const objCidades = [
{
	"Nome": "Afonso Cláudio",
	"uf": "ES"
}, {
	"Nome": "Água Doce do Norte",
	"uf": "ES"
}, {
	"Nome": "Águia Branca",
	"uf": "ES"
}, {
	"Nome": "Alegre",
	"uf": "ES"
}, {
	"Nome": "Alfredo Chaves",
	"uf": "ES"
}, {
	"Nome": "Alto Rio Novo",
	"uf": "ES"
}, {
	"Nome": "Anchieta",
	"uf": "ES"
}, {
	"Nome": "Apiacá",
	"uf": "ES"
}, {
	"Nome": "Aracruz",
	"uf": "ES"
}, {
	"Nome": "Atilio Vivacqua",
	"uf": "ES"
}, {
	"Nome": "Baixo Guandu",
	"uf": "ES"
}, {
	"Nome": "Barra de São Francisco",
	"uf": "ES"
}, {
	"Nome": "Boa Esperança",
	"uf": "ES"
}, {
	"Nome": "Bom Jesus do Norte",
	"uf": "ES"
}, {
	"Nome": "Brejetuba",
	"uf": "ES"
}, {
	"Nome": "Cachoeiro de Itapemirim",
	"uf": "ES"
}, {
	"Nome": "Cariacica",
	"uf": "ES"
}, {
	"Nome": "Castelo",
	"uf": "ES"
}, {
	"Nome": "Colatina",
	"uf": "ES"
}, {
	"Nome": "Conceição da Barra",
	"uf": "ES"
}, {
	"Nome": "Conceição do Castelo",
	"uf": "ES"
}, {
	"Nome": "Divino de São Lourenço",
	"uf": "ES"
}, {
	"Nome": "Domingos Martins",
	"uf": "ES"
}, {
	"Nome": "Dores do Rio Preto",
	"uf": "ES"
}, {
	"Nome": "Ecoporanga",
	"uf": "ES"
}, {
	"Nome": "Fundão",
	"uf": "ES"
}, {
	"Nome": "Governador Lindenberg",
	"uf": "ES"
}, {
	"Nome": "Guaçuí",
	"uf": "ES"
}, {
	"Nome": "Guarapari",
	"uf": "ES"
}, {
	"Nome": "Ibatiba",
	"uf": "ES"
}, {
	"Nome": "Ibiraçu",
	"uf": "ES"
}, {
	"Nome": "Ibitirama",
	"uf": "ES"
}, {
	"Nome": "Iconha",
	"uf": "ES"
}, {
	"Nome": "Irupi",
	"uf": "ES"
}, {
	"Nome": "Itaguaçu",
	"uf": "ES"
}, {
	"Nome": "Itapemirim",
	"uf": "ES"
}, {
	"Nome": "Itarana",
	"uf": "ES"
}, {
	"Nome": "Iúna",
	"uf": "ES"
}, {
	"Nome": "Jaguaré",
	"uf": "ES"
}, {
	"Nome": "Jerônimo Monteiro",
	"uf": "ES"
}, {
	"Nome": "João Neiva",
	"uf": "ES"
}, {
	"Nome": "Laranja da Terra",
	"uf": "ES"
}, {
	"Nome": "Linhares",
	"uf": "ES"
}, {
	"Nome": "Mantenópolis",
	"uf": "ES"
}, {
	"Nome": "Marataízes",
	"uf": "ES"
}, {
	"Nome": "Marechal Floriano",
	"uf": "ES"
}, {
	"Nome": "Marilândia",
	"uf": "ES"
}, {
	"Nome": "Mimoso do Sul",
	"uf": "ES"
}, {
	"Nome": "Montanha",
	"uf": "ES"
}, {
	"Nome": "Mucurici",
	"uf": "ES"
}, {
	"Nome": "Muniz Freire",
	"uf": "ES"
}, {
	"Nome": "Muqui",
	"uf": "ES"
}, {
	"Nome": "Nova Venécia",
	"uf": "ES"
}, {
	"Nome": "Pancas",
	"uf": "ES"
}, {
	"Nome": "Pedro Canário",
	"uf": "ES"
}, {
	"Nome": "Pinheiros",
	"uf": "ES"
}, {
	"Nome": "Piúma",
	"uf": "ES"
}, {
	"Nome": "Ponto Belo",
	"uf": "ES"
}, {
	"Nome": "Presidente Kennedy",
	"uf": "ES"
}, {
	"Nome": "Rio Bananal",
	"uf": "ES"
}, {
	"Nome": "Rio Novo do Sul",
	"uf": "ES"
}, {
	"Nome": "Santa Leopoldina",
	"uf": "ES"
}, {
	"Nome": "Santa Maria de Jetibá",
	"uf": "ES"
}, {
	"Nome": "Santa Teresa",
	"uf": "ES"
}, {
	"Nome": "São Domingos do Norte",
	"uf": "ES"
}, {
	"Nome": "São Gabriel da Palha",
	"uf": "ES"
}, {
	"Nome": "São José do Calçado",
	"uf": "ES"
}, {
	"Nome": "São Mateus",
	"uf": "ES"
}, {
	"Nome": "São Roque do Canaã",
	"uf": "ES"
}, {
	"Nome": "Serra",
	"uf": "ES"
}, {
	"Nome": "Sooretama",
	"uf": "ES"
}, {
	"Nome": "Vargem Alta",
	"uf": "ES"
}, {
	"Nome": "Venda Nova do Imigrante",
	"uf": "ES"
}, {
	"Nome": "Viana",
	"uf": "ES"
}, {
	"Nome": "Vila Pavão",
	"uf": "ES"
}, {
	"Nome": "Vila Valério",
	"uf": "ES"
}, {
	"Nome": "Vila Velha",
	"uf": "ES"
}, {
	"Nome": "Vitória",
	"uf": "ES"
}, {
	"Nome": "Acrelândia",
	"uf": "AC"
}, {
	"Nome": "Assis Brasil",
	"uf": "AC"
}, {
	"Nome": "Brasiléia",
	"uf": "AC"
}, {
	"Nome": "Bujari",
	"uf": "AC"
}, {
	"Nome": "Capixaba",
	"uf": "AC"
}, {
	"Nome": "Cruzeiro do Sul",
	"uf": "AC"
}, {
	"Nome": "Epitaciolândia",
	"uf": "AC"
}, {
	"Nome": "Feijó",
	"uf": "AC"
}, {
	"Nome": "Jordão",
	"uf": "AC"
}, {
	"Nome": "Mâncio Lima",
	"uf": "AC"
}, {
	"Nome": "Manoel Urbano",
	"uf": "AC"
}, {
	"Nome": "Marechal Thaumaturgo",
	"uf": "AC"
}, {
	"Nome": "Plácido de Castro",
	"uf": "AC"
}, {
	"Nome": "Porto Acre",
	"uf": "AC"
}, {
	"Nome": "Porto Walter",
	"uf": "AC"
}, {
	"Nome": "Rio Branco",
	"uf": "AC"
}, {
	"Nome": "Rodrigues Alves",
	"uf": "AC"
}, {
	"Nome": "Santa Rosa do Purus",
	"uf": "AC"
}, {
	"Nome": "Sena Madureira",
	"uf": "AC"
}, {
	"Nome": "Senador Guiomard",
	"uf": "AC"
}, {
	"Nome": "Tarauacá",
	"uf": "AC"
}, {
	"Nome": "Xapuri",
	"uf": "AC"
}, {
	"Nome": "Água Branca",
	"uf": "AL"
}, {
	"Nome": "Anadia",
	"uf": "AL"
}, {
	"Nome": "Arapiraca",
	"uf": "AL"
}, {
	"Nome": "Atalaia",
	"uf": "AL"
}, {
	"Nome": "Barra de Santo Antônio",
	"uf": "AL"
}, {
	"Nome": "Barra de São Miguel",
	"uf": "AL"
}, {
	"Nome": "Batalha",
	"uf": "AL"
}, {
	"Nome": "Belém",
	"uf": "AL"
}, {
	"Nome": "Belo Monte",
	"uf": "AL"
}, {
	"Nome": "Boca da Mata",
	"uf": "AL"
}, {
	"Nome": "Branquinha",
	"uf": "AL"
}, {
	"Nome": "Cacimbinhas",
	"uf": "AL"
}, {
	"Nome": "Cajueiro",
	"uf": "AL"
}, {
	"Nome": "Campestre",
	"uf": "AL"
}, {
	"Nome": "Campo Alegre",
	"uf": "AL"
}, {
	"Nome": "Campo Grande",
	"uf": "AL"
}, {
	"Nome": "Canapi",
	"uf": "AL"
}, {
	"Nome": "Capela",
	"uf": "AL"
}, {
	"Nome": "Carneiros",
	"uf": "AL"
}, {
	"Nome": "Chã Preta",
	"uf": "AL"
}, {
	"Nome": "Coité do Nóia",
	"uf": "AL"
}, {
	"Nome": "Colônia Leopoldina",
	"uf": "AL"
}, {
	"Nome": "Coqueiro Seco",
	"uf": "AL"
}, {
	"Nome": "Coruripe",
	"uf": "AL"
}, {
	"Nome": "Craíbas",
	"uf": "AL"
}, {
	"Nome": "Delmiro Gouveia",
	"uf": "AL"
}, {
	"Nome": "Dois Riachos",
	"uf": "AL"
}, {
	"Nome": "Estrela de Alagoas",
	"uf": "AL"
}, {
	"Nome": "Feira Grande",
	"uf": "AL"
}, {
	"Nome": "Feliz Deserto",
	"uf": "AL"
}, {
	"Nome": "Flexeiras",
	"uf": "AL"
}, {
	"Nome": "Girau do Ponciano",
	"uf": "AL"
}, {
	"Nome": "Ibateguara",
	"uf": "AL"
}, {
	"Nome": "Igaci",
	"uf": "AL"
}, {
	"Nome": "Igreja Nova",
	"uf": "AL"
}, {
	"Nome": "Inhapi",
	"uf": "AL"
}, {
	"Nome": "Jacaré dos Homens",
	"uf": "AL"
}, {
	"Nome": "Jacuípe",
	"uf": "AL"
}, {
	"Nome": "Japaratinga",
	"uf": "AL"
}, {
	"Nome": "Jaramataia",
	"uf": "AL"
}, {
	"Nome": "Jequiá da Praia",
	"uf": "AL"
}, {
	"Nome": "Joaquim Gomes",
	"uf": "AL"
}, {
	"Nome": "Jundiá",
	"uf": "AL"
}, {
	"Nome": "Junqueiro",
	"uf": "AL"
}, {
	"Nome": "Lagoa da Canoa",
	"uf": "AL"
}, {
	"Nome": "Limoeiro de Anadia",
	"uf": "AL"
}, {
	"Nome": "Maceió",
	"uf": "AL"
}, {
	"Nome": "Major Isidoro",
	"uf": "AL"
}, {
	"Nome": "Mar Vermelho",
	"uf": "AL"
}, {
	"Nome": "Maragogi",
	"uf": "AL"
}, {
	"Nome": "Maravilha",
	"uf": "AL"
}, {
	"Nome": "Marechal Deodoro",
	"uf": "AL"
}, {
	"Nome": "Maribondo",
	"uf": "AL"
}, {
	"Nome": "Mata Grande",
	"uf": "AL"
}, {
	"Nome": "Matriz de Camaragibe",
	"uf": "AL"
}, {
	"Nome": "Messias",
	"uf": "AL"
}, {
	"Nome": "Minador do Negrão",
	"uf": "AL"
}, {
	"Nome": "Monteirópolis",
	"uf": "AL"
}, {
	"Nome": "Murici",
	"uf": "AL"
}, {
	"Nome": "Novo Lino",
	"uf": "AL"
}, {
	"Nome": "Olho d`Água das Flores",
	"uf": "AL"
}, {
	"Nome": "Olho d`Água do Casado",
	"uf": "AL"
}, {
	"Nome": "Olho d`Água Grande",
	"uf": "AL"
}, {
	"Nome": "Olivença",
	"uf": "AL"
}, {
	"Nome": "Ouro Branco",
	"uf": "AL"
}, {
	"Nome": "Palestina",
	"uf": "AL"
}, {
	"Nome": "Palmeira dos Índios",
	"uf": "AL"
}, {
	"Nome": "Pão de Açúcar",
	"uf": "AL"
}, {
	"Nome": "Pariconha",
	"uf": "AL"
}, {
	"Nome": "Paripueira",
	"uf": "AL"
}, {
	"Nome": "Passo de Camaragibe",
	"uf": "AL"
}, {
	"Nome": "Paulo Jacinto",
	"uf": "AL"
}, {
	"Nome": "Penedo",
	"uf": "AL"
}, {
	"Nome": "Piaçabuçu",
	"uf": "AL"
}, {
	"Nome": "Pilar",
	"uf": "AL"
}, {
	"Nome": "Pindoba",
	"uf": "AL"
}, {
	"Nome": "Piranhas",
	"uf": "AL"
}, {
	"Nome": "Poço das Trincheiras",
	"uf": "AL"
}, {
	"Nome": "Porto Calvo",
	"uf": "AL"
}, {
	"Nome": "Porto de Pedras",
	"uf": "AL"
}, {
	"Nome": "Porto Real do Colégio",
	"uf": "AL"
}, {
	"Nome": "Quebrangulo",
	"uf": "AL"
}, {
	"Nome": "Rio Largo",
	"uf": "AL"
}, {
	"Nome": "Roteiro",
	"uf": "AL"
}, {
	"Nome": "Santa Luzia do Norte",
	"uf": "AL"
}, {
	"Nome": "Santana do Ipanema",
	"uf": "AL"
}, {
	"Nome": "Santana do Mundaú",
	"uf": "AL"
}, {
	"Nome": "São Brás",
	"uf": "AL"
}, {
	"Nome": "São José da Laje",
	"uf": "AL"
}, {
	"Nome": "São José da Tapera",
	"uf": "AL"
}, {
	"Nome": "São Luís do Quitunde",
	"uf": "AL"
}, {
	"Nome": "São Miguel dos Campos",
	"uf": "AL"
}, {
	"Nome": "São Miguel dos Milagres",
	"uf": "AL"
}, {
	"Nome": "São Sebastião",
	"uf": "AL"
}, {
	"Nome": "Satuba",
	"uf": "AL"
}, {
	"Nome": "Senador Rui Palmeira",
	"uf": "AL"
}, {
	"Nome": "Tanque d`Arca",
	"uf": "AL"
}, {
	"Nome": "Taquarana",
	"uf": "AL"
}, {
	"Nome": "Teotônio Vilela",
	"uf": "AL"
}, {
	"Nome": "Traipu",
	"uf": "AL"
}, {
	"Nome": "União dos Palmares",
	"uf": "AL"
}, {
	"Nome": "Viçosa",
	"uf": "AL"
}, {
	"Nome": "Amapá",
	"uf": "AP"
}, {
	"Nome": "Calçoene",
	"uf": "AP"
}, {
	"Nome": "Cutias",
	"uf": "AP"
}, {
	"Nome": "Ferreira Gomes",
	"uf": "AP"
}, {
	"Nome": "Itaubal",
	"uf": "AP"
}, {
	"Nome": "Laranjal do Jari",
	"uf": "AP"
}, {
	"Nome": "Macapá",
	"uf": "AP"
}, {
	"Nome": "Mazagão",
	"uf": "AP"
}, {
	"Nome": "Oiapoque",
	"uf": "AP"
}, {
	"Nome": "Pedra Branca do Amaparí",
	"uf": "AP"
}, {
	"Nome": "Porto Grande",
	"uf": "AP"
}, {
	"Nome": "Pracuúba",
	"uf": "AP"
}, {
	"Nome": "Santana",
	"uf": "AP"
}, {
	"Nome": "Serra do Navio",
	"uf": "AP"
}, {
	"Nome": "Tartarugalzinho",
	"uf": "AP"
}, {
	"Nome": "Vitória do Jari",
	"uf": "AP"
}, {
	"Nome": "Alvarães",
	"uf": "AM"
}, {
	"Nome": "Amaturá",
	"uf": "AM"
}, {
	"Nome": "Anamã",
	"uf": "AM"
}, {
	"Nome": "Anori",
	"uf": "AM"
}, {
	"Nome": "Apuí",
	"uf": "AM"
}, {
	"Nome": "Atalaia do Norte",
	"uf": "AM"
}, {
	"Nome": "Autazes",
	"uf": "AM"
}, {
	"Nome": "Barcelos",
	"uf": "AM"
}, {
	"Nome": "Barreirinha",
	"uf": "AM"
}, {
	"Nome": "Benjamin Constant",
	"uf": "AM"
}, {
	"Nome": "Beruri",
	"uf": "AM"
}, {
	"Nome": "Boa Vista do Ramos",
	"uf": "AM"
}, {
	"Nome": "Boca do Acre",
	"uf": "AM"
}, {
	"Nome": "Borba",
	"uf": "AM"
}, {
	"Nome": "Caapiranga",
	"uf": "AM"
}, {
	"Nome": "Canutama",
	"uf": "AM"
}, {
	"Nome": "Carauari",
	"uf": "AM"
}, {
	"Nome": "Careiro",
	"uf": "AM"
}, {
	"Nome": "Careiro da Várzea",
	"uf": "AM"
}, {
	"Nome": "Coari",
	"uf": "AM"
}, {
	"Nome": "Codajás",
	"uf": "AM"
}, {
	"Nome": "Eirunepé",
	"uf": "AM"
}, {
	"Nome": "Envira",
	"uf": "AM"
}, {
	"Nome": "Fonte Boa",
	"uf": "AM"
}, {
	"Nome": "Guajará",
	"uf": "AM"
}, {
	"Nome": "Humaitá",
	"uf": "AM"
}, {
	"Nome": "Ipixuna",
	"uf": "AM"
}, {
	"Nome": "Iranduba",
	"uf": "AM"
}, {
	"Nome": "Itacoatiara",
	"uf": "AM"
}, {
	"Nome": "Itamarati",
	"uf": "AM"
}, {
	"Nome": "Itapiranga",
	"uf": "AM"
}, {
	"Nome": "Japurá",
	"uf": "AM"
}, {
	"Nome": "Juruá",
	"uf": "AM"
}, {
	"Nome": "Jutaí",
	"uf": "AM"
}, {
	"Nome": "Lábrea",
	"uf": "AM"
}, {
	"Nome": "Manacapuru",
	"uf": "AM"
}, {
	"Nome": "Manaquiri",
	"uf": "AM"
}, {
	"Nome": "Manaus",
	"uf": "AM"
}, {
	"Nome": "Manicoré",
	"uf": "AM"
}, {
	"Nome": "Maraã",
	"uf": "AM"
}, {
	"Nome": "Maués",
	"uf": "AM"
}, {
	"Nome": "Nhamundá",
	"uf": "AM"
}, {
	"Nome": "Nova Olinda do Norte",
	"uf": "AM"
}, {
	"Nome": "Novo Airão",
	"uf": "AM"
}, {
	"Nome": "Novo Aripuanã",
	"uf": "AM"
}, {
	"Nome": "Parintins",
	"uf": "AM"
}, {
	"Nome": "Pauini",
	"uf": "AM"
}, {
	"Nome": "Presidente Figueiredo",
	"uf": "AM"
}, {
	"Nome": "Rio Preto da Eva",
	"uf": "AM"
}, {
	"Nome": "Santa Isabel do Rio Negro",
	"uf": "AM"
}, {
	"Nome": "Santo Antônio do Içá",
	"uf": "AM"
}, {
	"Nome": "São Gabriel da Cachoeira",
	"uf": "AM"
}, {
	"Nome": "São Paulo de Olivença",
	"uf": "AM"
}, {
	"Nome": "São Sebastião do Uatumã",
	"uf": "AM"
}, {
	"Nome": "Silves",
	"uf": "AM"
}, {
	"Nome": "Tabatinga",
	"uf": "AM"
}, {
	"Nome": "Tapauá",
	"uf": "AM"
}, {
	"Nome": "Tefé",
	"uf": "AM"
}, {
	"Nome": "Tonantins",
	"uf": "AM"
}, {
	"Nome": "Uarini",
	"uf": "AM"
}, {
	"Nome": "Urucará",
	"uf": "AM"
}, {
	"Nome": "Urucurituba",
	"uf": "AM"
}, {
	"Nome": "Abaíra",
	"uf": "BA"
}, {
	"Nome": "Abaré",
	"uf": "BA"
}, {
	"Nome": "Acajutiba",
	"uf": "BA"
}, {
	"Nome": "Adustina",
	"uf": "BA"
}, {
	"Nome": "Água Fria",
	"uf": "BA"
}, {
	"Nome": "Aiquara",
	"uf": "BA"
}, {
	"Nome": "Alagoinhas",
	"uf": "BA"
}, {
	"Nome": "Alcobaça",
	"uf": "BA"
}, {
	"Nome": "Almadina",
	"uf": "BA"
}, {
	"Nome": "Amargosa",
	"uf": "BA"
}, {
	"Nome": "Amélia Rodrigues",
	"uf": "BA"
}, {
	"Nome": "América Dourada",
	"uf": "BA"
}, {
	"Nome": "Anagé",
	"uf": "BA"
}, {
	"Nome": "Andaraí",
	"uf": "BA"
}, {
	"Nome": "Andorinha",
	"uf": "BA"
}, {
	"Nome": "Angical",
	"uf": "BA"
}, {
	"Nome": "Anguera",
	"uf": "BA"
}, {
	"Nome": "Antas",
	"uf": "BA"
}, {
	"Nome": "Antônio Cardoso",
	"uf": "BA"
}, {
	"Nome": "Antônio Gonçalves",
	"uf": "BA"
}, {
	"Nome": "Aporá",
	"uf": "BA"
}, {
	"Nome": "Apuarema",
	"uf": "BA"
}, {
	"Nome": "Araças",
	"uf": "BA"
}, {
	"Nome": "Aracatu",
	"uf": "BA"
}, {
	"Nome": "Araci",
	"uf": "BA"
}, {
	"Nome": "Aramari",
	"uf": "BA"
}, {
	"Nome": "Arataca",
	"uf": "BA"
}, {
	"Nome": "Aratuípe",
	"uf": "BA"
}, {
	"Nome": "Aurelino Leal",
	"uf": "BA"
}, {
	"Nome": "Baianópolis",
	"uf": "BA"
}, {
	"Nome": "Baixa Grande",
	"uf": "BA"
}, {
	"Nome": "Banzaê",
	"uf": "BA"
}, {
	"Nome": "Barra",
	"uf": "BA"
}, {
	"Nome": "Barra da Estiva",
	"uf": "BA"
}, {
	"Nome": "Barra do Choça",
	"uf": "BA"
}, {
	"Nome": "Barra do Mendes",
	"uf": "BA"
}, {
	"Nome": "Barra do Rocha",
	"uf": "BA"
}, {
	"Nome": "Barreiras",
	"uf": "BA"
}, {
	"Nome": "Barro Alto",
	"uf": "BA"
}, {
	"Nome": "Barro Preto (antigo Gov. Lomanto Jr.)",
	"uf": "BA"
}, {
	"Nome": "Barrocas",
	"uf": "BA"
}, {
	"Nome": "Belmonte",
	"uf": "BA"
}, {
	"Nome": "Belo Campo",
	"uf": "BA"
}, {
	"Nome": "Biritinga",
	"uf": "BA"
}, {
	"Nome": "Boa Nova",
	"uf": "BA"
}, {
	"Nome": "Boa Vista do Tupim",
	"uf": "BA"
}, {
	"Nome": "Bom Jesus da Lapa",
	"uf": "BA"
}, {
	"Nome": "Bom Jesus da Serra",
	"uf": "BA"
}, {
	"Nome": "Boninal",
	"uf": "BA"
}, {
	"Nome": "Bonito",
	"uf": "BA"
}, {
	"Nome": "Boquira",
	"uf": "BA"
}, {
	"Nome": "Botuporã",
	"uf": "BA"
}, {
	"Nome": "Brejões",
	"uf": "BA"
}, {
	"Nome": "Brejolândia",
	"uf": "BA"
}, {
	"Nome": "Brotas de Macaúbas",
	"uf": "BA"
}, {
	"Nome": "Brumado",
	"uf": "BA"
}, {
	"Nome": "Buerarema",
	"uf": "BA"
}, {
	"Nome": "Buritirama",
	"uf": "BA"
}, {
	"Nome": "Caatiba",
	"uf": "BA"
}, {
	"Nome": "Cabaceiras do Paraguaçu",
	"uf": "BA"
}, {
	"Nome": "Cachoeira",
	"uf": "BA"
}, {
	"Nome": "Caculé",
	"uf": "BA"
}, {
	"Nome": "Caém",
	"uf": "BA"
}, {
	"Nome": "Caetanos",
	"uf": "BA"
}, {
	"Nome": "Caetité",
	"uf": "BA"
}, {
	"Nome": "Cafarnaum",
	"uf": "BA"
}, {
	"Nome": "Cairu",
	"uf": "BA"
}, {
	"Nome": "Caldeirão Grande",
	"uf": "BA"
}, {
	"Nome": "Camacan",
	"uf": "BA"
}, {
	"Nome": "Camaçari",
	"uf": "BA"
}, {
	"Nome": "Camamu",
	"uf": "BA"
}, {
	"Nome": "Campo Alegre de Lourdes",
	"uf": "BA"
}, {
	"Nome": "Campo Formoso",
	"uf": "BA"
}, {
	"Nome": "Canápolis",
	"uf": "BA"
}, {
	"Nome": "Canarana",
	"uf": "BA"
}, {
	"Nome": "Canavieiras",
	"uf": "BA"
}, {
	"Nome": "Candeal",
	"uf": "BA"
}, {
	"Nome": "Candeias",
	"uf": "BA"
}, {
	"Nome": "Candiba",
	"uf": "BA"
}, {
	"Nome": "Cândido Sales",
	"uf": "BA"
}, {
	"Nome": "Cansanção",
	"uf": "BA"
}, {
	"Nome": "Canudos",
	"uf": "BA"
}, {
	"Nome": "Capela do Alto Alegre",
	"uf": "BA"
}, {
	"Nome": "Capim Grosso",
	"uf": "BA"
}, {
	"Nome": "Caraíbas",
	"uf": "BA"
}, {
	"Nome": "Caravelas",
	"uf": "BA"
}, {
	"Nome": "Cardeal da Silva",
	"uf": "BA"
}, {
	"Nome": "Carinhanha",
	"uf": "BA"
}, {
	"Nome": "Casa Nova",
	"uf": "BA"
}, {
	"Nome": "Castro Alves",
	"uf": "BA"
}, {
	"Nome": "Catolândia",
	"uf": "BA"
}, {
	"Nome": "Catu",
	"uf": "BA"
}, {
	"Nome": "Caturama",
	"uf": "BA"
}, {
	"Nome": "Central",
	"uf": "BA"
}, {
	"Nome": "Chorrochó",
	"uf": "BA"
}, {
	"Nome": "Cícero Dantas",
	"uf": "BA"
}, {
	"Nome": "Cipó",
	"uf": "BA"
}, {
	"Nome": "Coaraci",
	"uf": "BA"
}, {
	"Nome": "Cocos",
	"uf": "BA"
}, {
	"Nome": "Conceição da Feira",
	"uf": "BA"
}, {
	"Nome": "Conceição do Almeida",
	"uf": "BA"
}, {
	"Nome": "Conceição do Coité",
	"uf": "BA"
}, {
	"Nome": "Conceição do Jacuípe",
	"uf": "BA"
}, {
	"Nome": "Conde",
	"uf": "BA"
}, {
	"Nome": "Condeúba",
	"uf": "BA"
}, {
	"Nome": "Contendas do Sincorá",
	"uf": "BA"
}, {
	"Nome": "Coração de Maria",
	"uf": "BA"
}, {
	"Nome": "Cordeiros",
	"uf": "BA"
}, {
	"Nome": "Coribe",
	"uf": "BA"
}, {
	"Nome": "Coronel João Sá",
	"uf": "BA"
}, {
	"Nome": "Correntina",
	"uf": "BA"
}, {
	"Nome": "Cotegipe",
	"uf": "BA"
}, {
	"Nome": "Cravolândia",
	"uf": "BA"
}, {
	"Nome": "Crisópolis",
	"uf": "BA"
}, {
	"Nome": "Cristópolis",
	"uf": "BA"
}, {
	"Nome": "Cruz das Almas",
	"uf": "BA"
}, {
	"Nome": "Curaçá",
	"uf": "BA"
}, {
	"Nome": "Dário Meira",
	"uf": "BA"
}, {
	"Nome": "Dias d`Ávila",
	"uf": "BA"
}, {
	"Nome": "Dom Basílio",
	"uf": "BA"
}, {
	"Nome": "Dom Macedo Costa",
	"uf": "BA"
}, {
	"Nome": "Elísio Medrado",
	"uf": "BA"
}, {
	"Nome": "Encruzilhada",
	"uf": "BA"
}, {
	"Nome": "Entre Rios",
	"uf": "BA"
}, {
	"Nome": "Érico Cardoso",
	"uf": "BA"
}, {
	"Nome": "Esplanada",
	"uf": "BA"
}, {
	"Nome": "Euclides da Cunha",
	"uf": "BA"
}, {
	"Nome": "Eunápolis",
	"uf": "BA"
}, {
	"Nome": "Fátima",
	"uf": "BA"
}, {
	"Nome": "Feira da Mata",
	"uf": "BA"
}, {
	"Nome": "Feira de Santana",
	"uf": "BA"
}, {
	"Nome": "Filadélfia",
	"uf": "BA"
}, {
	"Nome": "Firmino Alves",
	"uf": "BA"
}, {
	"Nome": "Floresta Azul",
	"uf": "BA"
}, {
	"Nome": "Formosa do Rio Preto",
	"uf": "BA"
}, {
	"Nome": "Gandu",
	"uf": "BA"
}, {
	"Nome": "Gavião",
	"uf": "BA"
}, {
	"Nome": "Gentio do Ouro",
	"uf": "BA"
}, {
	"Nome": "Glória",
	"uf": "BA"
}, {
	"Nome": "Gongogi",
	"uf": "BA"
}, {
	"Nome": "Governador Mangabeira",
	"uf": "BA"
}, {
	"Nome": "Guajeru",
	"uf": "BA"
}, {
	"Nome": "Guanambi",
	"uf": "BA"
}, {
	"Nome": "Guaratinga",
	"uf": "BA"
}, {
	"Nome": "Heliópolis",
	"uf": "BA"
}, {
	"Nome": "Iaçu",
	"uf": "BA"
}, {
	"Nome": "Ibiassucê",
	"uf": "BA"
}, {
	"Nome": "Ibicaraí",
	"uf": "BA"
}, {
	"Nome": "Ibicoara",
	"uf": "BA"
}, {
	"Nome": "Ibicuí",
	"uf": "BA"
}, {
	"Nome": "Ibipeba",
	"uf": "BA"
}, {
	"Nome": "Ibipitanga",
	"uf": "BA"
}, {
	"Nome": "Ibiquera",
	"uf": "BA"
}, {
	"Nome": "Ibirapitanga",
	"uf": "BA"
}, {
	"Nome": "Ibirapuã",
	"uf": "BA"
}, {
	"Nome": "Ibirataia",
	"uf": "BA"
}, {
	"Nome": "Ibitiara",
	"uf": "BA"
}, {
	"Nome": "Ibititá",
	"uf": "BA"
}, {
	"Nome": "Ibotirama",
	"uf": "BA"
}, {
	"Nome": "Ichu",
	"uf": "BA"
}, {
	"Nome": "Igaporã",
	"uf": "BA"
}, {
	"Nome": "Igrapiúna",
	"uf": "BA"
}, {
	"Nome": "Iguaí",
	"uf": "BA"
}, {
	"Nome": "Ilhéus",
	"uf": "BA"
}, {
	"Nome": "Inhambupe",
	"uf": "BA"
}, {
	"Nome": "Ipecaetá",
	"uf": "BA"
}, {
	"Nome": "Ipiaú",
	"uf": "BA"
}, {
	"Nome": "Ipirá",
	"uf": "BA"
}, {
	"Nome": "Ipupiara",
	"uf": "BA"
}, {
	"Nome": "Irajuba",
	"uf": "BA"
}, {
	"Nome": "Iramaia",
	"uf": "BA"
}, {
	"Nome": "Iraquara",
	"uf": "BA"
}, {
	"Nome": "Irará",
	"uf": "BA"
}, {
	"Nome": "Irecê",
	"uf": "BA"
}, {
	"Nome": "Itabela",
	"uf": "BA"
}, {
	"Nome": "Itaberaba",
	"uf": "BA"
}, {
	"Nome": "Itabuna",
	"uf": "BA"
}, {
	"Nome": "Itacaré",
	"uf": "BA"
}, {
	"Nome": "Itaeté",
	"uf": "BA"
}, {
	"Nome": "Itagi",
	"uf": "BA"
}, {
	"Nome": "Itagibá",
	"uf": "BA"
}, {
	"Nome": "Itagimirim",
	"uf": "BA"
}, {
	"Nome": "Itaguaçu da Bahia",
	"uf": "BA"
}, {
	"Nome": "Itaju do Colônia",
	"uf": "BA"
}, {
	"Nome": "Itajuípe",
	"uf": "BA"
}, {
	"Nome": "Itamaraju",
	"uf": "BA"
}, {
	"Nome": "Itamari",
	"uf": "BA"
}, {
	"Nome": "Itambé",
	"uf": "BA"
}, {
	"Nome": "Itanagra",
	"uf": "BA"
}, {
	"Nome": "Itanhém",
	"uf": "BA"
}, {
	"Nome": "Itaparica",
	"uf": "BA"
}, {
	"Nome": "Itapé",
	"uf": "BA"
}, {
	"Nome": "Itapebi",
	"uf": "BA"
}, {
	"Nome": "Itapetinga",
	"uf": "BA"
}, {
	"Nome": "Itapicuru",
	"uf": "BA"
}, {
	"Nome": "Itapitanga",
	"uf": "BA"
}, {
	"Nome": "Itaquara",
	"uf": "BA"
}, {
	"Nome": "Itarantim",
	"uf": "BA"
}, {
	"Nome": "Itatim",
	"uf": "BA"
}, {
	"Nome": "Itiruçu",
	"uf": "BA"
}, {
	"Nome": "Itiúba",
	"uf": "BA"
}, {
	"Nome": "Itororó",
	"uf": "BA"
}, {
	"Nome": "Ituaçu",
	"uf": "BA"
}, {
	"Nome": "Ituberá",
	"uf": "BA"
}, {
	"Nome": "Iuiú",
	"uf": "BA"
}, {
	"Nome": "Jaborandi",
	"uf": "BA"
}, {
	"Nome": "Jacaraci",
	"uf": "BA"
}, {
	"Nome": "Jacobina",
	"uf": "BA"
}, {
	"Nome": "Jaguaquara",
	"uf": "BA"
}, {
	"Nome": "Jaguarari",
	"uf": "BA"
}, {
	"Nome": "Jaguaripe",
	"uf": "BA"
}, {
	"Nome": "Jandaíra",
	"uf": "BA"
}, {
	"Nome": "Jequié",
	"uf": "BA"
}, {
	"Nome": "Jeremoabo",
	"uf": "BA"
}, {
	"Nome": "Jiquiriçá",
	"uf": "BA"
}, {
	"Nome": "Jitaúna",
	"uf": "BA"
}, {
	"Nome": "João Dourado",
	"uf": "BA"
}, {
	"Nome": "Juazeiro",
	"uf": "BA"
}, {
	"Nome": "Jucuruçu",
	"uf": "BA"
}, {
	"Nome": "Jussara",
	"uf": "BA"
}, {
	"Nome": "Jussari",
	"uf": "BA"
}, {
	"Nome": "Jussiape",
	"uf": "BA"
}, {
	"Nome": "Lafaiete Coutinho",
	"uf": "BA"
}, {
	"Nome": "Lagoa Real",
	"uf": "BA"
}, {
	"Nome": "Laje",
	"uf": "BA"
}, {
	"Nome": "Lajedão",
	"uf": "BA"
}, {
	"Nome": "Lajedinho",
	"uf": "BA"
}, {
	"Nome": "Lajedo do Tabocal",
	"uf": "BA"
}, {
	"Nome": "Lamarão",
	"uf": "BA"
}, {
	"Nome": "Lapão",
	"uf": "BA"
}, {
	"Nome": "Lauro de Freitas",
	"uf": "BA"
}, {
	"Nome": "Lençóis",
	"uf": "BA"
}, {
	"Nome": "Licínio de Almeida",
	"uf": "BA"
}, {
	"Nome": "Livramento de Nossa Senhora",
	"uf": "BA"
}, {
	"Nome": "Luís Eduardo Magalhães",
	"uf": "BA"
}, {
	"Nome": "Macajuba",
	"uf": "BA"
}, {
	"Nome": "Macarani",
	"uf": "BA"
}, {
	"Nome": "Macaúbas",
	"uf": "BA"
}, {
	"Nome": "Macururé",
	"uf": "BA"
}, {
	"Nome": "Madre de Deus",
	"uf": "BA"
}, {
	"Nome": "Maetinga",
	"uf": "BA"
}, {
	"Nome": "Maiquinique",
	"uf": "BA"
}, {
	"Nome": "Mairi",
	"uf": "BA"
}, {
	"Nome": "Malhada",
	"uf": "BA"
}, {
	"Nome": "Malhada de Pedras",
	"uf": "BA"
}, {
	"Nome": "Manoel Vitorino",
	"uf": "BA"
}, {
	"Nome": "Mansidão",
	"uf": "BA"
}, {
	"Nome": "Maracás",
	"uf": "BA"
}, {
	"Nome": "Maragogipe",
	"uf": "BA"
}, {
	"Nome": "Maraú",
	"uf": "BA"
}, {
	"Nome": "Marcionílio Souza",
	"uf": "BA"
}, {
	"Nome": "Mascote",
	"uf": "BA"
}, {
	"Nome": "Mata de São João",
	"uf": "BA"
}, {
	"Nome": "Matina",
	"uf": "BA"
}, {
	"Nome": "Medeiros Neto",
	"uf": "BA"
}, {
	"Nome": "Miguel Calmon",
	"uf": "BA"
}, {
	"Nome": "Milagres",
	"uf": "BA"
}, {
	"Nome": "Mirangaba",
	"uf": "BA"
}, {
	"Nome": "Mirante",
	"uf": "BA"
}, {
	"Nome": "Monte Santo",
	"uf": "BA"
}, {
	"Nome": "Morpará",
	"uf": "BA"
}, {
	"Nome": "Morro do Chapéu",
	"uf": "BA"
}, {
	"Nome": "Mortugaba",
	"uf": "BA"
}, {
	"Nome": "Mucugê",
	"uf": "BA"
}, {
	"Nome": "Mucuri",
	"uf": "BA"
}, {
	"Nome": "Mulungu do Morro",
	"uf": "BA"
}, {
	"Nome": "Mundo Novo",
	"uf": "BA"
}, {
	"Nome": "Muniz Ferreira",
	"uf": "BA"
}, {
	"Nome": "Muquém de São Francisco",
	"uf": "BA"
}, {
	"Nome": "Muritiba",
	"uf": "BA"
}, {
	"Nome": "Mutuípe",
	"uf": "BA"
}, {
	"Nome": "Nazaré",
	"uf": "BA"
}, {
	"Nome": "Nilo Peçanha",
	"uf": "BA"
}, {
	"Nome": "Nordestina",
	"uf": "BA"
}, {
	"Nome": "Nova Canaã",
	"uf": "BA"
}, {
	"Nome": "Nova Fátima",
	"uf": "BA"
}, {
	"Nome": "Nova Ibiá",
	"uf": "BA"
}, {
	"Nome": "Nova Itarana",
	"uf": "BA"
}, {
	"Nome": "Nova Redenção",
	"uf": "BA"
}, {
	"Nome": "Nova Soure",
	"uf": "BA"
}, {
	"Nome": "Nova Viçosa",
	"uf": "BA"
}, {
	"Nome": "Novo Horizonte",
	"uf": "BA"
}, {
	"Nome": "Novo Triunfo",
	"uf": "BA"
}, {
	"Nome": "Olindina",
	"uf": "BA"
}, {
	"Nome": "Oliveira dos Brejinhos",
	"uf": "BA"
}, {
	"Nome": "Ouriçangas",
	"uf": "BA"
}, {
	"Nome": "Ourolândia",
	"uf": "BA"
}, {
	"Nome": "Palmas de Monte Alto",
	"uf": "BA"
}, {
	"Nome": "Palmeiras",
	"uf": "BA"
}, {
	"Nome": "Paramirim",
	"uf": "BA"
}, {
	"Nome": "Paratinga",
	"uf": "BA"
}, {
	"Nome": "Paripiranga",
	"uf": "BA"
}, {
	"Nome": "Pau Brasil",
	"uf": "BA"
}, {
	"Nome": "Paulo Afonso",
	"uf": "BA"
}, {
	"Nome": "Pé de Serra",
	"uf": "BA"
}, {
	"Nome": "Pedrão",
	"uf": "BA"
}, {
	"Nome": "Pedro Alexandre",
	"uf": "BA"
}, {
	"Nome": "Piatã",
	"uf": "BA"
}, {
	"Nome": "Pilão Arcado",
	"uf": "BA"
}, {
	"Nome": "Pindaí",
	"uf": "BA"
}, {
	"Nome": "Pindobaçu",
	"uf": "BA"
}, {
	"Nome": "Pintadas",
	"uf": "BA"
}, {
	"Nome": "Piraí do Norte",
	"uf": "BA"
}, {
	"Nome": "Piripá",
	"uf": "BA"
}, {
	"Nome": "Piritiba",
	"uf": "BA"
}, {
	"Nome": "Planaltino",
	"uf": "BA"
}, {
	"Nome": "Planalto",
	"uf": "BA"
}, {
	"Nome": "Poções",
	"uf": "BA"
}, {
	"Nome": "Pojuca",
	"uf": "BA"
}, {
	"Nome": "Ponto Novo",
	"uf": "BA"
}, {
	"Nome": "Porto Seguro",
	"uf": "BA"
}, {
	"Nome": "Potiraguá",
	"uf": "BA"
}, {
	"Nome": "Prado",
	"uf": "BA"
}, {
	"Nome": "Presidente Dutra",
	"uf": "BA"
}, {
	"Nome": "Presidente Jânio Quadros",
	"uf": "BA"
}, {
	"Nome": "Presidente Tancredo Neves",
	"uf": "BA"
}, {
	"Nome": "Queimadas",
	"uf": "BA"
}, {
	"Nome": "Quijingue",
	"uf": "BA"
}, {
	"Nome": "Quixabeira",
	"uf": "BA"
}, {
	"Nome": "Rafael Jambeiro",
	"uf": "BA"
}, {
	"Nome": "Remanso",
	"uf": "BA"
}, {
	"Nome": "Retirolândia",
	"uf": "BA"
}, {
	"Nome": "Riachão das Neves",
	"uf": "BA"
}, {
	"Nome": "Riachão do Jacuípe",
	"uf": "BA"
}, {
	"Nome": "Riacho de Santana",
	"uf": "BA"
}, {
	"Nome": "Ribeira do Amparo",
	"uf": "BA"
}, {
	"Nome": "Ribeira do Pombal",
	"uf": "BA"
}, {
	"Nome": "Ribeirão do Largo",
	"uf": "BA"
}, {
	"Nome": "Rio de Contas",
	"uf": "BA"
}, {
	"Nome": "Rio do Antônio",
	"uf": "BA"
}, {
	"Nome": "Rio do Pires",
	"uf": "BA"
}, {
	"Nome": "Rio Real",
	"uf": "BA"
}, {
	"Nome": "Rodelas",
	"uf": "BA"
}, {
	"Nome": "Ruy Barbosa",
	"uf": "BA"
}, {
	"Nome": "Salinas da Margarida",
	"uf": "BA"
}, {
	"Nome": "Salvador",
	"uf": "BA"
}, {
	"Nome": "Santa Bárbara",
	"uf": "BA"
}, {
	"Nome": "Santa Brígida",
	"uf": "BA"
}, {
	"Nome": "Santa Cruz Cabrália",
	"uf": "BA"
}, {
	"Nome": "Santa Cruz da Vitória",
	"uf": "BA"
}, {
	"Nome": "Santa Inês",
	"uf": "BA"
}, {
	"Nome": "Santa Luzia",
	"uf": "BA"
}, {
	"Nome": "Santa Maria da Vitória",
	"uf": "BA"
}, {
	"Nome": "Santa Rita de Cássia",
	"uf": "BA"
}, {
	"Nome": "Santa Teresinha",
	"uf": "BA"
}, {
	"Nome": "Santaluz",
	"uf": "BA"
}, {
	"Nome": "Santana",
	"uf": "BA"
}, {
	"Nome": "Santanópolis",
	"uf": "BA"
}, {
	"Nome": "Santo Amaro",
	"uf": "BA"
}, {
	"Nome": "Santo Antônio de Jesus",
	"uf": "BA"
}, {
	"Nome": "Santo Estêvão",
	"uf": "BA"
}, {
	"Nome": "São Desidério",
	"uf": "BA"
}, {
	"Nome": "São Domingos",
	"uf": "BA"
}, {
	"Nome": "São Felipe",
	"uf": "BA"
}, {
	"Nome": "São Félix",
	"uf": "BA"
}, {
	"Nome": "São Félix do Coribe",
	"uf": "BA"
}, {
	"Nome": "São Francisco do Conde",
	"uf": "BA"
}, {
	"Nome": "São Gabriel",
	"uf": "BA"
}, {
	"Nome": "São Gonçalo dos Campos",
	"uf": "BA"
}, {
	"Nome": "São José da Vitória",
	"uf": "BA"
}, {
	"Nome": "São José do Jacuípe",
	"uf": "BA"
}, {
	"Nome": "São Miguel das Matas",
	"uf": "BA"
}, {
	"Nome": "São Sebastião do Passé",
	"uf": "BA"
}, {
	"Nome": "Sapeaçu",
	"uf": "BA"
}, {
	"Nome": "Sátiro Dias",
	"uf": "BA"
}, {
	"Nome": "Saubara",
	"uf": "BA"
}, {
	"Nome": "Saúde",
	"uf": "BA"
}, {
	"Nome": "Seabra",
	"uf": "BA"
}, {
	"Nome": "Sebastião Laranjeiras",
	"uf": "BA"
}, {
	"Nome": "Senhor do Bonfim",
	"uf": "BA"
}, {
	"Nome": "Sento Sé",
	"uf": "BA"
}, {
	"Nome": "Serra do Ramalho",
	"uf": "BA"
}, {
	"Nome": "Serra Dourada",
	"uf": "BA"
}, {
	"Nome": "Serra Preta",
	"uf": "BA"
}, {
	"Nome": "Serrinha",
	"uf": "BA"
}, {
	"Nome": "Serrolândia",
	"uf": "BA"
}, {
	"Nome": "Simões Filho",
	"uf": "BA"
}, {
	"Nome": "Sítio do Mato",
	"uf": "BA"
}, {
	"Nome": "Sítio do Quinto",
	"uf": "BA"
}, {
	"Nome": "Sobradinho",
	"uf": "BA"
}, {
	"Nome": "Souto Soares",
	"uf": "BA"
}, {
	"Nome": "Tabocas do Brejo Velho",
	"uf": "BA"
}, {
	"Nome": "Tanhaçu",
	"uf": "BA"
}, {
	"Nome": "Tanque Novo",
	"uf": "BA"
}, {
	"Nome": "Tanquinho",
	"uf": "BA"
}, {
	"Nome": "Taperoá",
	"uf": "BA"
}, {
	"Nome": "Tapiramutá",
	"uf": "BA"
}, {
	"Nome": "Teixeira de Freitas",
	"uf": "BA"
}, {
	"Nome": "Teodoro Sampaio",
	"uf": "BA"
}, {
	"Nome": "Teofilândia",
	"uf": "BA"
}, {
	"Nome": "Teolândia",
	"uf": "BA"
}, {
	"Nome": "Terra Nova",
	"uf": "BA"
}, {
	"Nome": "Tremedal",
	"uf": "BA"
}, {
	"Nome": "Tucano",
	"uf": "BA"
}, {
	"Nome": "Uauá",
	"uf": "BA"
}, {
	"Nome": "Ubaíra",
	"uf": "BA"
}, {
	"Nome": "Ubaitaba",
	"uf": "BA"
}, {
	"Nome": "Ubatã",
	"uf": "BA"
}, {
	"Nome": "Uibaí",
	"uf": "BA"
}, {
	"Nome": "Umburanas",
	"uf": "BA"
}, {
	"Nome": "Una",
	"uf": "BA"
}, {
	"Nome": "Urandi",
	"uf": "BA"
}, {
	"Nome": "Uruçuca",
	"uf": "BA"
}, {
	"Nome": "Utinga",
	"uf": "BA"
}, {
	"Nome": "Valença",
	"uf": "BA"
}, {
	"Nome": "Valente",
	"uf": "BA"
}, {
	"Nome": "Várzea da Roça",
	"uf": "BA"
}, {
	"Nome": "Várzea do Poço",
	"uf": "BA"
}, {
	"Nome": "Várzea Nova",
	"uf": "BA"
}, {
	"Nome": "Varzedo",
	"uf": "BA"
}, {
	"Nome": "Vera Cruz",
	"uf": "BA"
}, {
	"Nome": "Vereda",
	"uf": "BA"
}, {
	"Nome": "Vitória da Conquista",
	"uf": "BA"
}, {
	"Nome": "Wagner",
	"uf": "BA"
}, {
	"Nome": "Wanderley",
	"uf": "BA"
}, {
	"Nome": "Wenceslau Guimarães",
	"uf": "BA"
}, {
	"Nome": "Xique-Xique",
	"uf": "BA"
}, {
	"Nome": "Abaiara",
	"uf": "CE"
}, {
	"Nome": "Acarape",
	"uf": "CE"
}, {
	"Nome": "Acaraú",
	"uf": "CE"
}, {
	"Nome": "Acopiara",
	"uf": "CE"
}, {
	"Nome": "Aiuaba",
	"uf": "CE"
}, {
	"Nome": "Alcântaras",
	"uf": "CE"
}, {
	"Nome": "Altaneira",
	"uf": "CE"
}, {
	"Nome": "Alto Santo",
	"uf": "CE"
}, {
	"Nome": "Amontada",
	"uf": "CE"
}, {
	"Nome": "Antonina do Norte",
	"uf": "CE"
}, {
	"Nome": "Apuiarés",
	"uf": "CE"
}, {
	"Nome": "Aquiraz",
	"uf": "CE"
}, {
	"Nome": "Aracati",
	"uf": "CE"
}, {
	"Nome": "Aracoiaba",
	"uf": "CE"
}, {
	"Nome": "Ararendá",
	"uf": "CE"
}, {
	"Nome": "Araripe",
	"uf": "CE"
}, {
	"Nome": "Aratuba",
	"uf": "CE"
}, {
	"Nome": "Arneiroz",
	"uf": "CE"
}, {
	"Nome": "Assaré",
	"uf": "CE"
}, {
	"Nome": "Aurora",
	"uf": "CE"
}, {
	"Nome": "Baixio",
	"uf": "CE"
}, {
	"Nome": "Banabuiú",
	"uf": "CE"
}, {
	"Nome": "Barbalha",
	"uf": "CE"
}, {
	"Nome": "Barreira",
	"uf": "CE"
}, {
	"Nome": "Barro",
	"uf": "CE"
}, {
	"Nome": "Barroquinha",
	"uf": "CE"
}, {
	"Nome": "Baturité",
	"uf": "CE"
}, {
	"Nome": "Beberibe",
	"uf": "CE"
}, {
	"Nome": "Bela Cruz",
	"uf": "CE"
}, {
	"Nome": "Boa Viagem",
	"uf": "CE"
}, {
	"Nome": "Brejo Santo",
	"uf": "CE"
}, {
	"Nome": "Camocim",
	"uf": "CE"
}, {
	"Nome": "Campos Sales",
	"uf": "CE"
}, {
	"Nome": "Canindé",
	"uf": "CE"
}, {
	"Nome": "Capistrano",
	"uf": "CE"
}, {
	"Nome": "Caridade",
	"uf": "CE"
}, {
	"Nome": "Cariré",
	"uf": "CE"
}, {
	"Nome": "Caririaçu",
	"uf": "CE"
}, {
	"Nome": "Cariús",
	"uf": "CE"
}, {
	"Nome": "Carnaubal",
	"uf": "CE"
}, {
	"Nome": "Cascavel",
	"uf": "CE"
}, {
	"Nome": "Catarina",
	"uf": "CE"
}, {
	"Nome": "Catunda",
	"uf": "CE"
}, {
	"Nome": "Caucaia",
	"uf": "CE"
}, {
	"Nome": "Cedro",
	"uf": "CE"
}, {
	"Nome": "Chaval",
	"uf": "CE"
}, {
	"Nome": "Choró",
	"uf": "CE"
}, {
	"Nome": "Chorozinho",
	"uf": "CE"
}, {
	"Nome": "Coreaú",
	"uf": "CE"
}, {
	"Nome": "Crateús",
	"uf": "CE"
}, {
	"Nome": "Crato",
	"uf": "CE"
}, {
	"Nome": "Croatá",
	"uf": "CE"
}, {
	"Nome": "Cruz",
	"uf": "CE"
}, {
	"Nome": "Deputado Irapuan Pinheiro",
	"uf": "CE"
}, {
	"Nome": "Ererê",
	"uf": "CE"
}, {
	"Nome": "Eusébio",
	"uf": "CE"
}, {
	"Nome": "Farias Brito",
	"uf": "CE"
}, {
	"Nome": "Forquilha",
	"uf": "CE"
}, {
	"Nome": "Fortaleza",
	"uf": "CE"
}, {
	"Nome": "Fortim",
	"uf": "CE"
}, {
	"Nome": "Frecheirinha",
	"uf": "CE"
}, {
	"Nome": "General Sampaio",
	"uf": "CE"
}, {
	"Nome": "Graça",
	"uf": "CE"
}, {
	"Nome": "Granja",
	"uf": "CE"
}, {
	"Nome": "Granjeiro",
	"uf": "CE"
}, {
	"Nome": "Groaíras",
	"uf": "CE"
}, {
	"Nome": "Guaiúba",
	"uf": "CE"
}, {
	"Nome": "Guaraciaba do Norte",
	"uf": "CE"
}, {
	"Nome": "Guaramiranga",
	"uf": "CE"
}, {
	"Nome": "Hidrolândia",
	"uf": "CE"
}, {
	"Nome": "Horizonte",
	"uf": "CE"
}, {
	"Nome": "Ibaretama",
	"uf": "CE"
}, {
	"Nome": "Ibiapina",
	"uf": "CE"
}, {
	"Nome": "Ibicuitinga",
	"uf": "CE"
}, {
	"Nome": "Icapuí",
	"uf": "CE"
}, {
	"Nome": "Icó",
	"uf": "CE"
}, {
	"Nome": "Iguatu",
	"uf": "CE"
}, {
	"Nome": "Independência",
	"uf": "CE"
}, {
	"Nome": "Ipaporanga",
	"uf": "CE"
}, {
	"Nome": "Ipaumirim",
	"uf": "CE"
}, {
	"Nome": "Ipu",
	"uf": "CE"
}, {
	"Nome": "Ipueiras",
	"uf": "CE"
}, {
	"Nome": "Iracema",
	"uf": "CE"
}, {
	"Nome": "Irauçuba",
	"uf": "CE"
}, {
	"Nome": "Itaiçaba",
	"uf": "CE"
}, {
	"Nome": "Itaitinga",
	"uf": "CE"
}, {
	"Nome": "Itapagé",
	"uf": "CE"
}, {
	"Nome": "Itapipoca",
	"uf": "CE"
}, {
	"Nome": "Itapiúna",
	"uf": "CE"
}, {
	"Nome": "Itarema",
	"uf": "CE"
}, {
	"Nome": "Itatira",
	"uf": "CE"
}, {
	"Nome": "Jaguaretama",
	"uf": "CE"
}, {
	"Nome": "Jaguaribara",
	"uf": "CE"
}, {
	"Nome": "Jaguaribe",
	"uf": "CE"
}, {
	"Nome": "Jaguaruana",
	"uf": "CE"
}, {
	"Nome": "Jardim",
	"uf": "CE"
}, {
	"Nome": "Jati",
	"uf": "CE"
}, {
	"Nome": "Jijoca de Jericoacoara",
	"uf": "CE"
}, {
	"Nome": "Juazeiro do Norte",
	"uf": "CE"
}, {
	"Nome": "Jucás",
	"uf": "CE"
}, {
	"Nome": "Lavras da Mangabeira",
	"uf": "CE"
}, {
	"Nome": "Limoeiro do Norte",
	"uf": "CE"
}, {
	"Nome": "Madalena",
	"uf": "CE"
}, {
	"Nome": "Maracanaú",
	"uf": "CE"
}, {
	"Nome": "Maranguape",
	"uf": "CE"
}, {
	"Nome": "Marco",
	"uf": "CE"
}, {
	"Nome": "Martinópole",
	"uf": "CE"
}, {
	"Nome": "Massapê",
	"uf": "CE"
}, {
	"Nome": "Mauriti",
	"uf": "CE"
}, {
	"Nome": "Meruoca",
	"uf": "CE"
}, {
	"Nome": "Milagres",
	"uf": "CE"
}, {
	"Nome": "Milhã",
	"uf": "CE"
}, {
	"Nome": "Miraíma",
	"uf": "CE"
}, {
	"Nome": "Missão Velha",
	"uf": "CE"
}, {
	"Nome": "Mombaça",
	"uf": "CE"
}, {
	"Nome": "Monsenhor Tabosa",
	"uf": "CE"
}, {
	"Nome": "Morada Nova",
	"uf": "CE"
}, {
	"Nome": "Moraújo",
	"uf": "CE"
}, {
	"Nome": "Morrinhos",
	"uf": "CE"
}, {
	"Nome": "Mucambo",
	"uf": "CE"
}, {
	"Nome": "Mulungu",
	"uf": "CE"
}, {
	"Nome": "Nova Olinda",
	"uf": "CE"
}, {
	"Nome": "Nova Russas",
	"uf": "CE"
}, {
	"Nome": "Novo Oriente",
	"uf": "CE"
}, {
	"Nome": "Ocara",
	"uf": "CE"
}, {
	"Nome": "Orós",
	"uf": "CE"
}, {
	"Nome": "Pacajus",
	"uf": "CE"
}, {
	"Nome": "Pacatuba",
	"uf": "CE"
}, {
	"Nome": "Pacoti",
	"uf": "CE"
}, {
	"Nome": "Pacujá",
	"uf": "CE"
}, {
	"Nome": "Palhano",
	"uf": "CE"
}, {
	"Nome": "Palmácia",
	"uf": "CE"
}, {
	"Nome": "Paracuru",
	"uf": "CE"
}, {
	"Nome": "Paraipaba",
	"uf": "CE"
}, {
	"Nome": "Parambu",
	"uf": "CE"
}, {
	"Nome": "Paramoti",
	"uf": "CE"
}, {
	"Nome": "Pedra Branca",
	"uf": "CE"
}, {
	"Nome": "Penaforte",
	"uf": "CE"
}, {
	"Nome": "Pentecoste",
	"uf": "CE"
}, {
	"Nome": "Pereiro",
	"uf": "CE"
}, {
	"Nome": "Pindoretama",
	"uf": "CE"
}, {
	"Nome": "Piquet Carneiro",
	"uf": "CE"
}, {
	"Nome": "Pires Ferreira",
	"uf": "CE"
}, {
	"Nome": "Poranga",
	"uf": "CE"
}, {
	"Nome": "Porteiras",
	"uf": "CE"
}, {
	"Nome": "Potengi",
	"uf": "CE"
}, {
	"Nome": "Potiretama",
	"uf": "CE"
}, {
	"Nome": "Quiterianópolis",
	"uf": "CE"
}, {
	"Nome": "Quixadá",
	"uf": "CE"
}, {
	"Nome": "Quixelô",
	"uf": "CE"
}, {
	"Nome": "Quixeramobim",
	"uf": "CE"
}, {
	"Nome": "Quixeré",
	"uf": "CE"
}, {
	"Nome": "Redenção",
	"uf": "CE"
}, {
	"Nome": "Reriutaba",
	"uf": "CE"
}, {
	"Nome": "Russas",
	"uf": "CE"
}, {
	"Nome": "Saboeiro",
	"uf": "CE"
}, {
	"Nome": "Salitre",
	"uf": "CE"
}, {
	"Nome": "Santa Quitéria",
	"uf": "CE"
}, {
	"Nome": "Santana do Acaraú",
	"uf": "CE"
}, {
	"Nome": "Santana do Cariri",
	"uf": "CE"
}, {
	"Nome": "São Benedito",
	"uf": "CE"
}, {
	"Nome": "São Gonçalo do Amarante",
	"uf": "CE"
}, {
	"Nome": "São João do Jaguaribe",
	"uf": "CE"
}, {
	"Nome": "São Luís do Curu",
	"uf": "CE"
}, {
	"Nome": "Senador Pompeu",
	"uf": "CE"
}, {
	"Nome": "Senador Sá",
	"uf": "CE"
}, {
	"Nome": "Sobral",
	"uf": "CE"
}, {
	"Nome": "Solonópole",
	"uf": "CE"
}, {
	"Nome": "Tabuleiro do Norte",
	"uf": "CE"
}, {
	"Nome": "Tamboril",
	"uf": "CE"
}, {
	"Nome": "Tarrafas",
	"uf": "CE"
}, {
	"Nome": "Tauá",
	"uf": "CE"
}, {
	"Nome": "Tejuçuoca",
	"uf": "CE"
}, {
	"Nome": "Tianguá",
	"uf": "CE"
}, {
	"Nome": "Trairi",
	"uf": "CE"
}, {
	"Nome": "Tururu",
	"uf": "CE"
}, {
	"Nome": "Ubajara",
	"uf": "CE"
}, {
	"Nome": "Umari",
	"uf": "CE"
}, {
	"Nome": "Umirim",
	"uf": "CE"
}, {
	"Nome": "Uruburetama",
	"uf": "CE"
}, {
	"Nome": "Uruoca",
	"uf": "CE"
}, {
	"Nome": "Varjota",
	"uf": "CE"
}, {
	"Nome": "Várzea Alegre",
	"uf": "CE"
}, {
	"Nome": "Viçosa do Ceará",
	"uf": "CE"
}, {
	"Nome": "Brasília",
	"uf": "DF"
}, {
	"Nome": "Abadia de Goiás",
	"uf": "GO"
}, {
	"Nome": "Abadiânia",
	"uf": "GO"
}, {
	"Nome": "Acreúna",
	"uf": "GO"
}, {
	"Nome": "Adelândia",
	"uf": "GO"
}, {
	"Nome": "Água Fria de Goiás",
	"uf": "GO"
}, {
	"Nome": "Água Limpa",
	"uf": "GO"
}, {
	"Nome": "Águas Lindas de Goiás",
	"uf": "GO"
}, {
	"Nome": "Alexânia",
	"uf": "GO"
}, {
	"Nome": "Aloândia",
	"uf": "GO"
}, {
	"Nome": "Alto Horizonte",
	"uf": "GO"
}, {
	"Nome": "Alto Paraíso de Goiás",
	"uf": "GO"
}, {
	"Nome": "Alvorada do Norte",
	"uf": "GO"
}, {
	"Nome": "Amaralina",
	"uf": "GO"
}, {
	"Nome": "Americano do Brasil",
	"uf": "GO"
}, {
	"Nome": "Amorinópolis",
	"uf": "GO"
}, {
	"Nome": "Anápolis",
	"uf": "GO"
}, {
	"Nome": "Anhanguera",
	"uf": "GO"
}, {
	"Nome": "Anicuns",
	"uf": "GO"
}, {
	"Nome": "Aparecida de Goiânia",
	"uf": "GO"
}, {
	"Nome": "Aparecida do Rio Doce",
	"uf": "GO"
}, {
	"Nome": "Aporé",
	"uf": "GO"
}, {
	"Nome": "Araçu",
	"uf": "GO"
}, {
	"Nome": "Aragarças",
	"uf": "GO"
}, {
	"Nome": "Aragoiânia",
	"uf": "GO"
}, {
	"Nome": "Araguapaz",
	"uf": "GO"
}, {
	"Nome": "Arenópolis",
	"uf": "GO"
}, {
	"Nome": "Aruanã",
	"uf": "GO"
}, {
	"Nome": "Aurilândia",
	"uf": "GO"
}, {
	"Nome": "Avelinópolis",
	"uf": "GO"
}, {
	"Nome": "Baliza",
	"uf": "GO"
}, {
	"Nome": "Barro Alto",
	"uf": "GO"
}, {
	"Nome": "Bela Vista de Goiás",
	"uf": "GO"
}, {
	"Nome": "Bom Jardim de Goiás",
	"uf": "GO"
}, {
	"Nome": "Bom Jesus de Goiás",
	"uf": "GO"
}, {
	"Nome": "Bonfinópolis",
	"uf": "GO"
}, {
	"Nome": "Bonópolis",
	"uf": "GO"
}, {
	"Nome": "Brazabrantes",
	"uf": "GO"
}, {
	"Nome": "Britânia",
	"uf": "GO"
}, {
	"Nome": "Buriti Alegre",
	"uf": "GO"
}, {
	"Nome": "Buriti de Goiás",
	"uf": "GO"
}, {
	"Nome": "Buritinópolis",
	"uf": "GO"
}, {
	"Nome": "Cabeceiras",
	"uf": "GO"
}, {
	"Nome": "Cachoeira Alta",
	"uf": "GO"
}, {
	"Nome": "Cachoeira de Goiás",
	"uf": "GO"
}, {
	"Nome": "Cachoeira Dourada",
	"uf": "GO"
}, {
	"Nome": "Caçu",
	"uf": "GO"
}, {
	"Nome": "Caiapônia",
	"uf": "GO"
}, {
	"Nome": "Caldas Novas",
	"uf": "GO"
}, {
	"Nome": "Caldazinha",
	"uf": "GO"
}, {
	"Nome": "Campestre de Goiás",
	"uf": "GO"
}, {
	"Nome": "Campinaçu",
	"uf": "GO"
}, {
	"Nome": "Campinorte",
	"uf": "GO"
}, {
	"Nome": "Campo Alegre de Goiás",
	"uf": "GO"
}, {
	"Nome": "Campo Limpo de Goiás",
	"uf": "GO"
}, {
	"Nome": "Campos Belos",
	"uf": "GO"
}, {
	"Nome": "Campos Verdes",
	"uf": "GO"
}, {
	"Nome": "Carmo do Rio Verde",
	"uf": "GO"
}, {
	"Nome": "Castelândia",
	"uf": "GO"
}, {
	"Nome": "Catalão",
	"uf": "GO"
}, {
	"Nome": "Caturaí",
	"uf": "GO"
}, {
	"Nome": "Cavalcante",
	"uf": "GO"
}, {
	"Nome": "Ceres",
	"uf": "GO"
}, {
	"Nome": "Cezarina",
	"uf": "GO"
}, {
	"Nome": "Chapadão do Céu",
	"uf": "GO"
}, {
	"Nome": "Cidade Ocidental",
	"uf": "GO"
}, {
	"Nome": "Cocalzinho de Goiás",
	"uf": "GO"
}, {
	"Nome": "Colinas do Sul",
	"uf": "GO"
}, {
	"Nome": "Córrego do Ouro",
	"uf": "GO"
}, {
	"Nome": "Corumbá de Goiás",
	"uf": "GO"
}, {
	"Nome": "Corumbaíba",
	"uf": "GO"
}, {
	"Nome": "Cristalina",
	"uf": "GO"
}, {
	"Nome": "Cristianópolis",
	"uf": "GO"
}, {
	"Nome": "Crixás",
	"uf": "GO"
}, {
	"Nome": "Cromínia",
	"uf": "GO"
}, {
	"Nome": "Cumari",
	"uf": "GO"
}, {
	"Nome": "Damianópolis",
	"uf": "GO"
}, {
	"Nome": "Damolândia",
	"uf": "GO"
}, {
	"Nome": "Davinópolis",
	"uf": "GO"
}, {
	"Nome": "Diorama",
	"uf": "GO"
}, {
	"Nome": "Divinópolis de Goiás",
	"uf": "GO"
}, {
	"Nome": "Doverlândia",
	"uf": "GO"
}, {
	"Nome": "Edealina",
	"uf": "GO"
}, {
	"Nome": "Edéia",
	"uf": "GO"
}, {
	"Nome": "Estrela do Norte",
	"uf": "GO"
}, {
	"Nome": "Faina",
	"uf": "GO"
}, {
	"Nome": "Fazenda Nova",
	"uf": "GO"
}, {
	"Nome": "Firminópolis",
	"uf": "GO"
}, {
	"Nome": "Flores de Goiás",
	"uf": "GO"
}, {
	"Nome": "Formosa",
	"uf": "GO"
}, {
	"Nome": "Formoso",
	"uf": "GO"
}, {
	"Nome": "Gameleira de Goiás",
	"uf": "GO"
}, {
	"Nome": "Goianápolis",
	"uf": "GO"
}, {
	"Nome": "Goiandira",
	"uf": "GO"
}, {
	"Nome": "Goianésia",
	"uf": "GO"
}, {
	"Nome": "Goiânia",
	"uf": "GO"
}, {
	"Nome": "Goianira",
	"uf": "GO"
}, {
	"Nome": "Goiás",
	"uf": "GO"
}, {
	"Nome": "Goiatuba",
	"uf": "GO"
}, {
	"Nome": "Gouvelândia",
	"uf": "GO"
}, {
	"Nome": "Guapó",
	"uf": "GO"
}, {
	"Nome": "Guaraíta",
	"uf": "GO"
}, {
	"Nome": "Guarani de Goiás",
	"uf": "GO"
}, {
	"Nome": "Guarinos",
	"uf": "GO"
}, {
	"Nome": "Heitoraí",
	"uf": "GO"
}, {
	"Nome": "Hidrolândia",
	"uf": "GO"
}, {
	"Nome": "Hidrolina",
	"uf": "GO"
}, {
	"Nome": "Iaciara",
	"uf": "GO"
}, {
	"Nome": "Inaciolândia",
	"uf": "GO"
}, {
	"Nome": "Indiara",
	"uf": "GO"
}, {
	"Nome": "Inhumas",
	"uf": "GO"
}, {
	"Nome": "Ipameri",
	"uf": "GO"
}, {
	"Nome": "Ipiranga de Goiás",
	"uf": "GO"
}, {
	"Nome": "Iporá",
	"uf": "GO"
}, {
	"Nome": "Israelândia",
	"uf": "GO"
}, {
	"Nome": "Itaberaí",
	"uf": "GO"
}, {
	"Nome": "Itaguari",
	"uf": "GO"
}, {
	"Nome": "Itaguaru",
	"uf": "GO"
}, {
	"Nome": "Itajá",
	"uf": "GO"
}, {
	"Nome": "Itapaci",
	"uf": "GO"
}, {
	"Nome": "Itapirapuã",
	"uf": "GO"
}, {
	"Nome": "Itapuranga",
	"uf": "GO"
}, {
	"Nome": "Itarumã",
	"uf": "GO"
}, {
	"Nome": "Itauçu",
	"uf": "GO"
}, {
	"Nome": "Itumbiara",
	"uf": "GO"
}, {
	"Nome": "Ivolândia",
	"uf": "GO"
}, {
	"Nome": "Jandaia",
	"uf": "GO"
}, {
	"Nome": "Jaraguá",
	"uf": "GO"
}, {
	"Nome": "Jataí",
	"uf": "GO"
}, {
	"Nome": "Jaupaci",
	"uf": "GO"
}, {
	"Nome": "Jesúpolis",
	"uf": "GO"
}, {
	"Nome": "Joviânia",
	"uf": "GO"
}, {
	"Nome": "Jussara",
	"uf": "GO"
}, {
	"Nome": "Lagoa Santa",
	"uf": "GO"
}, {
	"Nome": "Leopoldo de Bulhões",
	"uf": "GO"
}, {
	"Nome": "Luziânia",
	"uf": "GO"
}, {
	"Nome": "Mairipotaba",
	"uf": "GO"
}, {
	"Nome": "Mambaí",
	"uf": "GO"
}, {
	"Nome": "Mara Rosa",
	"uf": "GO"
}, {
	"Nome": "Marzagão",
	"uf": "GO"
}, {
	"Nome": "Matrinchã",
	"uf": "GO"
}, {
	"Nome": "Maurilândia",
	"uf": "GO"
}, {
	"Nome": "Mimoso de Goiás",
	"uf": "GO"
}, {
	"Nome": "Minaçu",
	"uf": "GO"
}, {
	"Nome": "Mineiros",
	"uf": "GO"
}, {
	"Nome": "Moiporá",
	"uf": "GO"
}, {
	"Nome": "Monte Alegre de Goiás",
	"uf": "GO"
}, {
	"Nome": "Montes Claros de Goiás",
	"uf": "GO"
}, {
	"Nome": "Montividiu",
	"uf": "GO"
}, {
	"Nome": "Montividiu do Norte",
	"uf": "GO"
}, {
	"Nome": "Morrinhos",
	"uf": "GO"
}, {
	"Nome": "Morro Agudo de Goiás",
	"uf": "GO"
}, {
	"Nome": "Mossâmedes",
	"uf": "GO"
}, {
	"Nome": "Mozarlândia",
	"uf": "GO"
}, {
	"Nome": "Mundo Novo",
	"uf": "GO"
}, {
	"Nome": "Mutunópolis",
	"uf": "GO"
}, {
	"Nome": "Nazário",
	"uf": "GO"
}, {
	"Nome": "Nerópolis",
	"uf": "GO"
}, {
	"Nome": "Niquelândia",
	"uf": "GO"
}, {
	"Nome": "Nova América",
	"uf": "GO"
}, {
	"Nome": "Nova Aurora",
	"uf": "GO"
}, {
	"Nome": "Nova Crixás",
	"uf": "GO"
}, {
	"Nome": "Nova Glória",
	"uf": "GO"
}, {
	"Nome": "Nova Iguaçu de Goiás",
	"uf": "GO"
}, {
	"Nome": "Nova Roma",
	"uf": "GO"
}, {
	"Nome": "Nova Veneza",
	"uf": "GO"
}, {
	"Nome": "Novo Brasil",
	"uf": "GO"
}, {
	"Nome": "Novo Gama",
	"uf": "GO"
}, {
	"Nome": "Novo Planalto",
	"uf": "GO"
}, {
	"Nome": "Orizona",
	"uf": "GO"
}, {
	"Nome": "Ouro Verde de Goiás",
	"uf": "GO"
}, {
	"Nome": "Ouvidor",
	"uf": "GO"
}, {
	"Nome": "Padre Bernardo",
	"uf": "GO"
}, {
	"Nome": "Palestina de Goiás",
	"uf": "GO"
}, {
	"Nome": "Palmeiras de Goiás",
	"uf": "GO"
}, {
	"Nome": "Palmelo",
	"uf": "GO"
}, {
	"Nome": "Palminópolis",
	"uf": "GO"
}, {
	"Nome": "Panamá",
	"uf": "GO"
}, {
	"Nome": "Paranaiguara",
	"uf": "GO"
}, {
	"Nome": "Paraúna",
	"uf": "GO"
}, {
	"Nome": "Perolândia",
	"uf": "GO"
}, {
	"Nome": "Petrolina de Goiás",
	"uf": "GO"
}, {
	"Nome": "Pilar de Goiás",
	"uf": "GO"
}, {
	"Nome": "Piracanjuba",
	"uf": "GO"
}, {
	"Nome": "Piranhas",
	"uf": "GO"
}, {
	"Nome": "Pirenópolis",
	"uf": "GO"
}, {
	"Nome": "Pires do Rio",
	"uf": "GO"
}, {
	"Nome": "Planaltina",
	"uf": "GO"
}, {
	"Nome": "Pontalina",
	"uf": "GO"
}, {
	"Nome": "Porangatu",
	"uf": "GO"
}, {
	"Nome": "Porteirão",
	"uf": "GO"
}, {
	"Nome": "Portelândia",
	"uf": "GO"
}, {
	"Nome": "Posse",
	"uf": "GO"
}, {
	"Nome": "Professor Jamil",
	"uf": "GO"
}, {
	"Nome": "Quirinópolis",
	"uf": "GO"
}, {
	"Nome": "Rialma",
	"uf": "GO"
}, {
	"Nome": "Rianápolis",
	"uf": "GO"
}, {
	"Nome": "Rio Quente",
	"uf": "GO"
}, {
	"Nome": "Rio Verde",
	"uf": "GO"
}, {
	"Nome": "Rubiataba",
	"uf": "GO"
}, {
	"Nome": "Sanclerlândia",
	"uf": "GO"
}, {
	"Nome": "Santa Bárbara de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Cruz de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Fé de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Helena de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Isabel",
	"uf": "GO"
}, {
	"Nome": "Santa Rita do Araguaia",
	"uf": "GO"
}, {
	"Nome": "Santa Rita do Novo Destino",
	"uf": "GO"
}, {
	"Nome": "Santa Rosa de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Tereza de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santa Terezinha de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santo Antônio da Barra",
	"uf": "GO"
}, {
	"Nome": "Santo Antônio de Goiás",
	"uf": "GO"
}, {
	"Nome": "Santo Antônio do Descoberto",
	"uf": "GO"
}, {
	"Nome": "São Domingos",
	"uf": "GO"
}, {
	"Nome": "São Francisco de Goiás",
	"uf": "GO"
}, {
	"Nome": "São João d`Aliança",
	"uf": "GO"
}, {
	"Nome": "São João da Paraúna",
	"uf": "GO"
}, {
	"Nome": "São Luís de Montes Belos",
	"uf": "GO"
}, {
	"Nome": "São Luíz do Norte",
	"uf": "GO"
}, {
	"Nome": "São Miguel do Araguaia",
	"uf": "GO"
}, {
	"Nome": "São Miguel do Passa Quatro",
	"uf": "GO"
}, {
	"Nome": "São Patrício",
	"uf": "GO"
}, {
	"Nome": "São Simão",
	"uf": "GO"
}, {
	"Nome": "Senador Canedo",
	"uf": "GO"
}, {
	"Nome": "Serranópolis",
	"uf": "GO"
}, {
	"Nome": "Silvânia",
	"uf": "GO"
}, {
	"Nome": "Simolândia",
	"uf": "GO"
}, {
	"Nome": "Sítio d`Abadia",
	"uf": "GO"
}, {
	"Nome": "Taquaral de Goiás",
	"uf": "GO"
}, {
	"Nome": "Teresina de Goiás",
	"uf": "GO"
}, {
	"Nome": "Terezópolis de Goiás",
	"uf": "GO"
}, {
	"Nome": "Três Ranchos",
	"uf": "GO"
}, {
	"Nome": "Trindade",
	"uf": "GO"
}, {
	"Nome": "Trombas",
	"uf": "GO"
}, {
	"Nome": "Turvânia",
	"uf": "GO"
}, {
	"Nome": "Turvelândia",
	"uf": "GO"
}, {
	"Nome": "Uirapuru",
	"uf": "GO"
}, {
	"Nome": "Uruaçu",
	"uf": "GO"
}, {
	"Nome": "Uruana",
	"uf": "GO"
}, {
	"Nome": "Urutaí",
	"uf": "GO"
}, {
	"Nome": "Valparaíso de Goiás",
	"uf": "GO"
}, {
	"Nome": "Varjão",
	"uf": "GO"
}, {
	"Nome": "Vianópolis",
	"uf": "GO"
}, {
	"Nome": "Vicentinópolis",
	"uf": "GO"
}, {
	"Nome": "Vila Boa",
	"uf": "GO"
}, {
	"Nome": "Vila Propício",
	"uf": "GO"
}, {
	"Nome": "Açailândia",
	"uf": "MA"
}, {
	"Nome": "Afonso Cunha",
	"uf": "MA"
}, {
	"Nome": "Água Doce do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Alcântara",
	"uf": "MA"
}, {
	"Nome": "Aldeias Altas",
	"uf": "MA"
}, {
	"Nome": "Altamira do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Alto Alegre do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Alto Alegre do Pindaré",
	"uf": "MA"
}, {
	"Nome": "Alto Parnaíba",
	"uf": "MA"
}, {
	"Nome": "Amapá do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Amarante do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Anajatuba",
	"uf": "MA"
}, {
	"Nome": "Anapurus",
	"uf": "MA"
}, {
	"Nome": "Apicum-Açu",
	"uf": "MA"
}, {
	"Nome": "Araguanã",
	"uf": "MA"
}, {
	"Nome": "Araioses",
	"uf": "MA"
}, {
	"Nome": "Arame",
	"uf": "MA"
}, {
	"Nome": "Arari",
	"uf": "MA"
}, {
	"Nome": "Axixá",
	"uf": "MA"
}, {
	"Nome": "Bacabal",
	"uf": "MA"
}, {
	"Nome": "Bacabeira",
	"uf": "MA"
}, {
	"Nome": "Bacuri",
	"uf": "MA"
}, {
	"Nome": "Bacurituba",
	"uf": "MA"
}, {
	"Nome": "Balsas",
	"uf": "MA"
}, {
	"Nome": "Barão de Grajaú",
	"uf": "MA"
}, {
	"Nome": "Barra do Corda",
	"uf": "MA"
}, {
	"Nome": "Barreirinhas",
	"uf": "MA"
}, {
	"Nome": "Bela Vista do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Belágua",
	"uf": "MA"
}, {
	"Nome": "Benedito Leite",
	"uf": "MA"
}, {
	"Nome": "Bequimão",
	"uf": "MA"
}, {
	"Nome": "Bernardo do Mearim",
	"uf": "MA"
}, {
	"Nome": "Boa Vista do Gurupi",
	"uf": "MA"
}, {
	"Nome": "Bom Jardim",
	"uf": "MA"
}, {
	"Nome": "Bom Jesus das Selvas",
	"uf": "MA"
}, {
	"Nome": "Bom Lugar",
	"uf": "MA"
}, {
	"Nome": "Brejo",
	"uf": "MA"
}, {
	"Nome": "Brejo de Areia",
	"uf": "MA"
}, {
	"Nome": "Buriti",
	"uf": "MA"
}, {
	"Nome": "Buriti Bravo",
	"uf": "MA"
}, {
	"Nome": "Buriticupu",
	"uf": "MA"
}, {
	"Nome": "Buritirana",
	"uf": "MA"
}, {
	"Nome": "Cachoeira Grande",
	"uf": "MA"
}, {
	"Nome": "Cajapió",
	"uf": "MA"
}, {
	"Nome": "Cajari",
	"uf": "MA"
}, {
	"Nome": "Campestre do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Cândido Mendes",
	"uf": "MA"
}, {
	"Nome": "Cantanhede",
	"uf": "MA"
}, {
	"Nome": "Capinzal do Norte",
	"uf": "MA"
}, {
	"Nome": "Carolina",
	"uf": "MA"
}, {
	"Nome": "Carutapera",
	"uf": "MA"
}, {
	"Nome": "Caxias",
	"uf": "MA"
}, {
	"Nome": "Cedral",
	"uf": "MA"
}, {
	"Nome": "Central do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Centro do Guilherme",
	"uf": "MA"
}, {
	"Nome": "Centro Novo do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Chapadinha",
	"uf": "MA"
}, {
	"Nome": "Cidelândia",
	"uf": "MA"
}, {
	"Nome": "Codó",
	"uf": "MA"
}, {
	"Nome": "Coelho Neto",
	"uf": "MA"
}, {
	"Nome": "Colinas",
	"uf": "MA"
}, {
	"Nome": "Conceição do Lago-Açu",
	"uf": "MA"
}, {
	"Nome": "Coroatá",
	"uf": "MA"
}, {
	"Nome": "Cururupu",
	"uf": "MA"
}, {
	"Nome": "Davinópolis",
	"uf": "MA"
}, {
	"Nome": "Dom Pedro",
	"uf": "MA"
}, {
	"Nome": "Duque Bacelar",
	"uf": "MA"
}, {
	"Nome": "Esperantinópolis",
	"uf": "MA"
}, {
	"Nome": "Estreito",
	"uf": "MA"
}, {
	"Nome": "Feira Nova do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Fernando Falcão",
	"uf": "MA"
}, {
	"Nome": "Formosa da Serra Negra",
	"uf": "MA"
}, {
	"Nome": "Fortaleza dos Nogueiras",
	"uf": "MA"
}, {
	"Nome": "Fortuna",
	"uf": "MA"
}, {
	"Nome": "Godofredo Viana",
	"uf": "MA"
}, {
	"Nome": "Gonçalves Dias",
	"uf": "MA"
}, {
	"Nome": "Governador Archer",
	"uf": "MA"
}, {
	"Nome": "Governador Edison Lobão",
	"uf": "MA"
}, {
	"Nome": "Governador Eugênio Barros",
	"uf": "MA"
}, {
	"Nome": "Governador Luiz Rocha",
	"uf": "MA"
}, {
	"Nome": "Governador Newton Bello",
	"uf": "MA"
}, {
	"Nome": "Governador Nunes Freire",
	"uf": "MA"
}, {
	"Nome": "Graça Aranha",
	"uf": "MA"
}, {
	"Nome": "Grajaú",
	"uf": "MA"
}, {
	"Nome": "Guimarães",
	"uf": "MA"
}, {
	"Nome": "Humberto de Campos",
	"uf": "MA"
}, {
	"Nome": "Icatu",
	"uf": "MA"
}, {
	"Nome": "Igarapé do Meio",
	"uf": "MA"
}, {
	"Nome": "Igarapé Grande",
	"uf": "MA"
}, {
	"Nome": "Imperatriz",
	"uf": "MA"
}, {
	"Nome": "Itaipava do Grajaú",
	"uf": "MA"
}, {
	"Nome": "Itapecuru Mirim",
	"uf": "MA"
}, {
	"Nome": "Itinga do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Jatobá",
	"uf": "MA"
}, {
	"Nome": "Jenipapo dos Vieiras",
	"uf": "MA"
}, {
	"Nome": "João Lisboa",
	"uf": "MA"
}, {
	"Nome": "Joselândia",
	"uf": "MA"
}, {
	"Nome": "Junco do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Lago da Pedra",
	"uf": "MA"
}, {
	"Nome": "Lago do Junco",
	"uf": "MA"
}, {
	"Nome": "Lago dos Rodrigues",
	"uf": "MA"
}, {
	"Nome": "Lago Verde",
	"uf": "MA"
}, {
	"Nome": "Lagoa do Mato",
	"uf": "MA"
}, {
	"Nome": "Lagoa Grande do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Lajeado Novo",
	"uf": "MA"
}, {
	"Nome": "Lima Campos",
	"uf": "MA"
}, {
	"Nome": "Loreto",
	"uf": "MA"
}, {
	"Nome": "Luís Domingues",
	"uf": "MA"
}, {
	"Nome": "Magalhães de Almeida",
	"uf": "MA"
}, {
	"Nome": "Maracaçumé",
	"uf": "MA"
}, {
	"Nome": "Marajá do Sena",
	"uf": "MA"
}, {
	"Nome": "Maranhãozinho",
	"uf": "MA"
}, {
	"Nome": "Mata Roma",
	"uf": "MA"
}, {
	"Nome": "Matinha",
	"uf": "MA"
}, {
	"Nome": "Matões",
	"uf": "MA"
}, {
	"Nome": "Matões do Norte",
	"uf": "MA"
}, {
	"Nome": "Milagres do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Mirador",
	"uf": "MA"
}, {
	"Nome": "Miranda do Norte",
	"uf": "MA"
}, {
	"Nome": "Mirinzal",
	"uf": "MA"
}, {
	"Nome": "Monção",
	"uf": "MA"
}, {
	"Nome": "Montes Altos",
	"uf": "MA"
}, {
	"Nome": "Morros",
	"uf": "MA"
}, {
	"Nome": "Nina Rodrigues",
	"uf": "MA"
}, {
	"Nome": "Nova Colinas",
	"uf": "MA"
}, {
	"Nome": "Nova Iorque",
	"uf": "MA"
}, {
	"Nome": "Nova Olinda do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Olho d`Água das Cunhãs",
	"uf": "MA"
}, {
	"Nome": "Olinda Nova do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Paço do Lumiar",
	"uf": "MA"
}, {
	"Nome": "Palmeirândia",
	"uf": "MA"
}, {
	"Nome": "Paraibano",
	"uf": "MA"
}, {
	"Nome": "Parnarama",
	"uf": "MA"
}, {
	"Nome": "Passagem Franca",
	"uf": "MA"
}, {
	"Nome": "Pastos Bons",
	"uf": "MA"
}, {
	"Nome": "Paulino Neves",
	"uf": "MA"
}, {
	"Nome": "Paulo Ramos",
	"uf": "MA"
}, {
	"Nome": "Pedreiras",
	"uf": "MA"
}, {
	"Nome": "Pedro do Rosário",
	"uf": "MA"
}, {
	"Nome": "Penalva",
	"uf": "MA"
}, {
	"Nome": "Peri Mirim",
	"uf": "MA"
}, {
	"Nome": "Peritoró",
	"uf": "MA"
}, {
	"Nome": "Pindaré-Mirim",
	"uf": "MA"
}, {
	"Nome": "Pinheiro",
	"uf": "MA"
}, {
	"Nome": "Pio XII",
	"uf": "MA"
}, {
	"Nome": "Pirapemas",
	"uf": "MA"
}, {
	"Nome": "Poção de Pedras",
	"uf": "MA"
}, {
	"Nome": "Porto Franco",
	"uf": "MA"
}, {
	"Nome": "Porto Rico do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Presidente Dutra",
	"uf": "MA"
}, {
	"Nome": "Presidente Juscelino",
	"uf": "MA"
}, {
	"Nome": "Presidente Médici",
	"uf": "MA"
}, {
	"Nome": "Presidente Sarney",
	"uf": "MA"
}, {
	"Nome": "Presidente Vargas",
	"uf": "MA"
}, {
	"Nome": "Primeira Cruz",
	"uf": "MA"
}, {
	"Nome": "Raposa",
	"uf": "MA"
}, {
	"Nome": "Riachão",
	"uf": "MA"
}, {
	"Nome": "Ribamar Fiquene",
	"uf": "MA"
}, {
	"Nome": "Rosário",
	"uf": "MA"
}, {
	"Nome": "Sambaíba",
	"uf": "MA"
}, {
	"Nome": "Santa Filomena do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Santa Helena",
	"uf": "MA"
}, {
	"Nome": "Santa Inês",
	"uf": "MA"
}, {
	"Nome": "Santa Luzia",
	"uf": "MA"
}, {
	"Nome": "Santa Luzia do Paruá",
	"uf": "MA"
}, {
	"Nome": "Santa Quitéria do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Santa Rita",
	"uf": "MA"
}, {
	"Nome": "Santana do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Santo Amaro do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Santo Antônio dos Lopes",
	"uf": "MA"
}, {
	"Nome": "São Benedito do Rio Preto",
	"uf": "MA"
}, {
	"Nome": "São Bento",
	"uf": "MA"
}, {
	"Nome": "São Bernardo",
	"uf": "MA"
}, {
	"Nome": "São Domingos do Azeitão",
	"uf": "MA"
}, {
	"Nome": "São Domingos do Maranhão",
	"uf": "MA"
}, {
	"Nome": "São Félix de Balsas",
	"uf": "MA"
}, {
	"Nome": "São Francisco do Brejão",
	"uf": "MA"
}, {
	"Nome": "São Francisco do Maranhão",
	"uf": "MA"
}, {
	"Nome": "São João Batista",
	"uf": "MA"
}, {
	"Nome": "São João do Carú",
	"uf": "MA"
}, {
	"Nome": "São João do Paraíso",
	"uf": "MA"
}, {
	"Nome": "São João do Soter",
	"uf": "MA"
}, {
	"Nome": "São João dos Patos",
	"uf": "MA"
}, {
	"Nome": "São José de Ribamar",
	"uf": "MA"
}, {
	"Nome": "São José dos Basílios",
	"uf": "MA"
}, {
	"Nome": "São Luís",
	"uf": "MA"
}, {
	"Nome": "São Luís Gonzaga do Maranhão",
	"uf": "MA"
}, {
	"Nome": "São Mateus do Maranhão",
	"uf": "MA"
}, {
	"Nome": "São Pedro da Água Branca",
	"uf": "MA"
}, {
	"Nome": "São Pedro dos Crentes",
	"uf": "MA"
}, {
	"Nome": "São Raimundo das Mangabeiras",
	"uf": "MA"
}, {
	"Nome": "São Raimundo do Doca Bezerra",
	"uf": "MA"
}, {
	"Nome": "São Roberto",
	"uf": "MA"
}, {
	"Nome": "São Vicente Ferrer",
	"uf": "MA"
}, {
	"Nome": "Satubinha",
	"uf": "MA"
}, {
	"Nome": "Senador Alexandre Costa",
	"uf": "MA"
}, {
	"Nome": "Senador La Rocque",
	"uf": "MA"
}, {
	"Nome": "Serrano do Maranhão",
	"uf": "MA"
}, {
	"Nome": "Sítio Novo",
	"uf": "MA"
}, {
	"Nome": "Sucupira do Norte",
	"uf": "MA"
}, {
	"Nome": "Sucupira do Riachão",
	"uf": "MA"
}, {
	"Nome": "Tasso Fragoso",
	"uf": "MA"
}, {
	"Nome": "Timbiras",
	"uf": "MA"
}, {
	"Nome": "Timon",
	"uf": "MA"
}, {
	"Nome": "Trizidela do Vale",
	"uf": "MA"
}, {
	"Nome": "Tufilândia",
	"uf": "MA"
}, {
	"Nome": "Tuntum",
	"uf": "MA"
}, {
	"Nome": "Turiaçu",
	"uf": "MA"
}, {
	"Nome": "Turilândia",
	"uf": "MA"
}, {
	"Nome": "Tutóia",
	"uf": "MA"
}, {
	"Nome": "Urbano Santos",
	"uf": "MA"
}, {
	"Nome": "Vargem Grande",
	"uf": "MA"
}, {
	"Nome": "Viana",
	"uf": "MA"
}, {
	"Nome": "Vila Nova dos Martírios",
	"uf": "MA"
}, {
	"Nome": "Vitória do Mearim",
	"uf": "MA"
}, {
	"Nome": "Vitorino Freire",
	"uf": "MA"
}, {
	"Nome": "Zé Doca",
	"uf": "MA"
}, {
	"Nome": "Acorizal",
	"uf": "MT"
}, {
	"Nome": "Água Boa",
	"uf": "MT"
}, {
	"Nome": "Alta Floresta",
	"uf": "MT"
}, {
	"Nome": "Alto Araguaia",
	"uf": "MT"
}, {
	"Nome": "Alto Boa Vista",
	"uf": "MT"
}, {
	"Nome": "Alto Garças",
	"uf": "MT"
}, {
	"Nome": "Alto Paraguai",
	"uf": "MT"
}, {
	"Nome": "Alto Taquari",
	"uf": "MT"
}, {
	"Nome": "Apiacás",
	"uf": "MT"
}, {
	"Nome": "Araguaiana",
	"uf": "MT"
}, {
	"Nome": "Araguainha",
	"uf": "MT"
}, {
	"Nome": "Araputanga",
	"uf": "MT"
}, {
	"Nome": "Arenápolis",
	"uf": "MT"
}, {
	"Nome": "Aripuanã",
	"uf": "MT"
}, {
	"Nome": "Barão de Melgaço",
	"uf": "MT"
}, {
	"Nome": "Barra do Bugres",
	"uf": "MT"
}, {
	"Nome": "Barra do Garças",
	"uf": "MT"
}, {
	"Nome": "Bom Jesus do Araguaia",
	"uf": "MT"
}, {
	"Nome": "Brasnorte",
	"uf": "MT"
}, {
	"Nome": "Cáceres",
	"uf": "MT"
}, {
	"Nome": "Campinápolis",
	"uf": "MT"
}, {
	"Nome": "Campo Novo do Parecis",
	"uf": "MT"
}, {
	"Nome": "Campo Verde",
	"uf": "MT"
}, {
	"Nome": "Campos de Júlio",
	"uf": "MT"
}, {
	"Nome": "Canabrava do Norte",
	"uf": "MT"
}, {
	"Nome": "Canarana",
	"uf": "MT"
}, {
	"Nome": "Carlinda",
	"uf": "MT"
}, {
	"Nome": "Castanheira",
	"uf": "MT"
}, {
	"Nome": "Chapada dos Guimarães",
	"uf": "MT"
}, {
	"Nome": "Cláudia",
	"uf": "MT"
}, {
	"Nome": "Cocalinho",
	"uf": "MT"
}, {
	"Nome": "Colíder",
	"uf": "MT"
}, {
	"Nome": "Colniza",
	"uf": "MT"
}, {
	"Nome": "Comodoro",
	"uf": "MT"
}, {
	"Nome": "Confresa",
	"uf": "MT"
}, {
	"Nome": "Conquista d`Oeste",
	"uf": "MT"
}, {
	"Nome": "Cotriguaçu",
	"uf": "MT"
}, {
	"Nome": "Cuiabá",
	"uf": "MT"
}, {
	"Nome": "Curvelândia",
	"uf": "MT"
}, {
	"Nome": "Denise",
	"uf": "MT"
}, {
	"Nome": "Diamantino",
	"uf": "MT"
}, {
	"Nome": "Dom Aquino",
	"uf": "MT"
}, {
	"Nome": "Feliz Natal",
	"uf": "MT"
}, {
	"Nome": "Figueirópolis d`Oeste",
	"uf": "MT"
}, {
	"Nome": "Gaúcha do Norte",
	"uf": "MT"
}, {
	"Nome": "General Carneiro",
	"uf": "MT"
}, {
	"Nome": "Glória d`Oeste",
	"uf": "MT"
}, {
	"Nome": "Guarantã do Norte",
	"uf": "MT"
}, {
	"Nome": "Guiratinga",
	"uf": "MT"
}, {
	"Nome": "Indiavaí",
	"uf": "MT"
}, {
	"Nome": "Ipiranga do Norte",
	"uf": "MT"
}, {
	"Nome": "Itanhangá",
	"uf": "MT"
}, {
	"Nome": "Itaúba",
	"uf": "MT"
}, {
	"Nome": "Itiquira",
	"uf": "MT"
}, {
	"Nome": "Jaciara",
	"uf": "MT"
}, {
	"Nome": "Jangada",
	"uf": "MT"
}, {
	"Nome": "Jauru",
	"uf": "MT"
}, {
	"Nome": "Juara",
	"uf": "MT"
}, {
	"Nome": "Juína",
	"uf": "MT"
}, {
	"Nome": "Juruena",
	"uf": "MT"
}, {
	"Nome": "Juscimeira",
	"uf": "MT"
}, {
	"Nome": "Lambari d`Oeste",
	"uf": "MT"
}, {
	"Nome": "Lucas do Rio Verde",
	"uf": "MT"
}, {
	"Nome": "Luciára",
	"uf": "MT"
}, {
	"Nome": "Marcelândia",
	"uf": "MT"
}, {
	"Nome": "Matupá",
	"uf": "MT"
}, {
	"Nome": "Mirassol d`Oeste",
	"uf": "MT"
}, {
	"Nome": "Nobres",
	"uf": "MT"
}, {
	"Nome": "Nortelândia",
	"uf": "MT"
}, {
	"Nome": "Nossa Senhora do Livramento",
	"uf": "MT"
}, {
	"Nome": "Nova Bandeirantes",
	"uf": "MT"
}, {
	"Nome": "Nova Brasilândia",
	"uf": "MT"
}, {
	"Nome": "Nova Canaã do Norte",
	"uf": "MT"
}, {
	"Nome": "Nova Guarita",
	"uf": "MT"
}, {
	"Nome": "Nova Lacerda",
	"uf": "MT"
}, {
	"Nome": "Nova Marilândia",
	"uf": "MT"
}, {
	"Nome": "Nova Maringá",
	"uf": "MT"
}, {
	"Nome": "Nova Monte verde",
	"uf": "MT"
}, {
	"Nome": "Nova Mutum",
	"uf": "MT"
}, {
	"Nome": "Nova Olímpia",
	"uf": "MT"
}, {
	"Nome": "Nova Santa Helena",
	"uf": "MT"
}, {
	"Nome": "Nova Ubiratã",
	"uf": "MT"
}, {
	"Nome": "Nova Xavantina",
	"uf": "MT"
}, {
	"Nome": "Novo Horizonte do Norte",
	"uf": "MT"
}, {
	"Nome": "Novo Mundo",
	"uf": "MT"
}, {
	"Nome": "Novo Santo Antônio",
	"uf": "MT"
}, {
	"Nome": "Novo São Joaquim",
	"uf": "MT"
}, {
	"Nome": "Paranaíta",
	"uf": "MT"
}, {
	"Nome": "Paranatinga",
	"uf": "MT"
}, {
	"Nome": "Pedra Preta",
	"uf": "MT"
}, {
	"Nome": "Peixoto de Azevedo",
	"uf": "MT"
}, {
	"Nome": "Planalto da Serra",
	"uf": "MT"
}, {
	"Nome": "Poconé",
	"uf": "MT"
}, {
	"Nome": "Pontal do Araguaia",
	"uf": "MT"
}, {
	"Nome": "Ponte Branca",
	"uf": "MT"
}, {
	"Nome": "Pontes e Lacerda",
	"uf": "MT"
}, {
	"Nome": "Porto Alegre do Norte",
	"uf": "MT"
}, {
	"Nome": "Porto dos Gaúchos",
	"uf": "MT"
}, {
	"Nome": "Porto Esperidião",
	"uf": "MT"
}, {
	"Nome": "Porto Estrela",
	"uf": "MT"
}, {
	"Nome": "Poxoréo",
	"uf": "MT"
}, {
	"Nome": "Primavera do Leste",
	"uf": "MT"
}, {
	"Nome": "Querência",
	"uf": "MT"
}, {
	"Nome": "Reserva do Cabaçal",
	"uf": "MT"
}, {
	"Nome": "Ribeirão Cascalheira",
	"uf": "MT"
}, {
	"Nome": "Ribeirãozinho",
	"uf": "MT"
}, {
	"Nome": "Rio Branco",
	"uf": "MT"
}, {
	"Nome": "Rondolândia",
	"uf": "MT"
}, {
	"Nome": "Rondonópolis",
	"uf": "MT"
}, {
	"Nome": "Rosário Oeste",
	"uf": "MT"
}, {
	"Nome": "Salto do Céu",
	"uf": "MT"
}, {
	"Nome": "Santa Carmem",
	"uf": "MT"
}, {
	"Nome": "Santa Cruz do Xingu",
	"uf": "MT"
}, {
	"Nome": "Santa Rita do Trivelato",
	"uf": "MT"
}, {
	"Nome": "Santa Terezinha",
	"uf": "MT"
}, {
	"Nome": "Santo Afonso",
	"uf": "MT"
}, {
	"Nome": "Santo Antônio do Leste",
	"uf": "MT"
}, {
	"Nome": "Santo Antônio do Leverger",
	"uf": "MT"
}, {
	"Nome": "São Félix do Araguaia",
	"uf": "MT"
}, {
	"Nome": "São José do Povo",
	"uf": "MT"
}, {
	"Nome": "São José do Rio Claro",
	"uf": "MT"
}, {
	"Nome": "São José do Xingu",
	"uf": "MT"
}, {
	"Nome": "São José dos Quatro Marcos",
	"uf": "MT"
}, {
	"Nome": "São Pedro da Cipa",
	"uf": "MT"
}, {
	"Nome": "Sapezal",
	"uf": "MT"
}, {
	"Nome": "Serra Nova Dourada",
	"uf": "MT"
}, {
	"Nome": "Sinop",
	"uf": "MT"
}, {
	"Nome": "Sorriso",
	"uf": "MT"
}, {
	"Nome": "Tabaporã",
	"uf": "MT"
}, {
	"Nome": "Tangará da Serra",
	"uf": "MT"
}, {
	"Nome": "Tapurah",
	"uf": "MT"
}, {
	"Nome": "Terra Nova do Norte",
	"uf": "MT"
}, {
	"Nome": "Tesouro",
	"uf": "MT"
}, {
	"Nome": "Torixoréu",
	"uf": "MT"
}, {
	"Nome": "União do Sul",
	"uf": "MT"
}, {
	"Nome": "Vale de São Domingos",
	"uf": "MT"
}, {
	"Nome": "Várzea Grande",
	"uf": "MT"
}, {
	"Nome": "Vera",
	"uf": "MT"
}, {
	"Nome": "Vila Bela da Santíssima Trindade",
	"uf": "MT"
}, {
	"Nome": "Vila Rica",
	"uf": "MT"
}, {
	"Nome": "Água Clara",
	"uf": "MS"
}, {
	"Nome": "Alcinópolis",
	"uf": "MS"
}, {
	"Nome": "Amambaí",
	"uf": "MS"
}, {
	"Nome": "Anastácio",
	"uf": "MS"
}, {
	"Nome": "Anaurilândia",
	"uf": "MS"
}, {
	"Nome": "Angélica",
	"uf": "MS"
}, {
	"Nome": "Antônio João",
	"uf": "MS"
}, {
	"Nome": "Aparecida do Taboado",
	"uf": "MS"
}, {
	"Nome": "Aquidauana",
	"uf": "MS"
}, {
	"Nome": "Aral Moreira",
	"uf": "MS"
}, {
	"Nome": "Bandeirantes",
	"uf": "MS"
}, {
	"Nome": "Bataguassu",
	"uf": "MS"
}, {
	"Nome": "Bataiporã",
	"uf": "MS"
}, {
	"Nome": "Bela Vista",
	"uf": "MS"
}, {
	"Nome": "Bodoquena",
	"uf": "MS"
}, {
	"Nome": "Bonito",
	"uf": "MS"
}, {
	"Nome": "Brasilândia",
	"uf": "MS"
}, {
	"Nome": "Caarapó",
	"uf": "MS"
}, {
	"Nome": "Camapuã",
	"uf": "MS"
}, {
	"Nome": "Campo Grande",
	"uf": "MS"
}, {
	"Nome": "Caracol",
	"uf": "MS"
}, {
	"Nome": "Cassilândia",
	"uf": "MS"
}, {
	"Nome": "Chapadão do Sul",
	"uf": "MS"
}, {
	"Nome": "Corguinho",
	"uf": "MS"
}, {
	"Nome": "Coronel Sapucaia",
	"uf": "MS"
}, {
	"Nome": "Corumbá",
	"uf": "MS"
}, {
	"Nome": "Costa Rica",
	"uf": "MS"
}, {
	"Nome": "Coxim",
	"uf": "MS"
}, {
	"Nome": "Deodápolis",
	"uf": "MS"
}, {
	"Nome": "Dois Irmãos do Buriti",
	"uf": "MS"
}, {
	"Nome": "Douradina",
	"uf": "MS"
}, {
	"Nome": "Dourados",
	"uf": "MS"
}, {
	"Nome": "Eldorado",
	"uf": "MS"
}, {
	"Nome": "Fátima do Sul",
	"uf": "MS"
}, {
	"Nome": "Figueirão",
	"uf": "MS"
}, {
	"Nome": "Glória de Dourados",
	"uf": "MS"
}, {
	"Nome": "Guia Lopes da Laguna",
	"uf": "MS"
}, {
	"Nome": "Iguatemi",
	"uf": "MS"
}, {
	"Nome": "Inocência",
	"uf": "MS"
}, {
	"Nome": "Itaporã",
	"uf": "MS"
}, {
	"Nome": "Itaquiraí",
	"uf": "MS"
}, {
	"Nome": "Ivinhema",
	"uf": "MS"
}, {
	"Nome": "Japorã",
	"uf": "MS"
}, {
	"Nome": "Jaraguari",
	"uf": "MS"
}, {
	"Nome": "Jardim",
	"uf": "MS"
}, {
	"Nome": "Jateí",
	"uf": "MS"
}, {
	"Nome": "Juti",
	"uf": "MS"
}, {
	"Nome": "Ladário",
	"uf": "MS"
}, {
	"Nome": "Laguna Carapã",
	"uf": "MS"
}, {
	"Nome": "Maracaju",
	"uf": "MS"
}, {
	"Nome": "Miranda",
	"uf": "MS"
}, {
	"Nome": "Mundo Novo",
	"uf": "MS"
}, {
	"Nome": "Naviraí",
	"uf": "MS"
}, {
	"Nome": "Nioaque",
	"uf": "MS"
}, {
	"Nome": "Nova Alvorada do Sul",
	"uf": "MS"
}, {
	"Nome": "Nova Andradina",
	"uf": "MS"
}, {
	"Nome": "Novo Horizonte do Sul",
	"uf": "MS"
}, {
	"Nome": "Paranaíba",
	"uf": "MS"
}, {
	"Nome": "Paranhos",
	"uf": "MS"
}, {
	"Nome": "Pedro Gomes",
	"uf": "MS"
}, {
	"Nome": "Ponta Porã",
	"uf": "MS"
}, {
	"Nome": "Porto Murtinho",
	"uf": "MS"
}, {
	"Nome": "Ribas do Rio Pardo",
	"uf": "MS"
}, {
	"Nome": "Rio Brilhante",
	"uf": "MS"
}, {
	"Nome": "Rio Negro",
	"uf": "MS"
}, {
	"Nome": "Rio Verde de Mato Grosso",
	"uf": "MS"
}, {
	"Nome": "Rochedo",
	"uf": "MS"
}, {
	"Nome": "Santa Rita do Pardo",
	"uf": "MS"
}, {
	"Nome": "São Gabriel do Oeste",
	"uf": "MS"
}, {
	"Nome": "Selvíria",
	"uf": "MS"
}, {
	"Nome": "Sete Quedas",
	"uf": "MS"
}, {
	"Nome": "Sidrolândia",
	"uf": "MS"
}, {
	"Nome": "Sonora",
	"uf": "MS"
}, {
	"Nome": "Tacuru",
	"uf": "MS"
}, {
	"Nome": "Taquarussu",
	"uf": "MS"
}, {
	"Nome": "Terenos",
	"uf": "MS"
}, {
	"Nome": "Três Lagoas",
	"uf": "MS"
}, {
	"Nome": "Vicentina",
	"uf": "MS"
}, {
	"Nome": "Abadia dos Dourados",
	"uf": "MG"
}, {
	"Nome": "Abaeté",
	"uf": "MG"
}, {
	"Nome": "Abre Campo",
	"uf": "MG"
}, {
	"Nome": "Acaiaca",
	"uf": "MG"
}, {
	"Nome": "Açucena",
	"uf": "MG"
}, {
	"Nome": "Água Boa",
	"uf": "MG"
}, {
	"Nome": "Água Comprida",
	"uf": "MG"
}, {
	"Nome": "Aguanil",
	"uf": "MG"
}, {
	"Nome": "Águas Formosas",
	"uf": "MG"
}, {
	"Nome": "Águas Vermelhas",
	"uf": "MG"
}, {
	"Nome": "Aimorés",
	"uf": "MG"
}, {
	"Nome": "Aiuruoca",
	"uf": "MG"
}, {
	"Nome": "Alagoa",
	"uf": "MG"
}, {
	"Nome": "Albertina",
	"uf": "MG"
}, {
	"Nome": "Além Paraíba",
	"uf": "MG"
}, {
	"Nome": "Alfenas",
	"uf": "MG"
}, {
	"Nome": "Alfredo Vasconcelos",
	"uf": "MG"
}, {
	"Nome": "Almenara",
	"uf": "MG"
}, {
	"Nome": "Alpercata",
	"uf": "MG"
}, {
	"Nome": "Alpinópolis",
	"uf": "MG"
}, {
	"Nome": "Alterosa",
	"uf": "MG"
}, {
	"Nome": "Alto Caparaó",
	"uf": "MG"
}, {
	"Nome": "Alto Jequitibá",
	"uf": "MG"
}, {
	"Nome": "Alto Rio Doce",
	"uf": "MG"
}, {
	"Nome": "Alvarenga",
	"uf": "MG"
}, {
	"Nome": "Alvinópolis",
	"uf": "MG"
}, {
	"Nome": "Alvorada de Minas",
	"uf": "MG"
}, {
	"Nome": "Amparo do Serra",
	"uf": "MG"
}, {
	"Nome": "Andradas",
	"uf": "MG"
}, {
	"Nome": "Andrelândia",
	"uf": "MG"
}, {
	"Nome": "Angelândia",
	"uf": "MG"
}, {
	"Nome": "Antônio Carlos",
	"uf": "MG"
}, {
	"Nome": "Antônio Dias",
	"uf": "MG"
}, {
	"Nome": "Antônio Prado de Minas",
	"uf": "MG"
}, {
	"Nome": "Araçaí",
	"uf": "MG"
}, {
	"Nome": "Aracitaba",
	"uf": "MG"
}, {
	"Nome": "Araçuaí",
	"uf": "MG"
}, {
	"Nome": "Araguari",
	"uf": "MG"
}, {
	"Nome": "Arantina",
	"uf": "MG"
}, {
	"Nome": "Araponga",
	"uf": "MG"
}, {
	"Nome": "Araporã",
	"uf": "MG"
}, {
	"Nome": "Arapuá",
	"uf": "MG"
}, {
	"Nome": "Araújos",
	"uf": "MG"
}, {
	"Nome": "Araxá",
	"uf": "MG"
}, {
	"Nome": "Arceburgo",
	"uf": "MG"
}, {
	"Nome": "Arcos",
	"uf": "MG"
}, {
	"Nome": "Areado",
	"uf": "MG"
}, {
	"Nome": "Argirita",
	"uf": "MG"
}, {
	"Nome": "Aricanduva",
	"uf": "MG"
}, {
	"Nome": "Arinos",
	"uf": "MG"
}, {
	"Nome": "Astolfo Dutra",
	"uf": "MG"
}, {
	"Nome": "Ataléia",
	"uf": "MG"
}, {
	"Nome": "Augusto de Lima",
	"uf": "MG"
}, {
	"Nome": "Baependi",
	"uf": "MG"
}, {
	"Nome": "Baldim",
	"uf": "MG"
}, {
	"Nome": "Bambuí",
	"uf": "MG"
}, {
	"Nome": "Bandeira",
	"uf": "MG"
}, {
	"Nome": "Bandeira do Sul",
	"uf": "MG"
}, {
	"Nome": "Barão de Cocais",
	"uf": "MG"
}, {
	"Nome": "Barão de Monte Alto",
	"uf": "MG"
}, {
	"Nome": "Barbacena",
	"uf": "MG"
}, {
	"Nome": "Barra Longa",
	"uf": "MG"
}, {
	"Nome": "Barroso",
	"uf": "MG"
}, {
	"Nome": "Bela Vista de Minas",
	"uf": "MG"
}, {
	"Nome": "Belmiro Braga",
	"uf": "MG"
}, {
	"Nome": "Belo Horizonte",
	"uf": "MG"
}, {
	"Nome": "Belo Oriente",
	"uf": "MG"
}, {
	"Nome": "Belo Vale",
	"uf": "MG"
}, {
	"Nome": "Berilo",
	"uf": "MG"
}, {
	"Nome": "Berizal",
	"uf": "MG"
}, {
	"Nome": "Bertópolis",
	"uf": "MG"
}, {
	"Nome": "Betim",
	"uf": "MG"
}, {
	"Nome": "Bias Fortes",
	"uf": "MG"
}, {
	"Nome": "Bicas",
	"uf": "MG"
}, {
	"Nome": "Biquinhas",
	"uf": "MG"
}, {
	"Nome": "Boa Esperança",
	"uf": "MG"
}, {
	"Nome": "Bocaina de Minas",
	"uf": "MG"
}, {
	"Nome": "Bocaiúva",
	"uf": "MG"
}, {
	"Nome": "Bom Despacho",
	"uf": "MG"
}, {
	"Nome": "Bom Jardim de Minas",
	"uf": "MG"
}, {
	"Nome": "Bom Jesus da Penha",
	"uf": "MG"
}, {
	"Nome": "Bom Jesus do Amparo",
	"uf": "MG"
}, {
	"Nome": "Bom Jesus do Galho",
	"uf": "MG"
}, {
	"Nome": "Bom Repouso",
	"uf": "MG"
}, {
	"Nome": "Bom Sucesso",
	"uf": "MG"
}, {
	"Nome": "Bonfim",
	"uf": "MG"
}, {
	"Nome": "Bonfinópolis de Minas",
	"uf": "MG"
}, {
	"Nome": "Bonito de Minas",
	"uf": "MG"
}, {
	"Nome": "Borda da Mata",
	"uf": "MG"
}, {
	"Nome": "Botelhos",
	"uf": "MG"
}, {
	"Nome": "Botumirim",
	"uf": "MG"
}, {
	"Nome": "Brás Pires",
	"uf": "MG"
}, {
	"Nome": "Brasilândia de Minas",
	"uf": "MG"
}, {
	"Nome": "Brasília de Minas",
	"uf": "MG"
}, {
	"Nome": "Brasópolis",
	"uf": "MG"
}, {
	"Nome": "Braúnas",
	"uf": "MG"
}, {
	"Nome": "Brumadinho",
	"uf": "MG"
}, {
	"Nome": "Bueno Brandão",
	"uf": "MG"
}, {
	"Nome": "Buenópolis",
	"uf": "MG"
}, {
	"Nome": "Bugre",
	"uf": "MG"
}, {
	"Nome": "Buritis",
	"uf": "MG"
}, {
	"Nome": "Buritizeiro",
	"uf": "MG"
}, {
	"Nome": "Cabeceira Grande",
	"uf": "MG"
}, {
	"Nome": "Cabo Verde",
	"uf": "MG"
}, {
	"Nome": "Cachoeira da Prata",
	"uf": "MG"
}, {
	"Nome": "Cachoeira de Minas",
	"uf": "MG"
}, {
	"Nome": "Cachoeira de Pajeú",
	"uf": "MG"
}, {
	"Nome": "Cachoeira Dourada",
	"uf": "MG"
}, {
	"Nome": "Caetanópolis",
	"uf": "MG"
}, {
	"Nome": "Caeté",
	"uf": "MG"
}, {
	"Nome": "Caiana",
	"uf": "MG"
}, {
	"Nome": "Cajuri",
	"uf": "MG"
}, {
	"Nome": "Caldas",
	"uf": "MG"
}, {
	"Nome": "Camacho",
	"uf": "MG"
}, {
	"Nome": "Camanducaia",
	"uf": "MG"
}, {
	"Nome": "Cambuí",
	"uf": "MG"
}, {
	"Nome": "Cambuquira",
	"uf": "MG"
}, {
	"Nome": "Campanário",
	"uf": "MG"
}, {
	"Nome": "Campanha",
	"uf": "MG"
}, {
	"Nome": "Campestre",
	"uf": "MG"
}, {
	"Nome": "Campina Verde",
	"uf": "MG"
}, {
	"Nome": "Campo Azul",
	"uf": "MG"
}, {
	"Nome": "Campo Belo",
	"uf": "MG"
}, {
	"Nome": "Campo do Meio",
	"uf": "MG"
}, {
	"Nome": "Campo Florido",
	"uf": "MG"
}, {
	"Nome": "Campos Altos",
	"uf": "MG"
}, {
	"Nome": "Campos Gerais",
	"uf": "MG"
}, {
	"Nome": "Cana Verde",
	"uf": "MG"
}, {
	"Nome": "Canaã",
	"uf": "MG"
}, {
	"Nome": "Canápolis",
	"uf": "MG"
}, {
	"Nome": "Candeias",
	"uf": "MG"
}, {
	"Nome": "Cantagalo",
	"uf": "MG"
}, {
	"Nome": "Caparaó",
	"uf": "MG"
}, {
	"Nome": "Capela Nova",
	"uf": "MG"
}, {
	"Nome": "Capelinha",
	"uf": "MG"
}, {
	"Nome": "Capetinga",
	"uf": "MG"
}, {
	"Nome": "Capim Branco",
	"uf": "MG"
}, {
	"Nome": "Capinópolis",
	"uf": "MG"
}, {
	"Nome": "Capitão Andrade",
	"uf": "MG"
}, {
	"Nome": "Capitão Enéas",
	"uf": "MG"
}, {
	"Nome": "Capitólio",
	"uf": "MG"
}, {
	"Nome": "Caputira",
	"uf": "MG"
}, {
	"Nome": "Caraí",
	"uf": "MG"
}, {
	"Nome": "Caranaíba",
	"uf": "MG"
}, {
	"Nome": "Carandaí",
	"uf": "MG"
}, {
	"Nome": "Carangola",
	"uf": "MG"
}, {
	"Nome": "Caratinga",
	"uf": "MG"
}, {
	"Nome": "Carbonita",
	"uf": "MG"
}, {
	"Nome": "Careaçu",
	"uf": "MG"
}, {
	"Nome": "Carlos Chagas",
	"uf": "MG"
}, {
	"Nome": "Carmésia",
	"uf": "MG"
}, {
	"Nome": "Carmo da Cachoeira",
	"uf": "MG"
}, {
	"Nome": "Carmo da Mata",
	"uf": "MG"
}, {
	"Nome": "Carmo de Minas",
	"uf": "MG"
}, {
	"Nome": "Carmo do Cajuru",
	"uf": "MG"
}, {
	"Nome": "Carmo do Paranaíba",
	"uf": "MG"
}, {
	"Nome": "Carmo do Rio Claro",
	"uf": "MG"
}, {
	"Nome": "Carmópolis de Minas",
	"uf": "MG"
}, {
	"Nome": "Carneirinho",
	"uf": "MG"
}, {
	"Nome": "Carrancas",
	"uf": "MG"
}, {
	"Nome": "Carvalhópolis",
	"uf": "MG"
}, {
	"Nome": "Carvalhos",
	"uf": "MG"
}, {
	"Nome": "Casa Grande",
	"uf": "MG"
}, {
	"Nome": "Cascalho Rico",
	"uf": "MG"
}, {
	"Nome": "Cássia",
	"uf": "MG"
}, {
	"Nome": "Cataguases",
	"uf": "MG"
}, {
	"Nome": "Catas Altas",
	"uf": "MG"
}, {
	"Nome": "Catas Altas da Noruega",
	"uf": "MG"
}, {
	"Nome": "Catuji",
	"uf": "MG"
}, {
	"Nome": "Catuti",
	"uf": "MG"
}, {
	"Nome": "Caxambu",
	"uf": "MG"
}, {
	"Nome": "Cedro do Abaeté",
	"uf": "MG"
}, {
	"Nome": "Central de Minas",
	"uf": "MG"
}, {
	"Nome": "Centralina",
	"uf": "MG"
}, {
	"Nome": "Chácara",
	"uf": "MG"
}, {
	"Nome": "Chalé",
	"uf": "MG"
}, {
	"Nome": "Chapada do Norte",
	"uf": "MG"
}, {
	"Nome": "Chapada Gaúcha",
	"uf": "MG"
}, {
	"Nome": "Chiador",
	"uf": "MG"
}, {
	"Nome": "Cipotânea",
	"uf": "MG"
}, {
	"Nome": "Claraval",
	"uf": "MG"
}, {
	"Nome": "Claro dos Poções",
	"uf": "MG"
}, {
	"Nome": "Cláudio",
	"uf": "MG"
}, {
	"Nome": "Coimbra",
	"uf": "MG"
}, {
	"Nome": "Coluna",
	"uf": "MG"
}, {
	"Nome": "Comendador Gomes",
	"uf": "MG"
}, {
	"Nome": "Comercinho",
	"uf": "MG"
}, {
	"Nome": "Conceição da Aparecida",
	"uf": "MG"
}, {
	"Nome": "Conceição da Barra de Minas",
	"uf": "MG"
}, {
	"Nome": "Conceição das Alagoas",
	"uf": "MG"
}, {
	"Nome": "Conceição das Pedras",
	"uf": "MG"
}, {
	"Nome": "Conceição de Ipanema",
	"uf": "MG"
}, {
	"Nome": "Conceição do Mato Dentro",
	"uf": "MG"
}, {
	"Nome": "Conceição do Pará",
	"uf": "MG"
}, {
	"Nome": "Conceição do Rio Verde",
	"uf": "MG"
}, {
	"Nome": "Conceição dos Ouros",
	"uf": "MG"
}, {
	"Nome": "Cônego Marinho",
	"uf": "MG"
}, {
	"Nome": "Confins",
	"uf": "MG"
}, {
	"Nome": "Congonhal",
	"uf": "MG"
}, {
	"Nome": "Congonhas",
	"uf": "MG"
}, {
	"Nome": "Congonhas do Norte",
	"uf": "MG"
}, {
	"Nome": "Conquista",
	"uf": "MG"
}, {
	"Nome": "Conselheiro Lafaiete",
	"uf": "MG"
}, {
	"Nome": "Conselheiro Pena",
	"uf": "MG"
}, {
	"Nome": "Consolação",
	"uf": "MG"
}, {
	"Nome": "Contagem",
	"uf": "MG"
}, {
	"Nome": "Coqueiral",
	"uf": "MG"
}, {
	"Nome": "Coração de Jesus",
	"uf": "MG"
}, {
	"Nome": "Cordisburgo",
	"uf": "MG"
}, {
	"Nome": "Cordislândia",
	"uf": "MG"
}, {
	"Nome": "Corinto",
	"uf": "MG"
}, {
	"Nome": "Coroaci",
	"uf": "MG"
}, {
	"Nome": "Coromandel",
	"uf": "MG"
}, {
	"Nome": "Coronel Fabriciano",
	"uf": "MG"
}, {
	"Nome": "Coronel Murta",
	"uf": "MG"
}, {
	"Nome": "Coronel Pacheco",
	"uf": "MG"
}, {
	"Nome": "Coronel Xavier Chaves",
	"uf": "MG"
}, {
	"Nome": "Córrego Danta",
	"uf": "MG"
}, {
	"Nome": "Córrego do Bom Jesus",
	"uf": "MG"
}, {
	"Nome": "Córrego Fundo",
	"uf": "MG"
}, {
	"Nome": "Córrego Novo",
	"uf": "MG"
}, {
	"Nome": "Couto de Magalhães de Minas",
	"uf": "MG"
}, {
	"Nome": "Crisólita",
	"uf": "MG"
}, {
	"Nome": "Cristais",
	"uf": "MG"
}, {
	"Nome": "Cristália",
	"uf": "MG"
}, {
	"Nome": "Cristiano Otoni",
	"uf": "MG"
}, {
	"Nome": "Cristina",
	"uf": "MG"
}, {
	"Nome": "Crucilândia",
	"uf": "MG"
}, {
	"Nome": "Cruzeiro da Fortaleza",
	"uf": "MG"
}, {
	"Nome": "Cruzília",
	"uf": "MG"
}, {
	"Nome": "Cuparaque",
	"uf": "MG"
}, {
	"Nome": "Curral de Dentro",
	"uf": "MG"
}, {
	"Nome": "Curvelo",
	"uf": "MG"
}, {
	"Nome": "Datas",
	"uf": "MG"
}, {
	"Nome": "Delfim Moreira",
	"uf": "MG"
}, {
	"Nome": "Delfinópolis",
	"uf": "MG"
}, {
	"Nome": "Delta",
	"uf": "MG"
}, {
	"Nome": "Descoberto",
	"uf": "MG"
}, {
	"Nome": "Desterro de Entre Rios",
	"uf": "MG"
}, {
	"Nome": "Desterro do Melo",
	"uf": "MG"
}, {
	"Nome": "Diamantina",
	"uf": "MG"
}, {
	"Nome": "Diogo de Vasconcelos",
	"uf": "MG"
}, {
	"Nome": "Dionísio",
	"uf": "MG"
}, {
	"Nome": "Divinésia",
	"uf": "MG"
}, {
	"Nome": "Divino",
	"uf": "MG"
}, {
	"Nome": "Divino das Laranjeiras",
	"uf": "MG"
}, {
	"Nome": "Divinolândia de Minas",
	"uf": "MG"
}, {
	"Nome": "Divinópolis",
	"uf": "MG"
}, {
	"Nome": "Divisa Alegre",
	"uf": "MG"
}, {
	"Nome": "Divisa Nova",
	"uf": "MG"
}, {
	"Nome": "Divisópolis",
	"uf": "MG"
}, {
	"Nome": "Dom Bosco",
	"uf": "MG"
}, {
	"Nome": "Dom Cavati",
	"uf": "MG"
}, {
	"Nome": "Dom Joaquim",
	"uf": "MG"
}, {
	"Nome": "Dom Silvério",
	"uf": "MG"
}, {
	"Nome": "Dom Viçoso",
	"uf": "MG"
}, {
	"Nome": "Dona Eusébia",
	"uf": "MG"
}, {
	"Nome": "Dores de Campos",
	"uf": "MG"
}, {
	"Nome": "Dores de Guanhães",
	"uf": "MG"
}, {
	"Nome": "Dores do Indaiá",
	"uf": "MG"
}, {
	"Nome": "Dores do Turvo",
	"uf": "MG"
}, {
	"Nome": "Doresópolis",
	"uf": "MG"
}, {
	"Nome": "Douradoquara",
	"uf": "MG"
}, {
	"Nome": "Durandé",
	"uf": "MG"
}, {
	"Nome": "Elói Mendes",
	"uf": "MG"
}, {
	"Nome": "Engenheiro Caldas",
	"uf": "MG"
}, {
	"Nome": "Engenheiro Navarro",
	"uf": "MG"
}, {
	"Nome": "Entre Folhas",
	"uf": "MG"
}, {
	"Nome": "Entre Rios de Minas",
	"uf": "MG"
}, {
	"Nome": "Ervália",
	"uf": "MG"
}, {
	"Nome": "Esmeraldas",
	"uf": "MG"
}, {
	"Nome": "Espera Feliz",
	"uf": "MG"
}, {
	"Nome": "Espinosa",
	"uf": "MG"
}, {
	"Nome": "Espírito Santo do Dourado",
	"uf": "MG"
}, {
	"Nome": "Estiva",
	"uf": "MG"
}, {
	"Nome": "Estrela Dalva",
	"uf": "MG"
}, {
	"Nome": "Estrela do Indaiá",
	"uf": "MG"
}, {
	"Nome": "Estrela do Sul",
	"uf": "MG"
}, {
	"Nome": "Eugenópolis",
	"uf": "MG"
}, {
	"Nome": "Ewbank da Câmara",
	"uf": "MG"
}, {
	"Nome": "Extrema",
	"uf": "MG"
}, {
	"Nome": "Fama",
	"uf": "MG"
}, {
	"Nome": "Faria Lemos",
	"uf": "MG"
}, {
	"Nome": "Felício dos Santos",
	"uf": "MG"
}, {
	"Nome": "Felisburgo",
	"uf": "MG"
}, {
	"Nome": "Felixlândia",
	"uf": "MG"
}, {
	"Nome": "Fernandes Tourinho",
	"uf": "MG"
}, {
	"Nome": "Ferros",
	"uf": "MG"
}, {
	"Nome": "Fervedouro",
	"uf": "MG"
}, {
	"Nome": "Florestal",
	"uf": "MG"
}, {
	"Nome": "Formiga",
	"uf": "MG"
}, {
	"Nome": "Formoso",
	"uf": "MG"
}, {
	"Nome": "Fortaleza de Minas",
	"uf": "MG"
}, {
	"Nome": "Fortuna de Minas",
	"uf": "MG"
}, {
	"Nome": "Francisco Badaró",
	"uf": "MG"
}, {
	"Nome": "Francisco Dumont",
	"uf": "MG"
}, {
	"Nome": "Francisco Sá",
	"uf": "MG"
}, {
	"Nome": "Franciscópolis",
	"uf": "MG"
}, {
	"Nome": "Frei Gaspar",
	"uf": "MG"
}, {
	"Nome": "Frei Inocêncio",
	"uf": "MG"
}, {
	"Nome": "Frei Lagonegro",
	"uf": "MG"
}, {
	"Nome": "Fronteira",
	"uf": "MG"
}, {
	"Nome": "Fronteira dos Vales",
	"uf": "MG"
}, {
	"Nome": "Fruta de Leite",
	"uf": "MG"
}, {
	"Nome": "Frutal",
	"uf": "MG"
}, {
	"Nome": "Funilândia",
	"uf": "MG"
}, {
	"Nome": "Galiléia",
	"uf": "MG"
}, {
	"Nome": "Gameleiras",
	"uf": "MG"
}, {
	"Nome": "Glaucilândia",
	"uf": "MG"
}, {
	"Nome": "Goiabeira",
	"uf": "MG"
}, {
	"Nome": "Goianá",
	"uf": "MG"
}, {
	"Nome": "Gonçalves",
	"uf": "MG"
}, {
	"Nome": "Gonzaga",
	"uf": "MG"
}, {
	"Nome": "Gouveia",
	"uf": "MG"
}, {
	"Nome": "Governador Valadares",
	"uf": "MG"
}, {
	"Nome": "Grão Mogol",
	"uf": "MG"
}, {
	"Nome": "Grupiara",
	"uf": "MG"
}, {
	"Nome": "Guanhães",
	"uf": "MG"
}, {
	"Nome": "Guapé",
	"uf": "MG"
}, {
	"Nome": "Guaraciaba",
	"uf": "MG"
}, {
	"Nome": "Guaraciama",
	"uf": "MG"
}, {
	"Nome": "Guaranésia",
	"uf": "MG"
}, {
	"Nome": "Guarani",
	"uf": "MG"
}, {
	"Nome": "Guarará",
	"uf": "MG"
}, {
	"Nome": "Guarda-Mor",
	"uf": "MG"
}, {
	"Nome": "Guaxupé",
	"uf": "MG"
}, {
	"Nome": "Guidoval",
	"uf": "MG"
}, {
	"Nome": "Guimarânia",
	"uf": "MG"
}, {
	"Nome": "Guiricema",
	"uf": "MG"
}, {
	"Nome": "Gurinhatã",
	"uf": "MG"
}, {
	"Nome": "Heliodora",
	"uf": "MG"
}, {
	"Nome": "Iapu",
	"uf": "MG"
}, {
	"Nome": "Ibertioga",
	"uf": "MG"
}, {
	"Nome": "Ibiá",
	"uf": "MG"
}, {
	"Nome": "Ibiaí",
	"uf": "MG"
}, {
	"Nome": "Ibiracatu",
	"uf": "MG"
}, {
	"Nome": "Ibiraci",
	"uf": "MG"
}, {
	"Nome": "Ibirité",
	"uf": "MG"
}, {
	"Nome": "Ibitiúra de Minas",
	"uf": "MG"
}, {
	"Nome": "Ibituruna",
	"uf": "MG"
}, {
	"Nome": "Icaraí de Minas",
	"uf": "MG"
}, {
	"Nome": "Igarapé",
	"uf": "MG"
}, {
	"Nome": "Igaratinga",
	"uf": "MG"
}, {
	"Nome": "Iguatama",
	"uf": "MG"
}, {
	"Nome": "Ijaci",
	"uf": "MG"
}, {
	"Nome": "Ilicínea",
	"uf": "MG"
}, {
	"Nome": "Imbé de Minas",
	"uf": "MG"
}, {
	"Nome": "Inconfidentes",
	"uf": "MG"
}, {
	"Nome": "Indaiabira",
	"uf": "MG"
}, {
	"Nome": "Indianópolis",
	"uf": "MG"
}, {
	"Nome": "Ingaí",
	"uf": "MG"
}, {
	"Nome": "Inhapim",
	"uf": "MG"
}, {
	"Nome": "Inhaúma",
	"uf": "MG"
}, {
	"Nome": "Inimutaba",
	"uf": "MG"
}, {
	"Nome": "Ipaba",
	"uf": "MG"
}, {
	"Nome": "Ipanema",
	"uf": "MG"
}, {
	"Nome": "Ipatinga",
	"uf": "MG"
}, {
	"Nome": "Ipiaçu",
	"uf": "MG"
}, {
	"Nome": "Ipuiúna",
	"uf": "MG"
}, {
	"Nome": "Iraí de Minas",
	"uf": "MG"
}, {
	"Nome": "Itabira",
	"uf": "MG"
}, {
	"Nome": "Itabirinha de Mantena",
	"uf": "MG"
}, {
	"Nome": "Itabirito",
	"uf": "MG"
}, {
	"Nome": "Itacambira",
	"uf": "MG"
}, {
	"Nome": "Itacarambi",
	"uf": "MG"
}, {
	"Nome": "Itaguara",
	"uf": "MG"
}, {
	"Nome": "Itaipé",
	"uf": "MG"
}, {
	"Nome": "Itajubá",
	"uf": "MG"
}, {
	"Nome": "Itamarandiba",
	"uf": "MG"
}, {
	"Nome": "Itamarati de Minas",
	"uf": "MG"
}, {
	"Nome": "Itambacuri",
	"uf": "MG"
}, {
	"Nome": "Itambé do Mato Dentro",
	"uf": "MG"
}, {
	"Nome": "Itamogi",
	"uf": "MG"
}, {
	"Nome": "Itamonte",
	"uf": "MG"
}, {
	"Nome": "Itanhandu",
	"uf": "MG"
}, {
	"Nome": "Itanhomi",
	"uf": "MG"
}, {
	"Nome": "Itaobim",
	"uf": "MG"
}, {
	"Nome": "Itapagipe",
	"uf": "MG"
}, {
	"Nome": "Itapecerica",
	"uf": "MG"
}, {
	"Nome": "Itapeva",
	"uf": "MG"
}, {
	"Nome": "Itatiaiuçu",
	"uf": "MG"
}, {
	"Nome": "Itaú de Minas",
	"uf": "MG"
}, {
	"Nome": "Itaúna",
	"uf": "MG"
}, {
	"Nome": "Itaverava",
	"uf": "MG"
}, {
	"Nome": "Itinga",
	"uf": "MG"
}, {
	"Nome": "Itueta",
	"uf": "MG"
}, {
	"Nome": "Ituiutaba",
	"uf": "MG"
}, {
	"Nome": "Itumirim",
	"uf": "MG"
}, {
	"Nome": "Iturama",
	"uf": "MG"
}, {
	"Nome": "Itutinga",
	"uf": "MG"
}, {
	"Nome": "Jaboticatubas",
	"uf": "MG"
}, {
	"Nome": "Jacinto",
	"uf": "MG"
}, {
	"Nome": "Jacuí",
	"uf": "MG"
}, {
	"Nome": "Jacutinga",
	"uf": "MG"
}, {
	"Nome": "Jaguaraçu",
	"uf": "MG"
}, {
	"Nome": "Jaíba",
	"uf": "MG"
}, {
	"Nome": "Jampruca",
	"uf": "MG"
}, {
	"Nome": "Janaúba",
	"uf": "MG"
}, {
	"Nome": "Januária",
	"uf": "MG"
}, {
	"Nome": "Japaraíba",
	"uf": "MG"
}, {
	"Nome": "Japonvar",
	"uf": "MG"
}, {
	"Nome": "Jeceaba",
	"uf": "MG"
}, {
	"Nome": "Jenipapo de Minas",
	"uf": "MG"
}, {
	"Nome": "Jequeri",
	"uf": "MG"
}, {
	"Nome": "Jequitaí",
	"uf": "MG"
}, {
	"Nome": "Jequitibá",
	"uf": "MG"
}, {
	"Nome": "Jequitinhonha",
	"uf": "MG"
}, {
	"Nome": "Jesuânia",
	"uf": "MG"
}, {
	"Nome": "Joaíma",
	"uf": "MG"
}, {
	"Nome": "Joanésia",
	"uf": "MG"
}, {
	"Nome": "João Monlevade",
	"uf": "MG"
}, {
	"Nome": "João Pinheiro",
	"uf": "MG"
}, {
	"Nome": "Joaquim Felício",
	"uf": "MG"
}, {
	"Nome": "Jordânia",
	"uf": "MG"
}, {
	"Nome": "José Gonçalves de Minas",
	"uf": "MG"
}, {
	"Nome": "José Raydan",
	"uf": "MG"
}, {
	"Nome": "Josenópolis",
	"uf": "MG"
}, {
	"Nome": "Juatuba",
	"uf": "MG"
}, {
	"Nome": "Juiz de Fora",
	"uf": "MG"
}, {
	"Nome": "Juramento",
	"uf": "MG"
}, {
	"Nome": "Juruaia",
	"uf": "MG"
}, {
	"Nome": "Juvenília",
	"uf": "MG"
}, {
	"Nome": "Ladainha",
	"uf": "MG"
}, {
	"Nome": "Lagamar",
	"uf": "MG"
}, {
	"Nome": "Lagoa da Prata",
	"uf": "MG"
}, {
	"Nome": "Lagoa dos Patos",
	"uf": "MG"
}, {
	"Nome": "Lagoa Dourada",
	"uf": "MG"
}, {
	"Nome": "Lagoa Formosa",
	"uf": "MG"
}, {
	"Nome": "Lagoa Grande",
	"uf": "MG"
}, {
	"Nome": "Lagoa Santa",
	"uf": "MG"
}, {
	"Nome": "Lajinha",
	"uf": "MG"
}, {
	"Nome": "Lambari",
	"uf": "MG"
}, {
	"Nome": "Lamim",
	"uf": "MG"
}, {
	"Nome": "Laranjal",
	"uf": "MG"
}, {
	"Nome": "Lassance",
	"uf": "MG"
}, {
	"Nome": "Lavras",
	"uf": "MG"
}, {
	"Nome": "Leandro Ferreira",
	"uf": "MG"
}, {
	"Nome": "Leme do Prado",
	"uf": "MG"
}, {
	"Nome": "Leopoldina",
	"uf": "MG"
}, {
	"Nome": "Liberdade",
	"uf": "MG"
}, {
	"Nome": "Lima Duarte",
	"uf": "MG"
}, {
	"Nome": "Limeira do Oeste",
	"uf": "MG"
}, {
	"Nome": "Lontra",
	"uf": "MG"
}, {
	"Nome": "Luisburgo",
	"uf": "MG"
}, {
	"Nome": "Luislândia",
	"uf": "MG"
}, {
	"Nome": "Luminárias",
	"uf": "MG"
}, {
	"Nome": "Luz",
	"uf": "MG"
}, {
	"Nome": "Machacalis",
	"uf": "MG"
}, {
	"Nome": "Machado",
	"uf": "MG"
}, {
	"Nome": "Madre de Deus de Minas",
	"uf": "MG"
}, {
	"Nome": "Malacacheta",
	"uf": "MG"
}, {
	"Nome": "Mamonas",
	"uf": "MG"
}, {
	"Nome": "Manga",
	"uf": "MG"
}, {
	"Nome": "Manhuaçu",
	"uf": "MG"
}, {
	"Nome": "Manhumirim",
	"uf": "MG"
}, {
	"Nome": "Mantena",
	"uf": "MG"
}, {
	"Nome": "Mar de Espanha",
	"uf": "MG"
}, {
	"Nome": "Maravilhas",
	"uf": "MG"
}, {
	"Nome": "Maria da Fé",
	"uf": "MG"
}, {
	"Nome": "Mariana",
	"uf": "MG"
}, {
	"Nome": "Marilac",
	"uf": "MG"
}, {
	"Nome": "Mário Campos",
	"uf": "MG"
}, {
	"Nome": "Maripá de Minas",
	"uf": "MG"
}, {
	"Nome": "Marliéria",
	"uf": "MG"
}, {
	"Nome": "Marmelópolis",
	"uf": "MG"
}, {
	"Nome": "Martinho Campos",
	"uf": "MG"
}, {
	"Nome": "Martins Soares",
	"uf": "MG"
}, {
	"Nome": "Mata Verde",
	"uf": "MG"
}, {
	"Nome": "Materlândia",
	"uf": "MG"
}, {
	"Nome": "Mateus Leme",
	"uf": "MG"
}, {
	"Nome": "Mathias Lobato",
	"uf": "MG"
}, {
	"Nome": "Matias Barbosa",
	"uf": "MG"
}, {
	"Nome": "Matias Cardoso",
	"uf": "MG"
}, {
	"Nome": "Matipó",
	"uf": "MG"
}, {
	"Nome": "Mato Verde",
	"uf": "MG"
}, {
	"Nome": "Matozinhos",
	"uf": "MG"
}, {
	"Nome": "Matutina",
	"uf": "MG"
}, {
	"Nome": "Medeiros",
	"uf": "MG"
}, {
	"Nome": "Medina",
	"uf": "MG"
}, {
	"Nome": "Mendes Pimentel",
	"uf": "MG"
}, {
	"Nome": "Mercês",
	"uf": "MG"
}, {
	"Nome": "Mesquita",
	"uf": "MG"
}, {
	"Nome": "Minas Novas",
	"uf": "MG"
}, {
	"Nome": "Minduri",
	"uf": "MG"
}, {
	"Nome": "Mirabela",
	"uf": "MG"
}, {
	"Nome": "Miradouro",
	"uf": "MG"
}, {
	"Nome": "Miraí",
	"uf": "MG"
}, {
	"Nome": "Miravânia",
	"uf": "MG"
}, {
	"Nome": "Moeda",
	"uf": "MG"
}, {
	"Nome": "Moema",
	"uf": "MG"
}, {
	"Nome": "Monjolos",
	"uf": "MG"
}, {
	"Nome": "Monsenhor Paulo",
	"uf": "MG"
}, {
	"Nome": "Montalvânia",
	"uf": "MG"
}, {
	"Nome": "Monte Alegre de Minas",
	"uf": "MG"
}, {
	"Nome": "Monte Azul",
	"uf": "MG"
}, {
	"Nome": "Monte Belo",
	"uf": "MG"
}, {
	"Nome": "Monte Carmelo",
	"uf": "MG"
}, {
	"Nome": "Monte Formoso",
	"uf": "MG"
}, {
	"Nome": "Monte Santo de Minas",
	"uf": "MG"
}, {
	"Nome": "Monte Sião",
	"uf": "MG"
}, {
	"Nome": "Montes Claros",
	"uf": "MG"
}, {
	"Nome": "Montezuma",
	"uf": "MG"
}, {
	"Nome": "Morada Nova de Minas",
	"uf": "MG"
}, {
	"Nome": "Morro da Garça",
	"uf": "MG"
}, {
	"Nome": "Morro do Pilar",
	"uf": "MG"
}, {
	"Nome": "Munhoz",
	"uf": "MG"
}, {
	"Nome": "Muriaé",
	"uf": "MG"
}, {
	"Nome": "Mutum",
	"uf": "MG"
}, {
	"Nome": "Muzambinho",
	"uf": "MG"
}, {
	"Nome": "Nacip Raydan",
	"uf": "MG"
}, {
	"Nome": "Nanuque",
	"uf": "MG"
}, {
	"Nome": "Naque",
	"uf": "MG"
}, {
	"Nome": "Natalândia",
	"uf": "MG"
}, {
	"Nome": "Natércia",
	"uf": "MG"
}, {
	"Nome": "Nazareno",
	"uf": "MG"
}, {
	"Nome": "Nepomuceno",
	"uf": "MG"
}, {
	"Nome": "Ninheira",
	"uf": "MG"
}, {
	"Nome": "Nova Belém",
	"uf": "MG"
}, {
	"Nome": "Nova Era",
	"uf": "MG"
}, {
	"Nome": "Nova Lima",
	"uf": "MG"
}, {
	"Nome": "Nova Módica",
	"uf": "MG"
}, {
	"Nome": "Nova Ponte",
	"uf": "MG"
}, {
	"Nome": "Nova Porteirinha",
	"uf": "MG"
}, {
	"Nome": "Nova Resende",
	"uf": "MG"
}, {
	"Nome": "Nova Serrana",
	"uf": "MG"
}, {
	"Nome": "Nova União",
	"uf": "MG"
}, {
	"Nome": "Novo Cruzeiro",
	"uf": "MG"
}, {
	"Nome": "Novo Oriente de Minas",
	"uf": "MG"
}, {
	"Nome": "Novorizonte",
	"uf": "MG"
}, {
	"Nome": "Olaria",
	"uf": "MG"
}, {
	"Nome": "Olhos-d`Água",
	"uf": "MG"
}, {
	"Nome": "Olímpio Noronha",
	"uf": "MG"
}, {
	"Nome": "Oliveira",
	"uf": "MG"
}, {
	"Nome": "Oliveira Fortes",
	"uf": "MG"
}, {
	"Nome": "Onça de Pitangui",
	"uf": "MG"
}, {
	"Nome": "Oratórios",
	"uf": "MG"
}, {
	"Nome": "Orizânia",
	"uf": "MG"
}, {
	"Nome": "Ouro Branco",
	"uf": "MG"
}, {
	"Nome": "Ouro Fino",
	"uf": "MG"
}, {
	"Nome": "Ouro Preto",
	"uf": "MG"
}, {
	"Nome": "Ouro Verde de Minas",
	"uf": "MG"
}, {
	"Nome": "Padre Carvalho",
	"uf": "MG"
}, {
	"Nome": "Padre Paraíso",
	"uf": "MG"
}, {
	"Nome": "Pai Pedro",
	"uf": "MG"
}, {
	"Nome": "Paineiras",
	"uf": "MG"
}, {
	"Nome": "Pains",
	"uf": "MG"
}, {
	"Nome": "Paiva",
	"uf": "MG"
}, {
	"Nome": "Palma",
	"uf": "MG"
}, {
	"Nome": "Palmópolis",
	"uf": "MG"
}, {
	"Nome": "Papagaios",
	"uf": "MG"
}, {
	"Nome": "Pará de Minas",
	"uf": "MG"
}, {
	"Nome": "Paracatu",
	"uf": "MG"
}, {
	"Nome": "Paraguaçu",
	"uf": "MG"
}, {
	"Nome": "Paraisópolis",
	"uf": "MG"
}, {
	"Nome": "Paraopeba",
	"uf": "MG"
}, {
	"Nome": "Passa Quatro",
	"uf": "MG"
}, {
	"Nome": "Passa Tempo",
	"uf": "MG"
}, {
	"Nome": "Passabém",
	"uf": "MG"
}, {
	"Nome": "Passa-Vinte",
	"uf": "MG"
}, {
	"Nome": "Passos",
	"uf": "MG"
}, {
	"Nome": "Patis",
	"uf": "MG"
}, {
	"Nome": "Patos de Minas",
	"uf": "MG"
}, {
	"Nome": "Patrocínio",
	"uf": "MG"
}, {
	"Nome": "Patrocínio do Muriaé",
	"uf": "MG"
}, {
	"Nome": "Paula Cândido",
	"uf": "MG"
}, {
	"Nome": "Paulistas",
	"uf": "MG"
}, {
	"Nome": "Pavão",
	"uf": "MG"
}, {
	"Nome": "Peçanha",
	"uf": "MG"
}, {
	"Nome": "Pedra Azul",
	"uf": "MG"
}, {
	"Nome": "Pedra Bonita",
	"uf": "MG"
}, {
	"Nome": "Pedra do Anta",
	"uf": "MG"
}, {
	"Nome": "Pedra do Indaiá",
	"uf": "MG"
}, {
	"Nome": "Pedra Dourada",
	"uf": "MG"
}, {
	"Nome": "Pedralva",
	"uf": "MG"
}, {
	"Nome": "Pedras de Maria da Cruz",
	"uf": "MG"
}, {
	"Nome": "Pedrinópolis",
	"uf": "MG"
}, {
	"Nome": "Pedro Leopoldo",
	"uf": "MG"
}, {
	"Nome": "Pedro Teixeira",
	"uf": "MG"
}, {
	"Nome": "Pequeri",
	"uf": "MG"
}, {
	"Nome": "Pequi",
	"uf": "MG"
}, {
	"Nome": "Perdigão",
	"uf": "MG"
}, {
	"Nome": "Perdizes",
	"uf": "MG"
}, {
	"Nome": "Perdões",
	"uf": "MG"
}, {
	"Nome": "Periquito",
	"uf": "MG"
}, {
	"Nome": "Pescador",
	"uf": "MG"
}, {
	"Nome": "Piau",
	"uf": "MG"
}, {
	"Nome": "Piedade de Caratinga",
	"uf": "MG"
}, {
	"Nome": "Piedade de Ponte Nova",
	"uf": "MG"
}, {
	"Nome": "Piedade do Rio Grande",
	"uf": "MG"
}, {
	"Nome": "Piedade dos Gerais",
	"uf": "MG"
}, {
	"Nome": "Pimenta",
	"uf": "MG"
}, {
	"Nome": "Pingo-d`Água",
	"uf": "MG"
}, {
	"Nome": "Pintópolis",
	"uf": "MG"
}, {
	"Nome": "Piracema",
	"uf": "MG"
}, {
	"Nome": "Pirajuba",
	"uf": "MG"
}, {
	"Nome": "Piranga",
	"uf": "MG"
}, {
	"Nome": "Piranguçu",
	"uf": "MG"
}, {
	"Nome": "Piranguinho",
	"uf": "MG"
}, {
	"Nome": "Pirapetinga",
	"uf": "MG"
}, {
	"Nome": "Pirapora",
	"uf": "MG"
}, {
	"Nome": "Piraúba",
	"uf": "MG"
}, {
	"Nome": "Pitangui",
	"uf": "MG"
}, {
	"Nome": "Piumhi",
	"uf": "MG"
}, {
	"Nome": "Planura",
	"uf": "MG"
}, {
	"Nome": "Poço Fundo",
	"uf": "MG"
}, {
	"Nome": "Poços de Caldas",
	"uf": "MG"
}, {
	"Nome": "Pocrane",
	"uf": "MG"
}, {
	"Nome": "Pompéu",
	"uf": "MG"
}, {
	"Nome": "Ponte Nova",
	"uf": "MG"
}, {
	"Nome": "Ponto Chique",
	"uf": "MG"
}, {
	"Nome": "Ponto dos Volantes",
	"uf": "MG"
}, {
	"Nome": "Porteirinha",
	"uf": "MG"
}, {
	"Nome": "Porto Firme",
	"uf": "MG"
}, {
	"Nome": "Poté",
	"uf": "MG"
}, {
	"Nome": "Pouso Alegre",
	"uf": "MG"
}, {
	"Nome": "Pouso Alto",
	"uf": "MG"
}, {
	"Nome": "Prados",
	"uf": "MG"
}, {
	"Nome": "Prata",
	"uf": "MG"
}, {
	"Nome": "Pratápolis",
	"uf": "MG"
}, {
	"Nome": "Pratinha",
	"uf": "MG"
}, {
	"Nome": "Presidente Bernardes",
	"uf": "MG"
}, {
	"Nome": "Presidente Juscelino",
	"uf": "MG"
}, {
	"Nome": "Presidente Kubitschek",
	"uf": "MG"
}, {
	"Nome": "Presidente Olegário",
	"uf": "MG"
}, {
	"Nome": "Prudente de Morais",
	"uf": "MG"
}, {
	"Nome": "Quartel Geral",
	"uf": "MG"
}, {
	"Nome": "Queluzito",
	"uf": "MG"
}, {
	"Nome": "Raposos",
	"uf": "MG"
}, {
	"Nome": "Raul Soares",
	"uf": "MG"
}, {
	"Nome": "Recreio",
	"uf": "MG"
}, {
	"Nome": "Reduto",
	"uf": "MG"
}, {
	"Nome": "Resende Costa",
	"uf": "MG"
}, {
	"Nome": "Resplendor",
	"uf": "MG"
}, {
	"Nome": "Ressaquinha",
	"uf": "MG"
}, {
	"Nome": "Riachinho",
	"uf": "MG"
}, {
	"Nome": "Riacho dos Machados",
	"uf": "MG"
}, {
	"Nome": "Ribeirão das Neves",
	"uf": "MG"
}, {
	"Nome": "Ribeirão Vermelho",
	"uf": "MG"
}, {
	"Nome": "Rio Acima",
	"uf": "MG"
}, {
	"Nome": "Rio Casca",
	"uf": "MG"
}, {
	"Nome": "Rio do Prado",
	"uf": "MG"
}, {
	"Nome": "Rio Doce",
	"uf": "MG"
}, {
	"Nome": "Rio Espera",
	"uf": "MG"
}, {
	"Nome": "Rio Manso",
	"uf": "MG"
}, {
	"Nome": "Rio Novo",
	"uf": "MG"
}, {
	"Nome": "Rio Paranaíba",
	"uf": "MG"
}, {
	"Nome": "Rio Pardo de Minas",
	"uf": "MG"
}, {
	"Nome": "Rio Piracicaba",
	"uf": "MG"
}, {
	"Nome": "Rio Pomba",
	"uf": "MG"
}, {
	"Nome": "Rio Preto",
	"uf": "MG"
}, {
	"Nome": "Rio Vermelho",
	"uf": "MG"
}, {
	"Nome": "Ritápolis",
	"uf": "MG"
}, {
	"Nome": "Rochedo de Minas",
	"uf": "MG"
}, {
	"Nome": "Rodeiro",
	"uf": "MG"
}, {
	"Nome": "Romaria",
	"uf": "MG"
}, {
	"Nome": "Rosário da Limeira",
	"uf": "MG"
}, {
	"Nome": "Rubelita",
	"uf": "MG"
}, {
	"Nome": "Rubim",
	"uf": "MG"
}, {
	"Nome": "Sabará",
	"uf": "MG"
}, {
	"Nome": "Sabinópolis",
	"uf": "MG"
}, {
	"Nome": "Sacramento",
	"uf": "MG"
}, {
	"Nome": "Salinas",
	"uf": "MG"
}, {
	"Nome": "Salto da Divisa",
	"uf": "MG"
}, {
	"Nome": "Santa Bárbara",
	"uf": "MG"
}, {
	"Nome": "Santa Bárbara do Leste",
	"uf": "MG"
}, {
	"Nome": "Santa Bárbara do Monte Verde",
	"uf": "MG"
}, {
	"Nome": "Santa Bárbara do Tugúrio",
	"uf": "MG"
}, {
	"Nome": "Santa Cruz de Minas",
	"uf": "MG"
}, {
	"Nome": "Santa Cruz de Salinas",
	"uf": "MG"
}, {
	"Nome": "Santa Cruz do Escalvado",
	"uf": "MG"
}, {
	"Nome": "Santa Efigênia de Minas",
	"uf": "MG"
}, {
	"Nome": "Santa Fé de Minas",
	"uf": "MG"
}, {
	"Nome": "Santa Helena de Minas",
	"uf": "MG"
}, {
	"Nome": "Santa Juliana",
	"uf": "MG"
}, {
	"Nome": "Santa Luzia",
	"uf": "MG"
}, {
	"Nome": "Santa Margarida",
	"uf": "MG"
}, {
	"Nome": "Santa Maria de Itabira",
	"uf": "MG"
}, {
	"Nome": "Santa Maria do Salto",
	"uf": "MG"
}, {
	"Nome": "Santa Maria do Suaçuí",
	"uf": "MG"
}, {
	"Nome": "Santa Rita de Caldas",
	"uf": "MG"
}, {
	"Nome": "Santa Rita de Ibitipoca",
	"uf": "MG"
}, {
	"Nome": "Santa Rita de Jacutinga",
	"uf": "MG"
}, {
	"Nome": "Santa Rita de Minas",
	"uf": "MG"
}, {
	"Nome": "Santa Rita do Itueto",
	"uf": "MG"
}, {
	"Nome": "Santa Rita do Sapucaí",
	"uf": "MG"
}, {
	"Nome": "Santa Rosa da Serra",
	"uf": "MG"
}, {
	"Nome": "Santa Vitória",
	"uf": "MG"
}, {
	"Nome": "Santana da Vargem",
	"uf": "MG"
}, {
	"Nome": "Santana de Cataguases",
	"uf": "MG"
}, {
	"Nome": "Santana de Pirapama",
	"uf": "MG"
}, {
	"Nome": "Santana do Deserto",
	"uf": "MG"
}, {
	"Nome": "Santana do Garambéu",
	"uf": "MG"
}, {
	"Nome": "Santana do Jacaré",
	"uf": "MG"
}, {
	"Nome": "Santana do Manhuaçu",
	"uf": "MG"
}, {
	"Nome": "Santana do Paraíso",
	"uf": "MG"
}, {
	"Nome": "Santana do Riacho",
	"uf": "MG"
}, {
	"Nome": "Santana dos Montes",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Amparo",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Aventureiro",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Grama",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Itambé",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Jacinto",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Monte",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Retiro",
	"uf": "MG"
}, {
	"Nome": "Santo Antônio do Rio Abaixo",
	"uf": "MG"
}, {
	"Nome": "Santo Hipólito",
	"uf": "MG"
}, {
	"Nome": "Santos Dumont",
	"uf": "MG"
}, {
	"Nome": "São Bento Abade",
	"uf": "MG"
}, {
	"Nome": "São Brás do Suaçuí",
	"uf": "MG"
}, {
	"Nome": "São Domingos das Dores",
	"uf": "MG"
}, {
	"Nome": "São Domingos do Prata",
	"uf": "MG"
}, {
	"Nome": "São Félix de Minas",
	"uf": "MG"
}, {
	"Nome": "São Francisco",
	"uf": "MG"
}, {
	"Nome": "São Francisco de Paula",
	"uf": "MG"
}, {
	"Nome": "São Francisco de Sales",
	"uf": "MG"
}, {
	"Nome": "São Francisco do Glória",
	"uf": "MG"
}, {
	"Nome": "São Geraldo",
	"uf": "MG"
}, {
	"Nome": "São Geraldo da Piedade",
	"uf": "MG"
}, {
	"Nome": "São Geraldo do Baixio",
	"uf": "MG"
}, {
	"Nome": "São Gonçalo do Abaeté",
	"uf": "MG"
}, {
	"Nome": "São Gonçalo do Pará",
	"uf": "MG"
}, {
	"Nome": "São Gonçalo do Rio Abaixo",
	"uf": "MG"
}, {
	"Nome": "São Gonçalo do Rio Preto",
	"uf": "MG"
}, {
	"Nome": "São Gonçalo do Sapucaí",
	"uf": "MG"
}, {
	"Nome": "São Gotardo",
	"uf": "MG"
}, {
	"Nome": "São João Batista do Glória",
	"uf": "MG"
}, {
	"Nome": "São João da Lagoa",
	"uf": "MG"
}, {
	"Nome": "São João da Mata",
	"uf": "MG"
}, {
	"Nome": "São João da Ponte",
	"uf": "MG"
}, {
	"Nome": "São João das Missões",
	"uf": "MG"
}, {
	"Nome": "São João del Rei",
	"uf": "MG"
}, {
	"Nome": "São João do Manhuaçu",
	"uf": "MG"
}, {
	"Nome": "São João do Manteninha",
	"uf": "MG"
}, {
	"Nome": "São João do Oriente",
	"uf": "MG"
}, {
	"Nome": "São João do Pacuí",
	"uf": "MG"
}, {
	"Nome": "São João do Paraíso",
	"uf": "MG"
}, {
	"Nome": "São João Evangelista",
	"uf": "MG"
}, {
	"Nome": "São João Nepomuceno",
	"uf": "MG"
}, {
	"Nome": "São Joaquim de Bicas",
	"uf": "MG"
}, {
	"Nome": "São José da Barra",
	"uf": "MG"
}, {
	"Nome": "São José da Lapa",
	"uf": "MG"
}, {
	"Nome": "São José da Safira",
	"uf": "MG"
}, {
	"Nome": "São José da Varginha",
	"uf": "MG"
}, {
	"Nome": "São José do Alegre",
	"uf": "MG"
}, {
	"Nome": "São José do Divino",
	"uf": "MG"
}, {
	"Nome": "São José do Goiabal",
	"uf": "MG"
}, {
	"Nome": "São José do Jacuri",
	"uf": "MG"
}, {
	"Nome": "São José do Mantimento",
	"uf": "MG"
}, {
	"Nome": "São Lourenço",
	"uf": "MG"
}, {
	"Nome": "São Miguel do Anta",
	"uf": "MG"
}, {
	"Nome": "São Pedro da União",
	"uf": "MG"
}, {
	"Nome": "São Pedro do Suaçuí",
	"uf": "MG"
}, {
	"Nome": "São Pedro dos Ferros",
	"uf": "MG"
}, {
	"Nome": "São Romão",
	"uf": "MG"
}, {
	"Nome": "São Roque de Minas",
	"uf": "MG"
}, {
	"Nome": "São Sebastião da Bela Vista",
	"uf": "MG"
}, {
	"Nome": "São Sebastião da Vargem Alegre",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Anta",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Maranhão",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Oeste",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Paraíso",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Rio Preto",
	"uf": "MG"
}, {
	"Nome": "São Sebastião do Rio Verde",
	"uf": "MG"
}, {
	"Nome": "São Thomé das Letras",
	"uf": "MG"
}, {
	"Nome": "São Tiago",
	"uf": "MG"
}, {
	"Nome": "São Tomás de Aquino",
	"uf": "MG"
}, {
	"Nome": "São Vicente de Minas",
	"uf": "MG"
}, {
	"Nome": "Sapucaí-Mirim",
	"uf": "MG"
}, {
	"Nome": "Sardoá",
	"uf": "MG"
}, {
	"Nome": "Sarzedo",
	"uf": "MG"
}, {
	"Nome": "Sem-Peixe",
	"uf": "MG"
}, {
	"Nome": "Senador Amaral",
	"uf": "MG"
}, {
	"Nome": "Senador Cortes",
	"uf": "MG"
}, {
	"Nome": "Senador Firmino",
	"uf": "MG"
}, {
	"Nome": "Senador José Bento",
	"uf": "MG"
}, {
	"Nome": "Senador Modestino Gonçalves",
	"uf": "MG"
}, {
	"Nome": "Senhora de Oliveira",
	"uf": "MG"
}, {
	"Nome": "Senhora do Porto",
	"uf": "MG"
}, {
	"Nome": "Senhora dos Remédios",
	"uf": "MG"
}, {
	"Nome": "Sericita",
	"uf": "MG"
}, {
	"Nome": "Seritinga",
	"uf": "MG"
}, {
	"Nome": "Serra Azul de Minas",
	"uf": "MG"
}, {
	"Nome": "Serra da Saudade",
	"uf": "MG"
}, {
	"Nome": "Serra do Salitre",
	"uf": "MG"
}, {
	"Nome": "Serra dos Aimorés",
	"uf": "MG"
}, {
	"Nome": "Serrania",
	"uf": "MG"
}, {
	"Nome": "Serranópolis de Minas",
	"uf": "MG"
}, {
	"Nome": "Serranos",
	"uf": "MG"
}, {
	"Nome": "Serro",
	"uf": "MG"
}, {
	"Nome": "Sete Lagoas",
	"uf": "MG"
}, {
	"Nome": "Setubinha",
	"uf": "MG"
}, {
	"Nome": "Silveirânia",
	"uf": "MG"
}, {
	"Nome": "Silvianópolis",
	"uf": "MG"
}, {
	"Nome": "Simão Pereira",
	"uf": "MG"
}, {
	"Nome": "Simonésia",
	"uf": "MG"
}, {
	"Nome": "Sobrália",
	"uf": "MG"
}, {
	"Nome": "Soledade de Minas",
	"uf": "MG"
}, {
	"Nome": "Tabuleiro",
	"uf": "MG"
}, {
	"Nome": "Taiobeiras",
	"uf": "MG"
}, {
	"Nome": "Taparuba",
	"uf": "MG"
}, {
	"Nome": "Tapira",
	"uf": "MG"
}, {
	"Nome": "Tapiraí",
	"uf": "MG"
}, {
	"Nome": "Taquaraçu de Minas",
	"uf": "MG"
}, {
	"Nome": "Tarumirim",
	"uf": "MG"
}, {
	"Nome": "Teixeiras",
	"uf": "MG"
}, {
	"Nome": "Teófilo Otoni",
	"uf": "MG"
}, {
	"Nome": "Timóteo",
	"uf": "MG"
}, {
	"Nome": "Tiradentes",
	"uf": "MG"
}, {
	"Nome": "Tiros",
	"uf": "MG"
}, {
	"Nome": "Tocantins",
	"uf": "MG"
}, {
	"Nome": "Tocos do Moji",
	"uf": "MG"
}, {
	"Nome": "Toledo",
	"uf": "MG"
}, {
	"Nome": "Tombos",
	"uf": "MG"
}, {
	"Nome": "Três Corações",
	"uf": "MG"
}, {
	"Nome": "Três Marias",
	"uf": "MG"
}, {
	"Nome": "Três Pontas",
	"uf": "MG"
}, {
	"Nome": "Tumiritinga",
	"uf": "MG"
}, {
	"Nome": "Tupaciguara",
	"uf": "MG"
}, {
	"Nome": "Turmalina",
	"uf": "MG"
}, {
	"Nome": "Turvolândia",
	"uf": "MG"
}, {
	"Nome": "Ubá",
	"uf": "MG"
}, {
	"Nome": "Ubaí",
	"uf": "MG"
}, {
	"Nome": "Ubaporanga",
	"uf": "MG"
}, {
	"Nome": "Uberaba",
	"uf": "MG"
}, {
	"Nome": "Uberlândia",
	"uf": "MG"
}, {
	"Nome": "Umburatiba",
	"uf": "MG"
}, {
	"Nome": "Unaí",
	"uf": "MG"
}, {
	"Nome": "União de Minas",
	"uf": "MG"
}, {
	"Nome": "Uruana de Minas",
	"uf": "MG"
}, {
	"Nome": "Urucânia",
	"uf": "MG"
}, {
	"Nome": "Urucuia",
	"uf": "MG"
}, {
	"Nome": "Vargem Alegre",
	"uf": "MG"
}, {
	"Nome": "Vargem Bonita",
	"uf": "MG"
}, {
	"Nome": "Vargem Grande do Rio Pardo",
	"uf": "MG"
}, {
	"Nome": "Varginha",
	"uf": "MG"
}, {
	"Nome": "Varjão de Minas",
	"uf": "MG"
}, {
	"Nome": "Várzea da Palma",
	"uf": "MG"
}, {
	"Nome": "Varzelândia",
	"uf": "MG"
}, {
	"Nome": "Vazante",
	"uf": "MG"
}, {
	"Nome": "Verdelândia",
	"uf": "MG"
}, {
	"Nome": "Veredinha",
	"uf": "MG"
}, {
	"Nome": "Veríssimo",
	"uf": "MG"
}, {
	"Nome": "Vermelho Novo",
	"uf": "MG"
}, {
	"Nome": "Vespasiano",
	"uf": "MG"
}, {
	"Nome": "Viçosa",
	"uf": "MG"
}, {
	"Nome": "Vieiras",
	"uf": "MG"
}, {
	"Nome": "Virgem da Lapa",
	"uf": "MG"
}, {
	"Nome": "Virgínia",
	"uf": "MG"
}, {
	"Nome": "Virginópolis",
	"uf": "MG"
}, {
	"Nome": "Virgolândia",
	"uf": "MG"
}, {
	"Nome": "Visconde do Rio Branco",
	"uf": "MG"
}, {
	"Nome": "Volta Grande",
	"uf": "MG"
}, {
	"Nome": "Wenceslau Braz",
	"uf": "MG"
}, {
	"Nome": "Abaetetuba",
	"uf": "PA"
}, {
	"Nome": "Abel Figueiredo",
	"uf": "PA"
}, {
	"Nome": "Acará",
	"uf": "PA"
}, {
	"Nome": "Afuá",
	"uf": "PA"
}, {
	"Nome": "Água Azul do Norte",
	"uf": "PA"
}, {
	"Nome": "Alenquer",
	"uf": "PA"
}, {
	"Nome": "Almeirim",
	"uf": "PA"
}, {
	"Nome": "Altamira",
	"uf": "PA"
}, {
	"Nome": "Anajás",
	"uf": "PA"
}, {
	"Nome": "Ananindeua",
	"uf": "PA"
}, {
	"Nome": "Anapu",
	"uf": "PA"
}, {
	"Nome": "Augusto Corrêa",
	"uf": "PA"
}, {
	"Nome": "Aurora do Pará",
	"uf": "PA"
}, {
	"Nome": "Aveiro",
	"uf": "PA"
}, {
	"Nome": "Bagre",
	"uf": "PA"
}, {
	"Nome": "Baião",
	"uf": "PA"
}, {
	"Nome": "Bannach",
	"uf": "PA"
}, {
	"Nome": "Barcarena",
	"uf": "PA"
}, {
	"Nome": "Belém",
	"uf": "PA"
}, {
	"Nome": "Belterra",
	"uf": "PA"
}, {
	"Nome": "Benevides",
	"uf": "PA"
}, {
	"Nome": "Bom Jesus do Tocantins",
	"uf": "PA"
}, {
	"Nome": "Bonito",
	"uf": "PA"
}, {
	"Nome": "Bragança",
	"uf": "PA"
}, {
	"Nome": "Brasil Novo",
	"uf": "PA"
}, {
	"Nome": "Brejo Grande do Araguaia",
	"uf": "PA"
}, {
	"Nome": "Breu Branco",
	"uf": "PA"
}, {
	"Nome": "Breves",
	"uf": "PA"
}, {
	"Nome": "Bujaru",
	"uf": "PA"
}, {
	"Nome": "Cachoeira do Arari",
	"uf": "PA"
}, {
	"Nome": "Cachoeira do Piriá",
	"uf": "PA"
}, {
	"Nome": "Cametá",
	"uf": "PA"
}, {
	"Nome": "Canaã dos Carajás",
	"uf": "PA"
}, {
	"Nome": "Capanema",
	"uf": "PA"
}, {
	"Nome": "Capitão Poço",
	"uf": "PA"
}, {
	"Nome": "Castanhal",
	"uf": "PA"
}, {
	"Nome": "Chaves",
	"uf": "PA"
}, {
	"Nome": "Colares",
	"uf": "PA"
}, {
	"Nome": "Conceição do Araguaia",
	"uf": "PA"
}, {
	"Nome": "Concórdia do Pará",
	"uf": "PA"
}, {
	"Nome": "Cumaru do Norte",
	"uf": "PA"
}, {
	"Nome": "Curionópolis",
	"uf": "PA"
}, {
	"Nome": "Curralinho",
	"uf": "PA"
}, {
	"Nome": "Curuá",
	"uf": "PA"
}, {
	"Nome": "Curuçá",
	"uf": "PA"
}, {
	"Nome": "Dom Eliseu",
	"uf": "PA"
}, {
	"Nome": "Eldorado dos Carajás",
	"uf": "PA"
}, {
	"Nome": "Faro",
	"uf": "PA"
}, {
	"Nome": "Floresta do Araguaia",
	"uf": "PA"
}, {
	"Nome": "Garrafão do Norte",
	"uf": "PA"
}, {
	"Nome": "Goianésia do Pará",
	"uf": "PA"
}, {
	"Nome": "Gurupá",
	"uf": "PA"
}, {
	"Nome": "Igarapé-Açu",
	"uf": "PA"
}, {
	"Nome": "Igarapé-Miri",
	"uf": "PA"
}, {
	"Nome": "Inhangapi",
	"uf": "PA"
}, {
	"Nome": "Ipixuna do Pará",
	"uf": "PA"
}, {
	"Nome": "Irituia",
	"uf": "PA"
}, {
	"Nome": "Itaituba",
	"uf": "PA"
}, {
	"Nome": "Itupiranga",
	"uf": "PA"
}, {
	"Nome": "Jacareacanga",
	"uf": "PA"
}, {
	"Nome": "Jacundá",
	"uf": "PA"
}, {
	"Nome": "Juruti",
	"uf": "PA"
}, {
	"Nome": "Limoeiro do Ajuru",
	"uf": "PA"
}, {
	"Nome": "Mãe do Rio",
	"uf": "PA"
}, {
	"Nome": "Magalhães Barata",
	"uf": "PA"
}, {
	"Nome": "Marabá",
	"uf": "PA"
}, {
	"Nome": "Maracanã",
	"uf": "PA"
}, {
	"Nome": "Marapanim",
	"uf": "PA"
}, {
	"Nome": "Marituba",
	"uf": "PA"
}, {
	"Nome": "Medicilândia",
	"uf": "PA"
}, {
	"Nome": "Melgaço",
	"uf": "PA"
}, {
	"Nome": "Mocajuba",
	"uf": "PA"
}, {
	"Nome": "Moju",
	"uf": "PA"
}, {
	"Nome": "Monte Alegre",
	"uf": "PA"
}, {
	"Nome": "Muaná",
	"uf": "PA"
}, {
	"Nome": "Nova Esperança do Piriá",
	"uf": "PA"
}, {
	"Nome": "Nova Ipixuna",
	"uf": "PA"
}, {
	"Nome": "Nova Timboteua",
	"uf": "PA"
}, {
	"Nome": "Novo Progresso",
	"uf": "PA"
}, {
	"Nome": "Novo Repartimento",
	"uf": "PA"
}, {
	"Nome": "Óbidos",
	"uf": "PA"
}, {
	"Nome": "Oeiras do Pará",
	"uf": "PA"
}, {
	"Nome": "Oriximiná",
	"uf": "PA"
}, {
	"Nome": "Ourém",
	"uf": "PA"
}, {
	"Nome": "Ourilândia do Norte",
	"uf": "PA"
}, {
	"Nome": "Pacajá",
	"uf": "PA"
}, {
	"Nome": "Palestina do Pará",
	"uf": "PA"
}, {
	"Nome": "Paragominas",
	"uf": "PA"
}, {
	"Nome": "Parauapebas",
	"uf": "PA"
}, {
	"Nome": "Pau d`Arco",
	"uf": "PA"
}, {
	"Nome": "Peixe-Boi",
	"uf": "PA"
}, {
	"Nome": "Piçarra",
	"uf": "PA"
}, {
	"Nome": "Placas",
	"uf": "PA"
}, {
	"Nome": "Ponta de Pedras",
	"uf": "PA"
}, {
	"Nome": "Portel",
	"uf": "PA"
}, {
	"Nome": "Porto de Moz",
	"uf": "PA"
}, {
	"Nome": "Prainha",
	"uf": "PA"
}, {
	"Nome": "Primavera",
	"uf": "PA"
}, {
	"Nome": "Quatipuru",
	"uf": "PA"
}, {
	"Nome": "Redenção",
	"uf": "PA"
}, {
	"Nome": "Rio Maria",
	"uf": "PA"
}, {
	"Nome": "Rondon do Pará",
	"uf": "PA"
}, {
	"Nome": "Rurópolis",
	"uf": "PA"
}, {
	"Nome": "Salinópolis",
	"uf": "PA"
}, {
	"Nome": "Salvaterra",
	"uf": "PA"
}, {
	"Nome": "Santa Bárbara do Pará",
	"uf": "PA"
}, {
	"Nome": "Santa Cruz do Arari",
	"uf": "PA"
}, {
	"Nome": "Santa Isabel do Pará",
	"uf": "PA"
}, {
	"Nome": "Santa Luzia do Pará",
	"uf": "PA"
}, {
	"Nome": "Santa Maria das Barreiras",
	"uf": "PA"
}, {
	"Nome": "Santa Maria do Pará",
	"uf": "PA"
}, {
	"Nome": "Santana do Araguaia",
	"uf": "PA"
}, {
	"Nome": "Santarém",
	"uf": "PA"
}, {
	"Nome": "Santarém Novo",
	"uf": "PA"
}, {
	"Nome": "Santo Antônio do Tauá",
	"uf": "PA"
}, {
	"Nome": "São Caetano de Odivelas",
	"uf": "PA"
}, {
	"Nome": "São Domingos do Araguaia",
	"uf": "PA"
}, {
	"Nome": "São Domingos do Capim",
	"uf": "PA"
}, {
	"Nome": "São Félix do Xingu",
	"uf": "PA"
}, {
	"Nome": "São Francisco do Pará",
	"uf": "PA"
}, {
	"Nome": "São Geraldo do Araguaia",
	"uf": "PA"
}, {
	"Nome": "São João da Ponta",
	"uf": "PA"
}, {
	"Nome": "São João de Pirabas",
	"uf": "PA"
}, {
	"Nome": "São João do Araguaia",
	"uf": "PA"
}, {
	"Nome": "São Miguel do Guamá",
	"uf": "PA"
}, {
	"Nome": "São Sebastião da Boa Vista",
	"uf": "PA"
}, {
	"Nome": "Sapucaia",
	"uf": "PA"
}, {
	"Nome": "Senador José Porfírio",
	"uf": "PA"
}, {
	"Nome": "Soure",
	"uf": "PA"
}, {
	"Nome": "Tailândia",
	"uf": "PA"
}, {
	"Nome": "Terra Alta",
	"uf": "PA"
}, {
	"Nome": "Terra Santa",
	"uf": "PA"
}, {
	"Nome": "Tomé-Açu",
	"uf": "PA"
}, {
	"Nome": "Tracuateua",
	"uf": "PA"
}, {
	"Nome": "Trairão",
	"uf": "PA"
}, {
	"Nome": "Tucumã",
	"uf": "PA"
}, {
	"Nome": "Tucuruí",
	"uf": "PA"
}, {
	"Nome": "Ulianópolis",
	"uf": "PA"
}, {
	"Nome": "Uruará",
	"uf": "PA"
}, {
	"Nome": "Vigia",
	"uf": "PA"
}, {
	"Nome": "Viseu",
	"uf": "PA"
}, {
	"Nome": "Vitória do Xingu",
	"uf": "PA"
}, {
	"Nome": "Xinguara",
	"uf": "PA"
}, {
	"Nome": "Água Branca",
	"uf": "PB"
}, {
	"Nome": "Aguiar",
	"uf": "PB"
}, {
	"Nome": "Alagoa Grande",
	"uf": "PB"
}, {
	"Nome": "Alagoa Nova",
	"uf": "PB"
}, {
	"Nome": "Alagoinha",
	"uf": "PB"
}, {
	"Nome": "Alcantil",
	"uf": "PB"
}, {
	"Nome": "Algodão de Jandaíra",
	"uf": "PB"
}, {
	"Nome": "Alhandra",
	"uf": "PB"
}, {
	"Nome": "Amparo",
	"uf": "PB"
}, {
	"Nome": "Aparecida",
	"uf": "PB"
}, {
	"Nome": "Araçagi",
	"uf": "PB"
}, {
	"Nome": "Arara",
	"uf": "PB"
}, {
	"Nome": "Araruna",
	"uf": "PB"
}, {
	"Nome": "Areia",
	"uf": "PB"
}, {
	"Nome": "Areia de Baraúnas",
	"uf": "PB"
}, {
	"Nome": "Areial",
	"uf": "PB"
}, {
	"Nome": "Aroeiras",
	"uf": "PB"
}, {
	"Nome": "Assunção",
	"uf": "PB"
}, {
	"Nome": "Baía da Traição",
	"uf": "PB"
}, {
	"Nome": "Bananeiras",
	"uf": "PB"
}, {
	"Nome": "Baraúna",
	"uf": "PB"
}, {
	"Nome": "Barra de Santa Rosa",
	"uf": "PB"
}, {
	"Nome": "Barra de Santana",
	"uf": "PB"
}, {
	"Nome": "Barra de São Miguel",
	"uf": "PB"
}, {
	"Nome": "Bayeux",
	"uf": "PB"
}, {
	"Nome": "Belém",
	"uf": "PB"
}, {
	"Nome": "Belém do Brejo do Cruz",
	"uf": "PB"
}, {
	"Nome": "Bernardino Batista",
	"uf": "PB"
}, {
	"Nome": "Boa Ventura",
	"uf": "PB"
}, {
	"Nome": "Boa Vista",
	"uf": "PB"
}, {
	"Nome": "Bom Jesus",
	"uf": "PB"
}, {
	"Nome": "Bom Sucesso",
	"uf": "PB"
}, {
	"Nome": "Bonito de Santa Fé",
	"uf": "PB"
}, {
	"Nome": "Boqueirão",
	"uf": "PB"
}, {
	"Nome": "Borborema",
	"uf": "PB"
}, {
	"Nome": "Brejo do Cruz",
	"uf": "PB"
}, {
	"Nome": "Brejo dos Santos",
	"uf": "PB"
}, {
	"Nome": "Caaporã",
	"uf": "PB"
}, {
	"Nome": "Cabaceiras",
	"uf": "PB"
}, {
	"Nome": "Cabedelo",
	"uf": "PB"
}, {
	"Nome": "Cachoeira dos Índios",
	"uf": "PB"
}, {
	"Nome": "Cacimba de Areia",
	"uf": "PB"
}, {
	"Nome": "Cacimba de Dentro",
	"uf": "PB"
}, {
	"Nome": "Cacimbas",
	"uf": "PB"
}, {
	"Nome": "Caiçara",
	"uf": "PB"
}, {
	"Nome": "Cajazeiras",
	"uf": "PB"
}, {
	"Nome": "Cajazeirinhas",
	"uf": "PB"
}, {
	"Nome": "Caldas Brandão",
	"uf": "PB"
}, {
	"Nome": "Camalaú",
	"uf": "PB"
}, {
	"Nome": "Campina Grande",
	"uf": "PB"
}, {
	"Nome": "Campo de Santana",
	"uf": "PB"
}, {
	"Nome": "Capim",
	"uf": "PB"
}, {
	"Nome": "Caraúbas",
	"uf": "PB"
}, {
	"Nome": "Carrapateira",
	"uf": "PB"
}, {
	"Nome": "Casserengue",
	"uf": "PB"
}, {
	"Nome": "Catingueira",
	"uf": "PB"
}, {
	"Nome": "Catolé do Rocha",
	"uf": "PB"
}, {
	"Nome": "Caturité",
	"uf": "PB"
}, {
	"Nome": "Conceição",
	"uf": "PB"
}, {
	"Nome": "Condado",
	"uf": "PB"
}, {
	"Nome": "Conde",
	"uf": "PB"
}, {
	"Nome": "Congo",
	"uf": "PB"
}, {
	"Nome": "Coremas",
	"uf": "PB"
}, {
	"Nome": "Coxixola",
	"uf": "PB"
}, {
	"Nome": "Cruz do Espírito Santo",
	"uf": "PB"
}, {
	"Nome": "Cubati",
	"uf": "PB"
}, {
	"Nome": "Cuité",
	"uf": "PB"
}, {
	"Nome": "Cuité de Mamanguape",
	"uf": "PB"
}, {
	"Nome": "Cuitegi",
	"uf": "PB"
}, {
	"Nome": "Curral de Cima",
	"uf": "PB"
}, {
	"Nome": "Curral Velho",
	"uf": "PB"
}, {
	"Nome": "Damião",
	"uf": "PB"
}, {
	"Nome": "Desterro",
	"uf": "PB"
}, {
	"Nome": "Diamante",
	"uf": "PB"
}, {
	"Nome": "Dona Inês",
	"uf": "PB"
}, {
	"Nome": "Duas Estradas",
	"uf": "PB"
}, {
	"Nome": "Emas",
	"uf": "PB"
}, {
	"Nome": "Esperança",
	"uf": "PB"
}, {
	"Nome": "Fagundes",
	"uf": "PB"
}, {
	"Nome": "Frei Martinho",
	"uf": "PB"
}, {
	"Nome": "Gado Bravo",
	"uf": "PB"
}, {
	"Nome": "Guarabira",
	"uf": "PB"
}, {
	"Nome": "Gurinhém",
	"uf": "PB"
}, {
	"Nome": "Gurjão",
	"uf": "PB"
}, {
	"Nome": "Ibiara",
	"uf": "PB"
}, {
	"Nome": "Igaracy",
	"uf": "PB"
}, {
	"Nome": "Imaculada",
	"uf": "PB"
}, {
	"Nome": "Ingá",
	"uf": "PB"
}, {
	"Nome": "Itabaiana",
	"uf": "PB"
}, {
	"Nome": "Itaporanga",
	"uf": "PB"
}, {
	"Nome": "Itapororoca",
	"uf": "PB"
}, {
	"Nome": "Itatuba",
	"uf": "PB"
}, {
	"Nome": "Jacaraú",
	"uf": "PB"
}, {
	"Nome": "Jericó",
	"uf": "PB"
}, {
	"Nome": "João Pessoa",
	"uf": "PB"
}, {
	"Nome": "Juarez Távora",
	"uf": "PB"
}, {
	"Nome": "Juazeirinho",
	"uf": "PB"
}, {
	"Nome": "Junco do Seridó",
	"uf": "PB"
}, {
	"Nome": "Juripiranga",
	"uf": "PB"
}, {
	"Nome": "Juru",
	"uf": "PB"
}, {
	"Nome": "Lagoa",
	"uf": "PB"
}, {
	"Nome": "Lagoa de Dentro",
	"uf": "PB"
}, {
	"Nome": "Lagoa Seca",
	"uf": "PB"
}, {
	"Nome": "Lastro",
	"uf": "PB"
}, {
	"Nome": "Livramento",
	"uf": "PB"
}, {
	"Nome": "Logradouro",
	"uf": "PB"
}, {
	"Nome": "Lucena",
	"uf": "PB"
}, {
	"Nome": "Mãe d`Água",
	"uf": "PB"
}, {
	"Nome": "Malta",
	"uf": "PB"
}, {
	"Nome": "Mamanguape",
	"uf": "PB"
}, {
	"Nome": "Manaíra",
	"uf": "PB"
}, {
	"Nome": "Marcação",
	"uf": "PB"
}, {
	"Nome": "Mari",
	"uf": "PB"
}, {
	"Nome": "Marizópolis",
	"uf": "PB"
}, {
	"Nome": "Massaranduba",
	"uf": "PB"
}, {
	"Nome": "Mataraca",
	"uf": "PB"
}, {
	"Nome": "Matinhas",
	"uf": "PB"
}, {
	"Nome": "Mato Grosso",
	"uf": "PB"
}, {
	"Nome": "Maturéia",
	"uf": "PB"
}, {
	"Nome": "Mogeiro",
	"uf": "PB"
}, {
	"Nome": "Montadas",
	"uf": "PB"
}, {
	"Nome": "Monte Horebe",
	"uf": "PB"
}, {
	"Nome": "Monteiro",
	"uf": "PB"
}, {
	"Nome": "Mulungu",
	"uf": "PB"
}, {
	"Nome": "Natuba",
	"uf": "PB"
}, {
	"Nome": "Nazarezinho",
	"uf": "PB"
}, {
	"Nome": "Nova Floresta",
	"uf": "PB"
}, {
	"Nome": "Nova Olinda",
	"uf": "PB"
}, {
	"Nome": "Nova Palmeira",
	"uf": "PB"
}, {
	"Nome": "Olho d`Água",
	"uf": "PB"
}, {
	"Nome": "Olivedos",
	"uf": "PB"
}, {
	"Nome": "Ouro Velho",
	"uf": "PB"
}, {
	"Nome": "Parari",
	"uf": "PB"
}, {
	"Nome": "Passagem",
	"uf": "PB"
}, {
	"Nome": "Patos",
	"uf": "PB"
}, {
	"Nome": "Paulista",
	"uf": "PB"
}, {
	"Nome": "Pedra Branca",
	"uf": "PB"
}, {
	"Nome": "Pedra Lavrada",
	"uf": "PB"
}, {
	"Nome": "Pedras de Fogo",
	"uf": "PB"
}, {
	"Nome": "Pedro Régis",
	"uf": "PB"
}, {
	"Nome": "Piancó",
	"uf": "PB"
}, {
	"Nome": "Picuí",
	"uf": "PB"
}, {
	"Nome": "Pilar",
	"uf": "PB"
}, {
	"Nome": "Pilões",
	"uf": "PB"
}, {
	"Nome": "Pilõezinhos",
	"uf": "PB"
}, {
	"Nome": "Pirpirituba",
	"uf": "PB"
}, {
	"Nome": "Pitimbu",
	"uf": "PB"
}, {
	"Nome": "Pocinhos",
	"uf": "PB"
}, {
	"Nome": "Poço Dantas",
	"uf": "PB"
}, {
	"Nome": "Poço de José de Moura",
	"uf": "PB"
}, {
	"Nome": "Pombal",
	"uf": "PB"
}, {
	"Nome": "Prata",
	"uf": "PB"
}, {
	"Nome": "Princesa Isabel",
	"uf": "PB"
}, {
	"Nome": "Puxinanã",
	"uf": "PB"
}, {
	"Nome": "Queimadas",
	"uf": "PB"
}, {
	"Nome": "Quixabá",
	"uf": "PB"
}, {
	"Nome": "Remígio",
	"uf": "PB"
}, {
	"Nome": "Riachão",
	"uf": "PB"
}, {
	"Nome": "Riachão do Bacamarte",
	"uf": "PB"
}, {
	"Nome": "Riachão do Poço",
	"uf": "PB"
}, {
	"Nome": "Riacho de Santo Antônio",
	"uf": "PB"
}, {
	"Nome": "Riacho dos Cavalos",
	"uf": "PB"
}, {
	"Nome": "Rio Tinto",
	"uf": "PB"
}, {
	"Nome": "Salgadinho",
	"uf": "PB"
}, {
	"Nome": "Salgado de São Félix",
	"uf": "PB"
}, {
	"Nome": "Santa Cecília",
	"uf": "PB"
}, {
	"Nome": "Santa Cruz",
	"uf": "PB"
}, {
	"Nome": "Santa Helena",
	"uf": "PB"
}, {
	"Nome": "Santa Inês",
	"uf": "PB"
}, {
	"Nome": "Santa Luzia",
	"uf": "PB"
}, {
	"Nome": "Santa Rita",
	"uf": "PB"
}, {
	"Nome": "Santa Teresinha",
	"uf": "PB"
}, {
	"Nome": "Santana de Mangueira",
	"uf": "PB"
}, {
	"Nome": "Santana dos Garrotes",
	"uf": "PB"
}, {
	"Nome": "Santarém",
	"uf": "PB"
}, {
	"Nome": "Santo André",
	"uf": "PB"
}, {
	"Nome": "São Bentinho",
	"uf": "PB"
}, {
	"Nome": "São Bento",
	"uf": "PB"
}, {
	"Nome": "São Domingos de Pombal",
	"uf": "PB"
}, {
	"Nome": "São Domingos do Cariri",
	"uf": "PB"
}, {
	"Nome": "São Francisco",
	"uf": "PB"
}, {
	"Nome": "São João do Cariri",
	"uf": "PB"
}, {
	"Nome": "São João do Rio do Peixe",
	"uf": "PB"
}, {
	"Nome": "São João do Tigre",
	"uf": "PB"
}, {
	"Nome": "São José da Lagoa Tapada",
	"uf": "PB"
}, {
	"Nome": "São José de Caiana",
	"uf": "PB"
}, {
	"Nome": "São José de Espinharas",
	"uf": "PB"
}, {
	"Nome": "São José de Piranhas",
	"uf": "PB"
}, {
	"Nome": "São José de Princesa",
	"uf": "PB"
}, {
	"Nome": "São José do Bonfim",
	"uf": "PB"
}, {
	"Nome": "São José do Brejo do Cruz",
	"uf": "PB"
}, {
	"Nome": "São José do Sabugi",
	"uf": "PB"
}, {
	"Nome": "São José dos Cordeiros",
	"uf": "PB"
}, {
	"Nome": "São José dos Ramos",
	"uf": "PB"
}, {
	"Nome": "São Mamede",
	"uf": "PB"
}, {
	"Nome": "São Miguel de Taipu",
	"uf": "PB"
}, {
	"Nome": "São Sebastião de Lagoa de Roça",
	"uf": "PB"
}, {
	"Nome": "São Sebastião do Umbuzeiro",
	"uf": "PB"
}, {
	"Nome": "Sapé",
	"uf": "PB"
}, {
	"Nome": "Seridó",
	"uf": "PB"
}, {
	"Nome": "Serra Branca",
	"uf": "PB"
}, {
	"Nome": "Serra da Raiz",
	"uf": "PB"
}, {
	"Nome": "Serra Grande",
	"uf": "PB"
}, {
	"Nome": "Serra Redonda",
	"uf": "PB"
}, {
	"Nome": "Serraria",
	"uf": "PB"
}, {
	"Nome": "Sertãozinho",
	"uf": "PB"
}, {
	"Nome": "Sobrado",
	"uf": "PB"
}, {
	"Nome": "Solânea",
	"uf": "PB"
}, {
	"Nome": "Soledade",
	"uf": "PB"
}, {
	"Nome": "Sossêgo",
	"uf": "PB"
}, {
	"Nome": "Sousa",
	"uf": "PB"
}, {
	"Nome": "Sumé",
	"uf": "PB"
}, {
	"Nome": "Taperoá",
	"uf": "PB"
}, {
	"Nome": "Tavares",
	"uf": "PB"
}, {
	"Nome": "Teixeira",
	"uf": "PB"
}, {
	"Nome": "Tenório",
	"uf": "PB"
}, {
	"Nome": "Triunfo",
	"uf": "PB"
}, {
	"Nome": "Uiraúna",
	"uf": "PB"
}, {
	"Nome": "Umbuzeiro",
	"uf": "PB"
}, {
	"Nome": "Várzea",
	"uf": "PB"
}, {
	"Nome": "Vieirópolis",
	"uf": "PB"
}, {
	"Nome": "Vista Serrana",
	"uf": "PB"
}, {
	"Nome": "Zabelê",
	"uf": "PB"
}, {
	"Nome": "Abatiá",
	"uf": "PR"
}, {
	"Nome": "Adrianópolis",
	"uf": "PR"
}, {
	"Nome": "Agudos do Sul",
	"uf": "PR"
}, {
	"Nome": "Almirante Tamandaré",
	"uf": "PR"
}, {
	"Nome": "Altamira do Paraná",
	"uf": "PR"
}, {
	"Nome": "Alto Paraíso",
	"uf": "PR"
}, {
	"Nome": "Alto Paraná",
	"uf": "PR"
}, {
	"Nome": "Alto Piquiri",
	"uf": "PR"
}, {
	"Nome": "Altônia",
	"uf": "PR"
}, {
	"Nome": "Alvorada do Sul",
	"uf": "PR"
}, {
	"Nome": "Amaporã",
	"uf": "PR"
}, {
	"Nome": "Ampére",
	"uf": "PR"
}, {
	"Nome": "Anahy",
	"uf": "PR"
}, {
	"Nome": "Andirá",
	"uf": "PR"
}, {
	"Nome": "Ângulo",
	"uf": "PR"
}, {
	"Nome": "Antonina",
	"uf": "PR"
}, {
	"Nome": "Antônio Olinto",
	"uf": "PR"
}, {
	"Nome": "Apucarana",
	"uf": "PR"
}, {
	"Nome": "Arapongas",
	"uf": "PR"
}, {
	"Nome": "Arapoti",
	"uf": "PR"
}, {
	"Nome": "Arapuã",
	"uf": "PR"
}, {
	"Nome": "Araruna",
	"uf": "PR"
}, {
	"Nome": "Araucária",
	"uf": "PR"
}, {
	"Nome": "Ariranha do Ivaí",
	"uf": "PR"
}, {
	"Nome": "Assaí",
	"uf": "PR"
}, {
	"Nome": "Assis Chateaubriand",
	"uf": "PR"
}, {
	"Nome": "Astorga",
	"uf": "PR"
}, {
	"Nome": "Atalaia",
	"uf": "PR"
}, {
	"Nome": "Balsa Nova",
	"uf": "PR"
}, {
	"Nome": "Bandeirantes",
	"uf": "PR"
}, {
	"Nome": "Barbosa Ferraz",
	"uf": "PR"
}, {
	"Nome": "Barra do Jacaré",
	"uf": "PR"
}, {
	"Nome": "Barracão",
	"uf": "PR"
}, {
	"Nome": "Bela Vista da Caroba",
	"uf": "PR"
}, {
	"Nome": "Bela Vista do Paraíso",
	"uf": "PR"
}, {
	"Nome": "Bituruna",
	"uf": "PR"
}, {
	"Nome": "Boa Esperança",
	"uf": "PR"
}, {
	"Nome": "Boa Esperança do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Boa Ventura de São Roque",
	"uf": "PR"
}, {
	"Nome": "Boa Vista da Aparecida",
	"uf": "PR"
}, {
	"Nome": "Bocaiúva do Sul",
	"uf": "PR"
}, {
	"Nome": "Bom Jesus do Sul",
	"uf": "PR"
}, {
	"Nome": "Bom Sucesso",
	"uf": "PR"
}, {
	"Nome": "Bom Sucesso do Sul",
	"uf": "PR"
}, {
	"Nome": "Borrazópolis",
	"uf": "PR"
}, {
	"Nome": "Braganey",
	"uf": "PR"
}, {
	"Nome": "Brasilândia do Sul",
	"uf": "PR"
}, {
	"Nome": "Cafeara",
	"uf": "PR"
}, {
	"Nome": "Cafelândia",
	"uf": "PR"
}, {
	"Nome": "Cafezal do Sul",
	"uf": "PR"
}, {
	"Nome": "Califórnia",
	"uf": "PR"
}, {
	"Nome": "Cambará",
	"uf": "PR"
}, {
	"Nome": "Cambé",
	"uf": "PR"
}, {
	"Nome": "Cambira",
	"uf": "PR"
}, {
	"Nome": "Campina da Lagoa",
	"uf": "PR"
}, {
	"Nome": "Campina do Simão",
	"uf": "PR"
}, {
	"Nome": "Campina Grande do Sul",
	"uf": "PR"
}, {
	"Nome": "Campo Bonito",
	"uf": "PR"
}, {
	"Nome": "Campo do Tenente",
	"uf": "PR"
}, {
	"Nome": "Campo Largo",
	"uf": "PR"
}, {
	"Nome": "Campo Magro",
	"uf": "PR"
}, {
	"Nome": "Campo Mourão",
	"uf": "PR"
}, {
	"Nome": "Cândido de Abreu",
	"uf": "PR"
}, {
	"Nome": "Candói",
	"uf": "PR"
}, {
	"Nome": "Cantagalo",
	"uf": "PR"
}, {
	"Nome": "Capanema",
	"uf": "PR"
}, {
	"Nome": "Capitão Leônidas Marques",
	"uf": "PR"
}, {
	"Nome": "Carambeí",
	"uf": "PR"
}, {
	"Nome": "Carlópolis",
	"uf": "PR"
}, {
	"Nome": "Cascavel",
	"uf": "PR"
}, {
	"Nome": "Castro",
	"uf": "PR"
}, {
	"Nome": "Catanduvas",
	"uf": "PR"
}, {
	"Nome": "Centenário do Sul",
	"uf": "PR"
}, {
	"Nome": "Cerro Azul",
	"uf": "PR"
}, {
	"Nome": "Céu Azul",
	"uf": "PR"
}, {
	"Nome": "Chopinzinho",
	"uf": "PR"
}, {
	"Nome": "Cianorte",
	"uf": "PR"
}, {
	"Nome": "Cidade Gaúcha",
	"uf": "PR"
}, {
	"Nome": "Clevelândia",
	"uf": "PR"
}, {
	"Nome": "Colombo",
	"uf": "PR"
}, {
	"Nome": "Colorado",
	"uf": "PR"
}, {
	"Nome": "Congonhinhas",
	"uf": "PR"
}, {
	"Nome": "Conselheiro Mairinck",
	"uf": "PR"
}, {
	"Nome": "Contenda",
	"uf": "PR"
}, {
	"Nome": "Corbélia",
	"uf": "PR"
}, {
	"Nome": "Cornélio Procópio",
	"uf": "PR"
}, {
	"Nome": "Coronel Domingos Soares",
	"uf": "PR"
}, {
	"Nome": "Coronel Vivida",
	"uf": "PR"
}, {
	"Nome": "Corumbataí do Sul",
	"uf": "PR"
}, {
	"Nome": "Cruz Machado",
	"uf": "PR"
}, {
	"Nome": "Cruzeiro do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Cruzeiro do Oeste",
	"uf": "PR"
}, {
	"Nome": "Cruzeiro do Sul",
	"uf": "PR"
}, {
	"Nome": "Cruzmaltina",
	"uf": "PR"
}, {
	"Nome": "Curitiba",
	"uf": "PR"
}, {
	"Nome": "Curiúva",
	"uf": "PR"
}, {
	"Nome": "Diamante d`Oeste",
	"uf": "PR"
}, {
	"Nome": "Diamante do Norte",
	"uf": "PR"
}, {
	"Nome": "Diamante do Sul",
	"uf": "PR"
}, {
	"Nome": "Dois Vizinhos",
	"uf": "PR"
}, {
	"Nome": "Douradina",
	"uf": "PR"
}, {
	"Nome": "Doutor Camargo",
	"uf": "PR"
}, {
	"Nome": "Doutor Ulysses",
	"uf": "PR"
}, {
	"Nome": "Enéas Marques",
	"uf": "PR"
}, {
	"Nome": "Engenheiro Beltrão",
	"uf": "PR"
}, {
	"Nome": "Entre Rios do Oeste",
	"uf": "PR"
}, {
	"Nome": "Esperança Nova",
	"uf": "PR"
}, {
	"Nome": "Espigão Alto do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Farol",
	"uf": "PR"
}, {
	"Nome": "Faxinal",
	"uf": "PR"
}, {
	"Nome": "Fazenda Rio Grande",
	"uf": "PR"
}, {
	"Nome": "Fênix",
	"uf": "PR"
}, {
	"Nome": "Fernandes Pinheiro",
	"uf": "PR"
}, {
	"Nome": "Figueira",
	"uf": "PR"
}, {
	"Nome": "Flor da Serra do Sul",
	"uf": "PR"
}, {
	"Nome": "Floraí",
	"uf": "PR"
}, {
	"Nome": "Floresta",
	"uf": "PR"
}, {
	"Nome": "Florestópolis",
	"uf": "PR"
}, {
	"Nome": "Flórida",
	"uf": "PR"
}, {
	"Nome": "Formosa do Oeste",
	"uf": "PR"
}, {
	"Nome": "Foz do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Foz do Jordão",
	"uf": "PR"
}, {
	"Nome": "Francisco Alves",
	"uf": "PR"
}, {
	"Nome": "Francisco Beltrão",
	"uf": "PR"
}, {
	"Nome": "General Carneiro",
	"uf": "PR"
}, {
	"Nome": "Godoy Moreira",
	"uf": "PR"
}, {
	"Nome": "Goioerê",
	"uf": "PR"
}, {
	"Nome": "Goioxim",
	"uf": "PR"
}, {
	"Nome": "Grandes Rios",
	"uf": "PR"
}, {
	"Nome": "Guaíra",
	"uf": "PR"
}, {
	"Nome": "Guairaçá",
	"uf": "PR"
}, {
	"Nome": "Guamiranga",
	"uf": "PR"
}, {
	"Nome": "Guapirama",
	"uf": "PR"
}, {
	"Nome": "Guaporema",
	"uf": "PR"
}, {
	"Nome": "Guaraci",
	"uf": "PR"
}, {
	"Nome": "Guaraniaçu",
	"uf": "PR"
}, {
	"Nome": "Guarapuava",
	"uf": "PR"
}, {
	"Nome": "Guaraqueçaba",
	"uf": "PR"
}, {
	"Nome": "Guaratuba",
	"uf": "PR"
}, {
	"Nome": "Honório Serpa",
	"uf": "PR"
}, {
	"Nome": "Ibaiti",
	"uf": "PR"
}, {
	"Nome": "Ibema",
	"uf": "PR"
}, {
	"Nome": "Ibiporã",
	"uf": "PR"
}, {
	"Nome": "Icaraíma",
	"uf": "PR"
}, {
	"Nome": "Iguaraçu",
	"uf": "PR"
}, {
	"Nome": "Iguatu",
	"uf": "PR"
}, {
	"Nome": "Imbaú",
	"uf": "PR"
}, {
	"Nome": "Imbituva",
	"uf": "PR"
}, {
	"Nome": "Inácio Martins",
	"uf": "PR"
}, {
	"Nome": "Inajá",
	"uf": "PR"
}, {
	"Nome": "Indianópolis",
	"uf": "PR"
}, {
	"Nome": "Ipiranga",
	"uf": "PR"
}, {
	"Nome": "Iporã",
	"uf": "PR"
}, {
	"Nome": "Iracema do Oeste",
	"uf": "PR"
}, {
	"Nome": "Irati",
	"uf": "PR"
}, {
	"Nome": "Iretama",
	"uf": "PR"
}, {
	"Nome": "Itaguajé",
	"uf": "PR"
}, {
	"Nome": "Itaipulândia",
	"uf": "PR"
}, {
	"Nome": "Itambaracá",
	"uf": "PR"
}, {
	"Nome": "Itambé",
	"uf": "PR"
}, {
	"Nome": "Itapejara d`Oeste",
	"uf": "PR"
}, {
	"Nome": "Itaperuçu",
	"uf": "PR"
}, {
	"Nome": "Itaúna do Sul",
	"uf": "PR"
}, {
	"Nome": "Ivaí",
	"uf": "PR"
}, {
	"Nome": "Ivaiporã",
	"uf": "PR"
}, {
	"Nome": "Ivaté",
	"uf": "PR"
}, {
	"Nome": "Ivatuba",
	"uf": "PR"
}, {
	"Nome": "Jaboti",
	"uf": "PR"
}, {
	"Nome": "Jacarezinho",
	"uf": "PR"
}, {
	"Nome": "Jaguapitã",
	"uf": "PR"
}, {
	"Nome": "Jaguariaíva",
	"uf": "PR"
}, {
	"Nome": "Jandaia do Sul",
	"uf": "PR"
}, {
	"Nome": "Janiópolis",
	"uf": "PR"
}, {
	"Nome": "Japira",
	"uf": "PR"
}, {
	"Nome": "Japurá",
	"uf": "PR"
}, {
	"Nome": "Jardim Alegre",
	"uf": "PR"
}, {
	"Nome": "Jardim Olinda",
	"uf": "PR"
}, {
	"Nome": "Jataizinho",
	"uf": "PR"
}, {
	"Nome": "Jesuítas",
	"uf": "PR"
}, {
	"Nome": "Joaquim Távora",
	"uf": "PR"
}, {
	"Nome": "Jundiaí do Sul",
	"uf": "PR"
}, {
	"Nome": "Juranda",
	"uf": "PR"
}, {
	"Nome": "Jussara",
	"uf": "PR"
}, {
	"Nome": "Kaloré",
	"uf": "PR"
}, {
	"Nome": "Lapa",
	"uf": "PR"
}, {
	"Nome": "Laranjal",
	"uf": "PR"
}, {
	"Nome": "Laranjeiras do Sul",
	"uf": "PR"
}, {
	"Nome": "Leópolis",
	"uf": "PR"
}, {
	"Nome": "Lidianópolis",
	"uf": "PR"
}, {
	"Nome": "Lindoeste",
	"uf": "PR"
}, {
	"Nome": "Loanda",
	"uf": "PR"
}, {
	"Nome": "Lobato",
	"uf": "PR"
}, {
	"Nome": "Londrina",
	"uf": "PR"
}, {
	"Nome": "Luiziana",
	"uf": "PR"
}, {
	"Nome": "Lunardelli",
	"uf": "PR"
}, {
	"Nome": "Lupionópolis",
	"uf": "PR"
}, {
	"Nome": "Mallet",
	"uf": "PR"
}, {
	"Nome": "Mamborê",
	"uf": "PR"
}, {
	"Nome": "Mandaguaçu",
	"uf": "PR"
}, {
	"Nome": "Mandaguari",
	"uf": "PR"
}, {
	"Nome": "Mandirituba",
	"uf": "PR"
}, {
	"Nome": "Manfrinópolis",
	"uf": "PR"
}, {
	"Nome": "Mangueirinha",
	"uf": "PR"
}, {
	"Nome": "Manoel Ribas",
	"uf": "PR"
}, {
	"Nome": "Marechal Cândido Rondon",
	"uf": "PR"
}, {
	"Nome": "Maria Helena",
	"uf": "PR"
}, {
	"Nome": "Marialva",
	"uf": "PR"
}, {
	"Nome": "Marilândia do Sul",
	"uf": "PR"
}, {
	"Nome": "Marilena",
	"uf": "PR"
}, {
	"Nome": "Mariluz",
	"uf": "PR"
}, {
	"Nome": "Maringá",
	"uf": "PR"
}, {
	"Nome": "Mariópolis",
	"uf": "PR"
}, {
	"Nome": "Maripá",
	"uf": "PR"
}, {
	"Nome": "Marmeleiro",
	"uf": "PR"
}, {
	"Nome": "Marquinho",
	"uf": "PR"
}, {
	"Nome": "Marumbi",
	"uf": "PR"
}, {
	"Nome": "Matelândia",
	"uf": "PR"
}, {
	"Nome": "Matinhos",
	"uf": "PR"
}, {
	"Nome": "Mato Rico",
	"uf": "PR"
}, {
	"Nome": "Mauá da Serra",
	"uf": "PR"
}, {
	"Nome": "Medianeira",
	"uf": "PR"
}, {
	"Nome": "Mercedes",
	"uf": "PR"
}, {
	"Nome": "Mirador",
	"uf": "PR"
}, {
	"Nome": "Miraselva",
	"uf": "PR"
}, {
	"Nome": "Missal",
	"uf": "PR"
}, {
	"Nome": "Moreira Sales",
	"uf": "PR"
}, {
	"Nome": "Morretes",
	"uf": "PR"
}, {
	"Nome": "Munhoz de Melo",
	"uf": "PR"
}, {
	"Nome": "Nossa Senhora das Graças",
	"uf": "PR"
}, {
	"Nome": "Nova Aliança do Ivaí",
	"uf": "PR"
}, {
	"Nome": "Nova América da Colina",
	"uf": "PR"
}, {
	"Nome": "Nova Aurora",
	"uf": "PR"
}, {
	"Nome": "Nova Cantu",
	"uf": "PR"
}, {
	"Nome": "Nova Esperança",
	"uf": "PR"
}, {
	"Nome": "Nova Esperança do Sudoeste",
	"uf": "PR"
}, {
	"Nome": "Nova Fátima",
	"uf": "PR"
}, {
	"Nome": "Nova Laranjeiras",
	"uf": "PR"
}, {
	"Nome": "Nova Londrina",
	"uf": "PR"
}, {
	"Nome": "Nova Olímpia",
	"uf": "PR"
}, {
	"Nome": "Nova Prata do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Nova Santa Bárbara",
	"uf": "PR"
}, {
	"Nome": "Nova Santa Rosa",
	"uf": "PR"
}, {
	"Nome": "Nova Tebas",
	"uf": "PR"
}, {
	"Nome": "Novo Itacolomi",
	"uf": "PR"
}, {
	"Nome": "Ortigueira",
	"uf": "PR"
}, {
	"Nome": "Ourizona",
	"uf": "PR"
}, {
	"Nome": "Ouro Verde do Oeste",
	"uf": "PR"
}, {
	"Nome": "Paiçandu",
	"uf": "PR"
}, {
	"Nome": "Palmas",
	"uf": "PR"
}, {
	"Nome": "Palmeira",
	"uf": "PR"
}, {
	"Nome": "Palmital",
	"uf": "PR"
}, {
	"Nome": "Palotina",
	"uf": "PR"
}, {
	"Nome": "Paraíso do Norte",
	"uf": "PR"
}, {
	"Nome": "Paranacity",
	"uf": "PR"
}, {
	"Nome": "Paranaguá",
	"uf": "PR"
}, {
	"Nome": "Paranapoema",
	"uf": "PR"
}, {
	"Nome": "Paranavaí",
	"uf": "PR"
}, {
	"Nome": "Pato Bragado",
	"uf": "PR"
}, {
	"Nome": "Pato Branco",
	"uf": "PR"
}, {
	"Nome": "Paula Freitas",
	"uf": "PR"
}, {
	"Nome": "Paulo Frontin",
	"uf": "PR"
}, {
	"Nome": "Peabiru",
	"uf": "PR"
}, {
	"Nome": "Perobal",
	"uf": "PR"
}, {
	"Nome": "Pérola",
	"uf": "PR"
}, {
	"Nome": "Pérola d`Oeste",
	"uf": "PR"
}, {
	"Nome": "Piên",
	"uf": "PR"
}, {
	"Nome": "Pinhais",
	"uf": "PR"
}, {
	"Nome": "Pinhal de São Bento",
	"uf": "PR"
}, {
	"Nome": "Pinhalão",
	"uf": "PR"
}, {
	"Nome": "Pinhão",
	"uf": "PR"
}, {
	"Nome": "Piraí do Sul",
	"uf": "PR"
}, {
	"Nome": "Piraquara",
	"uf": "PR"
}, {
	"Nome": "Pitanga",
	"uf": "PR"
}, {
	"Nome": "Pitangueiras",
	"uf": "PR"
}, {
	"Nome": "Planaltina do Paraná",
	"uf": "PR"
}, {
	"Nome": "Planalto",
	"uf": "PR"
}, {
	"Nome": "Ponta Grossa",
	"uf": "PR"
}, {
	"Nome": "Pontal do Paraná",
	"uf": "PR"
}, {
	"Nome": "Porecatu",
	"uf": "PR"
}, {
	"Nome": "Porto Amazonas",
	"uf": "PR"
}, {
	"Nome": "Porto Barreiro",
	"uf": "PR"
}, {
	"Nome": "Porto Rico",
	"uf": "PR"
}, {
	"Nome": "Porto Vitória",
	"uf": "PR"
}, {
	"Nome": "Prado Ferreira",
	"uf": "PR"
}, {
	"Nome": "Pranchita",
	"uf": "PR"
}, {
	"Nome": "Presidente Castelo Branco",
	"uf": "PR"
}, {
	"Nome": "Primeiro de Maio",
	"uf": "PR"
}, {
	"Nome": "Prudentópolis",
	"uf": "PR"
}, {
	"Nome": "Quarto Centenário",
	"uf": "PR"
}, {
	"Nome": "Quatiguá",
	"uf": "PR"
}, {
	"Nome": "Quatro Barras",
	"uf": "PR"
}, {
	"Nome": "Quatro Pontes",
	"uf": "PR"
}, {
	"Nome": "Quedas do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Querência do Norte",
	"uf": "PR"
}, {
	"Nome": "Quinta do Sol",
	"uf": "PR"
}, {
	"Nome": "Quitandinha",
	"uf": "PR"
}, {
	"Nome": "Ramilândia",
	"uf": "PR"
}, {
	"Nome": "Rancho Alegre",
	"uf": "PR"
}, {
	"Nome": "Rancho Alegre d`Oeste",
	"uf": "PR"
}, {
	"Nome": "Realeza",
	"uf": "PR"
}, {
	"Nome": "Rebouças",
	"uf": "PR"
}, {
	"Nome": "Renascença",
	"uf": "PR"
}, {
	"Nome": "Reserva",
	"uf": "PR"
}, {
	"Nome": "Reserva do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Ribeirão Claro",
	"uf": "PR"
}, {
	"Nome": "Ribeirão do Pinhal",
	"uf": "PR"
}, {
	"Nome": "Rio Azul",
	"uf": "PR"
}, {
	"Nome": "Rio Bom",
	"uf": "PR"
}, {
	"Nome": "Rio Bonito do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Rio Branco do Ivaí",
	"uf": "PR"
}, {
	"Nome": "Rio Branco do Sul",
	"uf": "PR"
}, {
	"Nome": "Rio Negro",
	"uf": "PR"
}, {
	"Nome": "Rolândia",
	"uf": "PR"
}, {
	"Nome": "Roncador",
	"uf": "PR"
}, {
	"Nome": "Rondon",
	"uf": "PR"
}, {
	"Nome": "Rosário do Ivaí",
	"uf": "PR"
}, {
	"Nome": "Sabáudia",
	"uf": "PR"
}, {
	"Nome": "Salgado Filho",
	"uf": "PR"
}, {
	"Nome": "Salto do Itararé",
	"uf": "PR"
}, {
	"Nome": "Salto do Lontra",
	"uf": "PR"
}, {
	"Nome": "Santa Amélia",
	"uf": "PR"
}, {
	"Nome": "Santa Cecília do Pavão",
	"uf": "PR"
}, {
	"Nome": "Santa Cruz de Monte Castelo",
	"uf": "PR"
}, {
	"Nome": "Santa Fé",
	"uf": "PR"
}, {
	"Nome": "Santa Helena",
	"uf": "PR"
}, {
	"Nome": "Santa Inês",
	"uf": "PR"
}, {
	"Nome": "Santa Isabel do Ivaí",
	"uf": "PR"
}, {
	"Nome": "Santa Izabel do Oeste",
	"uf": "PR"
}, {
	"Nome": "Santa Lúcia",
	"uf": "PR"
}, {
	"Nome": "Santa Maria do Oeste",
	"uf": "PR"
}, {
	"Nome": "Santa Mariana",
	"uf": "PR"
}, {
	"Nome": "Santa Mônica",
	"uf": "PR"
}, {
	"Nome": "Santa Tereza do Oeste",
	"uf": "PR"
}, {
	"Nome": "Santa Terezinha de Itaipu",
	"uf": "PR"
}, {
	"Nome": "Santana do Itararé",
	"uf": "PR"
}, {
	"Nome": "Santo Antônio da Platina",
	"uf": "PR"
}, {
	"Nome": "Santo Antônio do Caiuá",
	"uf": "PR"
}, {
	"Nome": "Santo Antônio do Paraíso",
	"uf": "PR"
}, {
	"Nome": "Santo Antônio do Sudoeste",
	"uf": "PR"
}, {
	"Nome": "Santo Inácio",
	"uf": "PR"
}, {
	"Nome": "São Carlos do Ivaí",
	"uf": "PR"
}, {
	"Nome": "São Jerônimo da Serra",
	"uf": "PR"
}, {
	"Nome": "São João",
	"uf": "PR"
}, {
	"Nome": "São João do Caiuá",
	"uf": "PR"
}, {
	"Nome": "São João do Ivaí",
	"uf": "PR"
}, {
	"Nome": "São João do Triunfo",
	"uf": "PR"
}, {
	"Nome": "São Jorge d`Oeste",
	"uf": "PR"
}, {
	"Nome": "São Jorge do Ivaí",
	"uf": "PR"
}, {
	"Nome": "São Jorge do Patrocínio",
	"uf": "PR"
}, {
	"Nome": "São José da Boa Vista",
	"uf": "PR"
}, {
	"Nome": "São José das Palmeiras",
	"uf": "PR"
}, {
	"Nome": "São José dos Pinhais",
	"uf": "PR"
}, {
	"Nome": "São Manoel do Paraná",
	"uf": "PR"
}, {
	"Nome": "São Mateus do Sul",
	"uf": "PR"
}, {
	"Nome": "São Miguel do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "São Pedro do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "São Pedro do Ivaí",
	"uf": "PR"
}, {
	"Nome": "São Pedro do Paraná",
	"uf": "PR"
}, {
	"Nome": "São Sebastião da Amoreira",
	"uf": "PR"
}, {
	"Nome": "São Tomé",
	"uf": "PR"
}, {
	"Nome": "Sapopema",
	"uf": "PR"
}, {
	"Nome": "Sarandi",
	"uf": "PR"
}, {
	"Nome": "Saudade do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Sengés",
	"uf": "PR"
}, {
	"Nome": "Serranópolis do Iguaçu",
	"uf": "PR"
}, {
	"Nome": "Sertaneja",
	"uf": "PR"
}, {
	"Nome": "Sertanópolis",
	"uf": "PR"
}, {
	"Nome": "Siqueira Campos",
	"uf": "PR"
}, {
	"Nome": "Sulina",
	"uf": "PR"
}, {
	"Nome": "Tamarana",
	"uf": "PR"
}, {
	"Nome": "Tamboara",
	"uf": "PR"
}, {
	"Nome": "Tapejara",
	"uf": "PR"
}, {
	"Nome": "Tapira",
	"uf": "PR"
}, {
	"Nome": "Teixeira Soares",
	"uf": "PR"
}, {
	"Nome": "Telêmaco Borba",
	"uf": "PR"
}, {
	"Nome": "Terra Boa",
	"uf": "PR"
}, {
	"Nome": "Terra Rica",
	"uf": "PR"
}, {
	"Nome": "Terra Roxa",
	"uf": "PR"
}, {
	"Nome": "Tibagi",
	"uf": "PR"
}, {
	"Nome": "Tijucas do Sul",
	"uf": "PR"
}, {
	"Nome": "Toledo",
	"uf": "PR"
}, {
	"Nome": "Tomazina",
	"uf": "PR"
}, {
	"Nome": "Três Barras do Paraná",
	"uf": "PR"
}, {
	"Nome": "Tunas do Paraná",
	"uf": "PR"
}, {
	"Nome": "Tuneiras do Oeste",
	"uf": "PR"
}, {
	"Nome": "Tupãssi",
	"uf": "PR"
}, {
	"Nome": "Turvo",
	"uf": "PR"
}, {
	"Nome": "Ubiratã",
	"uf": "PR"
}, {
	"Nome": "Umuarama",
	"uf": "PR"
}, {
	"Nome": "União da Vitória",
	"uf": "PR"
}, {
	"Nome": "Uniflor",
	"uf": "PR"
}, {
	"Nome": "Uraí",
	"uf": "PR"
}, {
	"Nome": "Ventania",
	"uf": "PR"
}, {
	"Nome": "Vera Cruz do Oeste",
	"uf": "PR"
}, {
	"Nome": "Verê",
	"uf": "PR"
}, {
	"Nome": "Virmond",
	"uf": "PR"
}, {
	"Nome": "Vitorino",
	"uf": "PR"
}, {
	"Nome": "Wenceslau Braz",
	"uf": "PR"
}, {
	"Nome": "Xambrê",
	"uf": "PR"
}, {
	"Nome": "Abreu e Lima",
	"uf": "PE"
}, {
	"Nome": "Afogados da Ingazeira",
	"uf": "PE"
}, {
	"Nome": "Afrânio",
	"uf": "PE"
}, {
	"Nome": "Agrestina",
	"uf": "PE"
}, {
	"Nome": "Água Preta",
	"uf": "PE"
}, {
	"Nome": "Águas Belas",
	"uf": "PE"
}, {
	"Nome": "Alagoinha",
	"uf": "PE"
}, {
	"Nome": "Aliança",
	"uf": "PE"
}, {
	"Nome": "Altinho",
	"uf": "PE"
}, {
	"Nome": "Amaraji",
	"uf": "PE"
}, {
	"Nome": "Angelim",
	"uf": "PE"
}, {
	"Nome": "Araçoiaba",
	"uf": "PE"
}, {
	"Nome": "Araripina",
	"uf": "PE"
}, {
	"Nome": "Arcoverde",
	"uf": "PE"
}, {
	"Nome": "Barra de Guabiraba",
	"uf": "PE"
}, {
	"Nome": "Barreiros",
	"uf": "PE"
}, {
	"Nome": "Belém de Maria",
	"uf": "PE"
}, {
	"Nome": "Belém de São Francisco",
	"uf": "PE"
}, {
	"Nome": "Belo Jardim",
	"uf": "PE"
}, {
	"Nome": "Betânia",
	"uf": "PE"
}, {
	"Nome": "Bezerros",
	"uf": "PE"
}, {
	"Nome": "Bodocó",
	"uf": "PE"
}, {
	"Nome": "Bom Conselho",
	"uf": "PE"
}, {
	"Nome": "Bom Jardim",
	"uf": "PE"
}, {
	"Nome": "Bonito",
	"uf": "PE"
}, {
	"Nome": "Brejão",
	"uf": "PE"
}, {
	"Nome": "Brejinho",
	"uf": "PE"
}, {
	"Nome": "Brejo da Madre de Deus",
	"uf": "PE"
}, {
	"Nome": "Buenos Aires",
	"uf": "PE"
}, {
	"Nome": "Buíque",
	"uf": "PE"
}, {
	"Nome": "Cabo de Santo Agostinho",
	"uf": "PE"
}, {
	"Nome": "Cabrobó",
	"uf": "PE"
}, {
	"Nome": "Cachoeirinha",
	"uf": "PE"
}, {
	"Nome": "Caetés",
	"uf": "PE"
}, {
	"Nome": "Calçado",
	"uf": "PE"
}, {
	"Nome": "Calumbi",
	"uf": "PE"
}, {
	"Nome": "Camaragibe",
	"uf": "PE"
}, {
	"Nome": "Camocim de São Félix",
	"uf": "PE"
}, {
	"Nome": "Camutanga",
	"uf": "PE"
}, {
	"Nome": "Canhotinho",
	"uf": "PE"
}, {
	"Nome": "Capoeiras",
	"uf": "PE"
}, {
	"Nome": "Carnaíba",
	"uf": "PE"
}, {
	"Nome": "Carnaubeira da Penha",
	"uf": "PE"
}, {
	"Nome": "Carpina",
	"uf": "PE"
}, {
	"Nome": "Caruaru",
	"uf": "PE"
}, {
	"Nome": "Casinhas",
	"uf": "PE"
}, {
	"Nome": "Catende",
	"uf": "PE"
}, {
	"Nome": "Cedro",
	"uf": "PE"
}, {
	"Nome": "Chã de Alegria",
	"uf": "PE"
}, {
	"Nome": "Chã Grande",
	"uf": "PE"
}, {
	"Nome": "Condado",
	"uf": "PE"
}, {
	"Nome": "Correntes",
	"uf": "PE"
}, {
	"Nome": "Cortês",
	"uf": "PE"
}, {
	"Nome": "Cumaru",
	"uf": "PE"
}, {
	"Nome": "Cupira",
	"uf": "PE"
}, {
	"Nome": "Custódia",
	"uf": "PE"
}, {
	"Nome": "Dormentes",
	"uf": "PE"
}, {
	"Nome": "Escada",
	"uf": "PE"
}, {
	"Nome": "Exu",
	"uf": "PE"
}, {
	"Nome": "Feira Nova",
	"uf": "PE"
}, {
	"Nome": "Fernando de Noronha",
	"uf": "PE"
}, {
	"Nome": "Ferreiros",
	"uf": "PE"
}, {
	"Nome": "Flores",
	"uf": "PE"
}, {
	"Nome": "Floresta",
	"uf": "PE"
}, {
	"Nome": "Frei Miguelinho",
	"uf": "PE"
}, {
	"Nome": "Gameleira",
	"uf": "PE"
}, {
	"Nome": "Garanhuns",
	"uf": "PE"
}, {
	"Nome": "Glória do Goitá",
	"uf": "PE"
}, {
	"Nome": "Goiana",
	"uf": "PE"
}, {
	"Nome": "Granito",
	"uf": "PE"
}, {
	"Nome": "Gravatá",
	"uf": "PE"
}, {
	"Nome": "Iati",
	"uf": "PE"
}, {
	"Nome": "Ibimirim",
	"uf": "PE"
}, {
	"Nome": "Ibirajuba",
	"uf": "PE"
}, {
	"Nome": "Igarassu",
	"uf": "PE"
}, {
	"Nome": "Iguaraci",
	"uf": "PE"
}, {
	"Nome": "Ilha de Itamaracá",
	"uf": "PE"
}, {
	"Nome": "Inajá",
	"uf": "PE"
}, {
	"Nome": "Ingazeira",
	"uf": "PE"
}, {
	"Nome": "Ipojuca",
	"uf": "PE"
}, {
	"Nome": "Ipubi",
	"uf": "PE"
}, {
	"Nome": "Itacuruba",
	"uf": "PE"
}, {
	"Nome": "Itaíba",
	"uf": "PE"
}, {
	"Nome": "Itambé",
	"uf": "PE"
}, {
	"Nome": "Itapetim",
	"uf": "PE"
}, {
	"Nome": "Itapissuma",
	"uf": "PE"
}, {
	"Nome": "Itaquitinga",
	"uf": "PE"
}, {
	"Nome": "Jaboatão dos Guararapes",
	"uf": "PE"
}, {
	"Nome": "Jaqueira",
	"uf": "PE"
}, {
	"Nome": "Jataúba",
	"uf": "PE"
}, {
	"Nome": "Jatobá",
	"uf": "PE"
}, {
	"Nome": "João Alfredo",
	"uf": "PE"
}, {
	"Nome": "Joaquim Nabuco",
	"uf": "PE"
}, {
	"Nome": "Jucati",
	"uf": "PE"
}, {
	"Nome": "Jupi",
	"uf": "PE"
}, {
	"Nome": "Jurema",
	"uf": "PE"
}, {
	"Nome": "Lagoa do Carro",
	"uf": "PE"
}, {
	"Nome": "Lagoa do Itaenga",
	"uf": "PE"
}, {
	"Nome": "Lagoa do Ouro",
	"uf": "PE"
}, {
	"Nome": "Lagoa dos Gatos",
	"uf": "PE"
}, {
	"Nome": "Lagoa Grande",
	"uf": "PE"
}, {
	"Nome": "Lajedo",
	"uf": "PE"
}, {
	"Nome": "Limoeiro",
	"uf": "PE"
}, {
	"Nome": "Macaparana",
	"uf": "PE"
}, {
	"Nome": "Machados",
	"uf": "PE"
}, {
	"Nome": "Manari",
	"uf": "PE"
}, {
	"Nome": "Maraial",
	"uf": "PE"
}, {
	"Nome": "Mirandiba",
	"uf": "PE"
}, {
	"Nome": "Moreilândia",
	"uf": "PE"
}, {
	"Nome": "Moreno",
	"uf": "PE"
}, {
	"Nome": "Nazaré da Mata",
	"uf": "PE"
}, {
	"Nome": "Olinda",
	"uf": "PE"
}, {
	"Nome": "Orobó",
	"uf": "PE"
}, {
	"Nome": "Orocó",
	"uf": "PE"
}, {
	"Nome": "Ouricuri",
	"uf": "PE"
}, {
	"Nome": "Palmares",
	"uf": "PE"
}, {
	"Nome": "Palmeirina",
	"uf": "PE"
}, {
	"Nome": "Panelas",
	"uf": "PE"
}, {
	"Nome": "Paranatama",
	"uf": "PE"
}, {
	"Nome": "Parnamirim",
	"uf": "PE"
}, {
	"Nome": "Passira",
	"uf": "PE"
}, {
	"Nome": "Paudalho",
	"uf": "PE"
}, {
	"Nome": "Paulista",
	"uf": "PE"
}, {
	"Nome": "Pedra",
	"uf": "PE"
}, {
	"Nome": "Pesqueira",
	"uf": "PE"
}, {
	"Nome": "Petrolândia",
	"uf": "PE"
}, {
	"Nome": "Petrolina",
	"uf": "PE"
}, {
	"Nome": "Poção",
	"uf": "PE"
}, {
	"Nome": "Pombos",
	"uf": "PE"
}, {
	"Nome": "Primavera",
	"uf": "PE"
}, {
	"Nome": "Quipapá",
	"uf": "PE"
}, {
	"Nome": "Quixaba",
	"uf": "PE"
}, {
	"Nome": "Recife",
	"uf": "PE"
}, {
	"Nome": "Riacho das Almas",
	"uf": "PE"
}, {
	"Nome": "Ribeirão",
	"uf": "PE"
}, {
	"Nome": "Rio Formoso",
	"uf": "PE"
}, {
	"Nome": "Sairé",
	"uf": "PE"
}, {
	"Nome": "Salgadinho",
	"uf": "PE"
}, {
	"Nome": "Salgueiro",
	"uf": "PE"
}, {
	"Nome": "Saloá",
	"uf": "PE"
}, {
	"Nome": "Sanharó",
	"uf": "PE"
}, {
	"Nome": "Santa Cruz",
	"uf": "PE"
}, {
	"Nome": "Santa Cruz da Baixa Verde",
	"uf": "PE"
}, {
	"Nome": "Santa Cruz do Capibaribe",
	"uf": "PE"
}, {
	"Nome": "Santa Filomena",
	"uf": "PE"
}, {
	"Nome": "Santa Maria da Boa Vista",
	"uf": "PE"
}, {
	"Nome": "Santa Maria do Cambucá",
	"uf": "PE"
}, {
	"Nome": "Santa Terezinha",
	"uf": "PE"
}, {
	"Nome": "São Benedito do Sul",
	"uf": "PE"
}, {
	"Nome": "São Bento do Una",
	"uf": "PE"
}, {
	"Nome": "São Caitano",
	"uf": "PE"
}, {
	"Nome": "São João",
	"uf": "PE"
}, {
	"Nome": "São Joaquim do Monte",
	"uf": "PE"
}, {
	"Nome": "São José da Coroa Grande",
	"uf": "PE"
}, {
	"Nome": "São José do Belmonte",
	"uf": "PE"
}, {
	"Nome": "São José do Egito",
	"uf": "PE"
}, {
	"Nome": "São Lourenço da Mata",
	"uf": "PE"
}, {
	"Nome": "São Vicente Ferrer",
	"uf": "PE"
}, {
	"Nome": "Serra Talhada",
	"uf": "PE"
}, {
	"Nome": "Serrita",
	"uf": "PE"
}, {
	"Nome": "Sertânia",
	"uf": "PE"
}, {
	"Nome": "Sirinhaém",
	"uf": "PE"
}, {
	"Nome": "Solidão",
	"uf": "PE"
}, {
	"Nome": "Surubim",
	"uf": "PE"
}, {
	"Nome": "Tabira",
	"uf": "PE"
}, {
	"Nome": "Tacaimbó",
	"uf": "PE"
}, {
	"Nome": "Tacaratu",
	"uf": "PE"
}, {
	"Nome": "Tamandaré",
	"uf": "PE"
}, {
	"Nome": "Taquaritinga do Norte",
	"uf": "PE"
}, {
	"Nome": "Terezinha",
	"uf": "PE"
}, {
	"Nome": "Terra Nova",
	"uf": "PE"
}, {
	"Nome": "Timbaúba",
	"uf": "PE"
}, {
	"Nome": "Toritama",
	"uf": "PE"
}, {
	"Nome": "Tracunhaém",
	"uf": "PE"
}, {
	"Nome": "Trindade",
	"uf": "PE"
}, {
	"Nome": "Triunfo",
	"uf": "PE"
}, {
	"Nome": "Tupanatinga",
	"uf": "PE"
}, {
	"Nome": "Tuparetama",
	"uf": "PE"
}, {
	"Nome": "Venturosa",
	"uf": "PE"
}, {
	"Nome": "Verdejante",
	"uf": "PE"
}, {
	"Nome": "Vertente do Lério",
	"uf": "PE"
}, {
	"Nome": "Vertentes",
	"uf": "PE"
}, {
	"Nome": "Vicência",
	"uf": "PE"
}, {
	"Nome": "Vitória de Santo Antão",
	"uf": "PE"
}, {
	"Nome": "Xexéu",
	"uf": "PE"
}, {
	"Nome": "Acauã",
	"uf": "PI"
}, {
	"Nome": "Agricolândia",
	"uf": "PI"
}, {
	"Nome": "Água Branca",
	"uf": "PI"
}, {
	"Nome": "Alagoinha do Piauí",
	"uf": "PI"
}, {
	"Nome": "Alegrete do Piauí",
	"uf": "PI"
}, {
	"Nome": "Alto Longá",
	"uf": "PI"
}, {
	"Nome": "Altos",
	"uf": "PI"
}, {
	"Nome": "Alvorada do Gurguéia",
	"uf": "PI"
}, {
	"Nome": "Amarante",
	"uf": "PI"
}, {
	"Nome": "Angical do Piauí",
	"uf": "PI"
}, {
	"Nome": "Anísio de Abreu",
	"uf": "PI"
}, {
	"Nome": "Antônio Almeida",
	"uf": "PI"
}, {
	"Nome": "Aroazes",
	"uf": "PI"
}, {
	"Nome": "Aroeiras do Itaim",
	"uf": "PI"
}, {
	"Nome": "Arraial",
	"uf": "PI"
}, {
	"Nome": "Assunção do Piauí",
	"uf": "PI"
}, {
	"Nome": "Avelino Lopes",
	"uf": "PI"
}, {
	"Nome": "Baixa Grande do Ribeiro",
	"uf": "PI"
}, {
	"Nome": "Barra d`Alcântara",
	"uf": "PI"
}, {
	"Nome": "Barras",
	"uf": "PI"
}, {
	"Nome": "Barreiras do Piauí",
	"uf": "PI"
}, {
	"Nome": "Barro Duro",
	"uf": "PI"
}, {
	"Nome": "Batalha",
	"uf": "PI"
}, {
	"Nome": "Bela Vista do Piauí",
	"uf": "PI"
}, {
	"Nome": "Belém do Piauí",
	"uf": "PI"
}, {
	"Nome": "Beneditinos",
	"uf": "PI"
}, {
	"Nome": "Bertolínia",
	"uf": "PI"
}, {
	"Nome": "Betânia do Piauí",
	"uf": "PI"
}, {
	"Nome": "Boa Hora",
	"uf": "PI"
}, {
	"Nome": "Bocaina",
	"uf": "PI"
}, {
	"Nome": "Bom Jesus",
	"uf": "PI"
}, {
	"Nome": "Bom Princípio do Piauí",
	"uf": "PI"
}, {
	"Nome": "Bonfim do Piauí",
	"uf": "PI"
}, {
	"Nome": "Boqueirão do Piauí",
	"uf": "PI"
}, {
	"Nome": "Brasileira",
	"uf": "PI"
}, {
	"Nome": "Brejo do Piauí",
	"uf": "PI"
}, {
	"Nome": "Buriti dos Lopes",
	"uf": "PI"
}, {
	"Nome": "Buriti dos Montes",
	"uf": "PI"
}, {
	"Nome": "Cabeceiras do Piauí",
	"uf": "PI"
}, {
	"Nome": "Cajazeiras do Piauí",
	"uf": "PI"
}, {
	"Nome": "Cajueiro da Praia",
	"uf": "PI"
}, {
	"Nome": "Caldeirão Grande do Piauí",
	"uf": "PI"
}, {
	"Nome": "Campinas do Piauí",
	"uf": "PI"
}, {
	"Nome": "Campo Alegre do Fidalgo",
	"uf": "PI"
}, {
	"Nome": "Campo Grande do Piauí",
	"uf": "PI"
}, {
	"Nome": "Campo Largo do Piauí",
	"uf": "PI"
}, {
	"Nome": "Campo Maior",
	"uf": "PI"
}, {
	"Nome": "Canavieira",
	"uf": "PI"
}, {
	"Nome": "Canto do Buriti",
	"uf": "PI"
}, {
	"Nome": "Capitão de Campos",
	"uf": "PI"
}, {
	"Nome": "Capitão Gervásio Oliveira",
	"uf": "PI"
}, {
	"Nome": "Caracol",
	"uf": "PI"
}, {
	"Nome": "Caraúbas do Piauí",
	"uf": "PI"
}, {
	"Nome": "Caridade do Piauí",
	"uf": "PI"
}, {
	"Nome": "Castelo do Piauí",
	"uf": "PI"
}, {
	"Nome": "Caxingó",
	"uf": "PI"
}, {
	"Nome": "Cocal",
	"uf": "PI"
}, {
	"Nome": "Cocal de Telha",
	"uf": "PI"
}, {
	"Nome": "Cocal dos Alves",
	"uf": "PI"
}, {
	"Nome": "Coivaras",
	"uf": "PI"
}, {
	"Nome": "Colônia do Gurguéia",
	"uf": "PI"
}, {
	"Nome": "Colônia do Piauí",
	"uf": "PI"
}, {
	"Nome": "Conceição do Canindé",
	"uf": "PI"
}, {
	"Nome": "Coronel José Dias",
	"uf": "PI"
}, {
	"Nome": "Corrente",
	"uf": "PI"
}, {
	"Nome": "Cristalândia do Piauí",
	"uf": "PI"
}, {
	"Nome": "Cristino Castro",
	"uf": "PI"
}, {
	"Nome": "Curimatá",
	"uf": "PI"
}, {
	"Nome": "Currais",
	"uf": "PI"
}, {
	"Nome": "Curral Novo do Piauí",
	"uf": "PI"
}, {
	"Nome": "Curralinhos",
	"uf": "PI"
}, {
	"Nome": "Demerval Lobão",
	"uf": "PI"
}, {
	"Nome": "Dirceu Arcoverde",
	"uf": "PI"
}, {
	"Nome": "Dom Expedito Lopes",
	"uf": "PI"
}, {
	"Nome": "Dom Inocêncio",
	"uf": "PI"
}, {
	"Nome": "Domingos Mourão",
	"uf": "PI"
}, {
	"Nome": "Elesbão Veloso",
	"uf": "PI"
}, {
	"Nome": "Eliseu Martins",
	"uf": "PI"
}, {
	"Nome": "Esperantina",
	"uf": "PI"
}, {
	"Nome": "Fartura do Piauí",
	"uf": "PI"
}, {
	"Nome": "Flores do Piauí",
	"uf": "PI"
}, {
	"Nome": "Floresta do Piauí",
	"uf": "PI"
}, {
	"Nome": "Floriano",
	"uf": "PI"
}, {
	"Nome": "Francinópolis",
	"uf": "PI"
}, {
	"Nome": "Francisco Ayres",
	"uf": "PI"
}, {
	"Nome": "Francisco Macedo",
	"uf": "PI"
}, {
	"Nome": "Francisco Santos",
	"uf": "PI"
}, {
	"Nome": "Fronteiras",
	"uf": "PI"
}, {
	"Nome": "Geminiano",
	"uf": "PI"
}, {
	"Nome": "Gilbués",
	"uf": "PI"
}, {
	"Nome": "Guadalupe",
	"uf": "PI"
}, {
	"Nome": "Guaribas",
	"uf": "PI"
}, {
	"Nome": "Hugo Napoleão",
	"uf": "PI"
}, {
	"Nome": "Ilha Grande",
	"uf": "PI"
}, {
	"Nome": "Inhuma",
	"uf": "PI"
}, {
	"Nome": "Ipiranga do Piauí",
	"uf": "PI"
}, {
	"Nome": "Isaías Coelho",
	"uf": "PI"
}, {
	"Nome": "Itainópolis",
	"uf": "PI"
}, {
	"Nome": "Itaueira",
	"uf": "PI"
}, {
	"Nome": "Jacobina do Piauí",
	"uf": "PI"
}, {
	"Nome": "Jaicós",
	"uf": "PI"
}, {
	"Nome": "Jardim do Mulato",
	"uf": "PI"
}, {
	"Nome": "Jatobá do Piauí",
	"uf": "PI"
}, {
	"Nome": "Jerumenha",
	"uf": "PI"
}, {
	"Nome": "João Costa",
	"uf": "PI"
}, {
	"Nome": "Joaquim Pires",
	"uf": "PI"
}, {
	"Nome": "Joca Marques",
	"uf": "PI"
}, {
	"Nome": "José de Freitas",
	"uf": "PI"
}, {
	"Nome": "Juazeiro do Piauí",
	"uf": "PI"
}, {
	"Nome": "Júlio Borges",
	"uf": "PI"
}, {
	"Nome": "Jurema",
	"uf": "PI"
}, {
	"Nome": "Lagoa Alegre",
	"uf": "PI"
}, {
	"Nome": "Lagoa de São Francisco",
	"uf": "PI"
}, {
	"Nome": "Lagoa do Barro do Piauí",
	"uf": "PI"
}, {
	"Nome": "Lagoa do Piauí",
	"uf": "PI"
}, {
	"Nome": "Lagoa do Sítio",
	"uf": "PI"
}, {
	"Nome": "Lagoinha do Piauí",
	"uf": "PI"
}, {
	"Nome": "Landri Sales",
	"uf": "PI"
}, {
	"Nome": "Luís Correia",
	"uf": "PI"
}, {
	"Nome": "Luzilândia",
	"uf": "PI"
}, {
	"Nome": "Madeiro",
	"uf": "PI"
}, {
	"Nome": "Manoel Emídio",
	"uf": "PI"
}, {
	"Nome": "Marcolândia",
	"uf": "PI"
}, {
	"Nome": "Marcos Parente",
	"uf": "PI"
}, {
	"Nome": "Massapê do Piauí",
	"uf": "PI"
}, {
	"Nome": "Matias Olímpio",
	"uf": "PI"
}, {
	"Nome": "Miguel Alves",
	"uf": "PI"
}, {
	"Nome": "Miguel Leão",
	"uf": "PI"
}, {
	"Nome": "Milton Brandão",
	"uf": "PI"
}, {
	"Nome": "Monsenhor Gil",
	"uf": "PI"
}, {
	"Nome": "Monsenhor Hipólito",
	"uf": "PI"
}, {
	"Nome": "Monte Alegre do Piauí",
	"uf": "PI"
}, {
	"Nome": "Morro Cabeça no Tempo",
	"uf": "PI"
}, {
	"Nome": "Morro do Chapéu do Piauí",
	"uf": "PI"
}, {
	"Nome": "Murici dos Portelas",
	"uf": "PI"
}, {
	"Nome": "Nazaré do Piauí",
	"uf": "PI"
}, {
	"Nome": "Nossa Senhora de Nazaré",
	"uf": "PI"
}, {
	"Nome": "Nossa Senhora dos Remédios",
	"uf": "PI"
}, {
	"Nome": "Nova Santa Rita",
	"uf": "PI"
}, {
	"Nome": "Novo Oriente do Piauí",
	"uf": "PI"
}, {
	"Nome": "Novo Santo Antônio",
	"uf": "PI"
}, {
	"Nome": "Oeiras",
	"uf": "PI"
}, {
	"Nome": "Olho d`Água do Piauí",
	"uf": "PI"
}, {
	"Nome": "Padre Marcos",
	"uf": "PI"
}, {
	"Nome": "Paes Landim",
	"uf": "PI"
}, {
	"Nome": "Pajeú do Piauí",
	"uf": "PI"
}, {
	"Nome": "Palmeira do Piauí",
	"uf": "PI"
}, {
	"Nome": "Palmeirais",
	"uf": "PI"
}, {
	"Nome": "Paquetá",
	"uf": "PI"
}, {
	"Nome": "Parnaguá",
	"uf": "PI"
}, {
	"Nome": "Parnaíba",
	"uf": "PI"
}, {
	"Nome": "Passagem Franca do Piauí",
	"uf": "PI"
}, {
	"Nome": "Patos do Piauí",
	"uf": "PI"
}, {
	"Nome": "Pau d`Arco do Piauí",
	"uf": "PI"
}, {
	"Nome": "Paulistana",
	"uf": "PI"
}, {
	"Nome": "Pavussu",
	"uf": "PI"
}, {
	"Nome": "Pedro II",
	"uf": "PI"
}, {
	"Nome": "Pedro Laurentino",
	"uf": "PI"
}, {
	"Nome": "Picos",
	"uf": "PI"
}, {
	"Nome": "Pimenteiras",
	"uf": "PI"
}, {
	"Nome": "Pio IX",
	"uf": "PI"
}, {
	"Nome": "Piracuruca",
	"uf": "PI"
}, {
	"Nome": "Piripiri",
	"uf": "PI"
}, {
	"Nome": "Porto",
	"uf": "PI"
}, {
	"Nome": "Porto Alegre do Piauí",
	"uf": "PI"
}, {
	"Nome": "Prata do Piauí",
	"uf": "PI"
}, {
	"Nome": "Queimada Nova",
	"uf": "PI"
}, {
	"Nome": "Redenção do Gurguéia",
	"uf": "PI"
}, {
	"Nome": "Regeneração",
	"uf": "PI"
}, {
	"Nome": "Riacho Frio",
	"uf": "PI"
}, {
	"Nome": "Ribeira do Piauí",
	"uf": "PI"
}, {
	"Nome": "Ribeiro Gonçalves",
	"uf": "PI"
}, {
	"Nome": "Rio Grande do Piauí",
	"uf": "PI"
}, {
	"Nome": "Santa Cruz do Piauí",
	"uf": "PI"
}, {
	"Nome": "Santa Cruz dos Milagres",
	"uf": "PI"
}, {
	"Nome": "Santa Filomena",
	"uf": "PI"
}, {
	"Nome": "Santa Luz",
	"uf": "PI"
}, {
	"Nome": "Santa Rosa do Piauí",
	"uf": "PI"
}, {
	"Nome": "Santana do Piauí",
	"uf": "PI"
}, {
	"Nome": "Santo Antônio de Lisboa",
	"uf": "PI"
}, {
	"Nome": "Santo Antônio dos Milagres",
	"uf": "PI"
}, {
	"Nome": "Santo Inácio do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Braz do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Félix do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Francisco de Assis do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Francisco do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Gonçalo do Gurguéia",
	"uf": "PI"
}, {
	"Nome": "São Gonçalo do Piauí",
	"uf": "PI"
}, {
	"Nome": "São João da Canabrava",
	"uf": "PI"
}, {
	"Nome": "São João da Fronteira",
	"uf": "PI"
}, {
	"Nome": "São João da Serra",
	"uf": "PI"
}, {
	"Nome": "São João da Varjota",
	"uf": "PI"
}, {
	"Nome": "São João do Arraial",
	"uf": "PI"
}, {
	"Nome": "São João do Piauí",
	"uf": "PI"
}, {
	"Nome": "São José do Divino",
	"uf": "PI"
}, {
	"Nome": "São José do Peixe",
	"uf": "PI"
}, {
	"Nome": "São José do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Julião",
	"uf": "PI"
}, {
	"Nome": "São Lourenço do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Luis do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Miguel da Baixa Grande",
	"uf": "PI"
}, {
	"Nome": "São Miguel do Fidalgo",
	"uf": "PI"
}, {
	"Nome": "São Miguel do Tapuio",
	"uf": "PI"
}, {
	"Nome": "São Pedro do Piauí",
	"uf": "PI"
}, {
	"Nome": "São Raimundo Nonato",
	"uf": "PI"
}, {
	"Nome": "Sebastião Barros",
	"uf": "PI"
}, {
	"Nome": "Sebastião Leal",
	"uf": "PI"
}, {
	"Nome": "Sigefredo Pacheco",
	"uf": "PI"
}, {
	"Nome": "Simões",
	"uf": "PI"
}, {
	"Nome": "Simplício Mendes",
	"uf": "PI"
}, {
	"Nome": "Socorro do Piauí",
	"uf": "PI"
}, {
	"Nome": "Sussuapara",
	"uf": "PI"
}, {
	"Nome": "Tamboril do Piauí",
	"uf": "PI"
}, {
	"Nome": "Tanque do Piauí",
	"uf": "PI"
}, {
	"Nome": "Teresina",
	"uf": "PI"
}, {
	"Nome": "União",
	"uf": "PI"
}, {
	"Nome": "Uruçuí",
	"uf": "PI"
}, {
	"Nome": "Valença do Piauí",
	"uf": "PI"
}, {
	"Nome": "Várzea Branca",
	"uf": "PI"
}, {
	"Nome": "Várzea Grande",
	"uf": "PI"
}, {
	"Nome": "Vera Mendes",
	"uf": "PI"
}, {
	"Nome": "Vila Nova do Piauí",
	"uf": "PI"
}, {
	"Nome": "Wall Ferraz",
	"uf": "PI"
}, {
	"Nome": "Angra dos Reis",
	"uf": "RJ"
}, {
	"Nome": "Aperibé",
	"uf": "RJ"
}, {
	"Nome": "Araruama",
	"uf": "RJ"
}, {
	"Nome": "Areal",
	"uf": "RJ"
}, {
	"Nome": "Armação dos Búzios",
	"uf": "RJ"
}, {
	"Nome": "Arraial do Cabo",
	"uf": "RJ"
}, {
	"Nome": "Barra do Piraí",
	"uf": "RJ"
}, {
	"Nome": "Barra Mansa",
	"uf": "RJ"
}, {
	"Nome": "Belford Roxo",
	"uf": "RJ"
}, {
	"Nome": "Bom Jardim",
	"uf": "RJ"
}, {
	"Nome": "Bom Jesus do Itabapoana",
	"uf": "RJ"
}, {
	"Nome": "Cabo Frio",
	"uf": "RJ"
}, {
	"Nome": "Cachoeiras de Macacu",
	"uf": "RJ"
}, {
	"Nome": "Cambuci",
	"uf": "RJ"
}, {
	"Nome": "Campos dos Goytacazes",
	"uf": "RJ"
}, {
	"Nome": "Cantagalo",
	"uf": "RJ"
}, {
	"Nome": "Carapebus",
	"uf": "RJ"
}, {
	"Nome": "Cardoso Moreira",
	"uf": "RJ"
}, {
	"Nome": "Carmo",
	"uf": "RJ"
}, {
	"Nome": "Casimiro de Abreu",
	"uf": "RJ"
}, {
	"Nome": "Comendador Levy Gasparian",
	"uf": "RJ"
}, {
	"Nome": "Conceição de Macabu",
	"uf": "RJ"
}, {
	"Nome": "Cordeiro",
	"uf": "RJ"
}, {
	"Nome": "Duas Barras",
	"uf": "RJ"
}, {
	"Nome": "Duque de Caxias",
	"uf": "RJ"
}, {
	"Nome": "Engenheiro Paulo de Frontin",
	"uf": "RJ"
}, {
	"Nome": "Guapimirim",
	"uf": "RJ"
}, {
	"Nome": "Iguaba Grande",
	"uf": "RJ"
}, {
	"Nome": "Itaboraí",
	"uf": "RJ"
}, {
	"Nome": "Itaguaí",
	"uf": "RJ"
}, {
	"Nome": "Italva",
	"uf": "RJ"
}, {
	"Nome": "Itaocara",
	"uf": "RJ"
}, {
	"Nome": "Itaperuna",
	"uf": "RJ"
}, {
	"Nome": "Itatiaia",
	"uf": "RJ"
}, {
	"Nome": "Japeri",
	"uf": "RJ"
}, {
	"Nome": "Laje do Muriaé",
	"uf": "RJ"
}, {
	"Nome": "Macaé",
	"uf": "RJ"
}, {
	"Nome": "Macuco",
	"uf": "RJ"
}, {
	"Nome": "Magé",
	"uf": "RJ"
}, {
	"Nome": "Mangaratiba",
	"uf": "RJ"
}, {
	"Nome": "Maricá",
	"uf": "RJ"
}, {
	"Nome": "Mendes",
	"uf": "RJ"
}, {
	"Nome": "Mesquita",
	"uf": "RJ"
}, {
	"Nome": "Miguel Pereira",
	"uf": "RJ"
}, {
	"Nome": "Miracema",
	"uf": "RJ"
}, {
	"Nome": "Natividade",
	"uf": "RJ"
}, {
	"Nome": "Nilópolis",
	"uf": "RJ"
}, {
	"Nome": "Niterói",
	"uf": "RJ"
}, {
	"Nome": "Nova Friburgo",
	"uf": "RJ"
}, {
	"Nome": "Nova Iguaçu",
	"uf": "RJ"
}, {
	"Nome": "Paracambi",
	"uf": "RJ"
}, {
	"Nome": "Paraíba do Sul",
	"uf": "RJ"
}, {
	"Nome": "Parati",
	"uf": "RJ"
}, {
	"Nome": "Paty do Alferes",
	"uf": "RJ"
}, {
	"Nome": "Petrópolis",
	"uf": "RJ"
}, {
	"Nome": "Pinheiral",
	"uf": "RJ"
}, {
	"Nome": "Piraí",
	"uf": "RJ"
}, {
	"Nome": "Porciúncula",
	"uf": "RJ"
}, {
	"Nome": "Porto Real",
	"uf": "RJ"
}, {
	"Nome": "Quatis",
	"uf": "RJ"
}, {
	"Nome": "Queimados",
	"uf": "RJ"
}, {
	"Nome": "Quissamã",
	"uf": "RJ"
}, {
	"Nome": "Resende",
	"uf": "RJ"
}, {
	"Nome": "Rio Bonito",
	"uf": "RJ"
}, {
	"Nome": "Rio Claro",
	"uf": "RJ"
}, {
	"Nome": "Rio das Flores",
	"uf": "RJ"
}, {
	"Nome": "Rio das Ostras",
	"uf": "RJ"
}, {
	"Nome": "Rio de Janeiro",
	"uf": "RJ"
}, {
	"Nome": "Santa Maria Madalena",
	"uf": "RJ"
}, {
	"Nome": "Santo Antônio de Pádua",
	"uf": "RJ"
}, {
	"Nome": "São Fidélis",
	"uf": "RJ"
}, {
	"Nome": "São Francisco de Itabapoana",
	"uf": "RJ"
}, {
	"Nome": "São Gonçalo",
	"uf": "RJ"
}, {
	"Nome": "São João da Barra",
	"uf": "RJ"
}, {
	"Nome": "São João de Meriti",
	"uf": "RJ"
}, {
	"Nome": "São José de Ubá",
	"uf": "RJ"
}, {
	"Nome": "São José do Vale do Rio Preto",
	"uf": "RJ"
}, {
	"Nome": "São Pedro da Aldeia",
	"uf": "RJ"
}, {
	"Nome": "São Sebastião do Alto",
	"uf": "RJ"
}, {
	"Nome": "Sapucaia",
	"uf": "RJ"
}, {
	"Nome": "Saquarema",
	"uf": "RJ"
}, {
	"Nome": "Seropédica",
	"uf": "RJ"
}, {
	"Nome": "Silva Jardim",
	"uf": "RJ"
}, {
	"Nome": "Sumidouro",
	"uf": "RJ"
}, {
	"Nome": "Tanguá",
	"uf": "RJ"
}, {
	"Nome": "Teresópolis",
	"uf": "RJ"
}, {
	"Nome": "Trajano de Morais",
	"uf": "RJ"
}, {
	"Nome": "Três Rios",
	"uf": "RJ"
}, {
	"Nome": "Valença",
	"uf": "RJ"
}, {
	"Nome": "Varre-Sai",
	"uf": "RJ"
}, {
	"Nome": "Vassouras",
	"uf": "RJ"
}, {
	"Nome": "Volta Redonda",
	"uf": "RJ"
}, {
	"Nome": "Acari",
	"uf": "RN"
}, {
	"Nome": "Açu",
	"uf": "RN"
}, {
	"Nome": "Afonso Bezerra",
	"uf": "RN"
}, {
	"Nome": "Água Nova",
	"uf": "RN"
}, {
	"Nome": "Alexandria",
	"uf": "RN"
}, {
	"Nome": "Almino Afonso",
	"uf": "RN"
}, {
	"Nome": "Alto do Rodrigues",
	"uf": "RN"
}, {
	"Nome": "Angicos",
	"uf": "RN"
}, {
	"Nome": "Antônio Martins",
	"uf": "RN"
}, {
	"Nome": "Apodi",
	"uf": "RN"
}, {
	"Nome": "Areia Branca",
	"uf": "RN"
}, {
	"Nome": "Arês",
	"uf": "RN"
}, {
	"Nome": "Augusto Severo",
	"uf": "RN"
}, {
	"Nome": "Baía Formosa",
	"uf": "RN"
}, {
	"Nome": "Baraúna",
	"uf": "RN"
}, {
	"Nome": "Barcelona",
	"uf": "RN"
}, {
	"Nome": "Bento Fernandes",
	"uf": "RN"
}, {
	"Nome": "Bodó",
	"uf": "RN"
}, {
	"Nome": "Bom Jesus",
	"uf": "RN"
}, {
	"Nome": "Brejinho",
	"uf": "RN"
}, {
	"Nome": "Caiçara do Norte",
	"uf": "RN"
}, {
	"Nome": "Caiçara do Rio do Vento",
	"uf": "RN"
}, {
	"Nome": "Caicó",
	"uf": "RN"
}, {
	"Nome": "Campo Redondo",
	"uf": "RN"
}, {
	"Nome": "Canguaretama",
	"uf": "RN"
}, {
	"Nome": "Caraúbas",
	"uf": "RN"
}, {
	"Nome": "Carnaúba dos Dantas",
	"uf": "RN"
}, {
	"Nome": "Carnaubais",
	"uf": "RN"
}, {
	"Nome": "Ceará-Mirim",
	"uf": "RN"
}, {
	"Nome": "Cerro Corá",
	"uf": "RN"
}, {
	"Nome": "Coronel Ezequiel",
	"uf": "RN"
}, {
	"Nome": "Coronel João Pessoa",
	"uf": "RN"
}, {
	"Nome": "Cruzeta",
	"uf": "RN"
}, {
	"Nome": "Currais Novos",
	"uf": "RN"
}, {
	"Nome": "Doutor Severiano",
	"uf": "RN"
}, {
	"Nome": "Encanto",
	"uf": "RN"
}, {
	"Nome": "Equador",
	"uf": "RN"
}, {
	"Nome": "Espírito Santo",
	"uf": "RN"
}, {
	"Nome": "Extremoz",
	"uf": "RN"
}, {
	"Nome": "Felipe Guerra",
	"uf": "RN"
}, {
	"Nome": "Fernando Pedroza",
	"uf": "RN"
}, {
	"Nome": "Florânia",
	"uf": "RN"
}, {
	"Nome": "Francisco Dantas",
	"uf": "RN"
}, {
	"Nome": "Frutuoso Gomes",
	"uf": "RN"
}, {
	"Nome": "Galinhos",
	"uf": "RN"
}, {
	"Nome": "Goianinha",
	"uf": "RN"
}, {
	"Nome": "Governador Dix-Sept Rosado",
	"uf": "RN"
}, {
	"Nome": "Grossos",
	"uf": "RN"
}, {
	"Nome": "Guamaré",
	"uf": "RN"
}, {
	"Nome": "Ielmo Marinho",
	"uf": "RN"
}, {
	"Nome": "Ipanguaçu",
	"uf": "RN"
}, {
	"Nome": "Ipueira",
	"uf": "RN"
}, {
	"Nome": "Itajá",
	"uf": "RN"
}, {
	"Nome": "Itaú",
	"uf": "RN"
}, {
	"Nome": "Jaçanã",
	"uf": "RN"
}, {
	"Nome": "Jandaíra",
	"uf": "RN"
}, {
	"Nome": "Janduís",
	"uf": "RN"
}, {
	"Nome": "Januário Cicco",
	"uf": "RN"
}, {
	"Nome": "Japi",
	"uf": "RN"
}, {
	"Nome": "Jardim de Angicos",
	"uf": "RN"
}, {
	"Nome": "Jardim de Piranhas",
	"uf": "RN"
}, {
	"Nome": "Jardim do Seridó",
	"uf": "RN"
}, {
	"Nome": "João Câmara",
	"uf": "RN"
}, {
	"Nome": "João Dias",
	"uf": "RN"
}, {
	"Nome": "José da Penha",
	"uf": "RN"
}, {
	"Nome": "Jucurutu",
	"uf": "RN"
}, {
	"Nome": "Jundiá",
	"uf": "RN"
}, {
	"Nome": "Lagoa d`Anta",
	"uf": "RN"
}, {
	"Nome": "Lagoa de Pedras",
	"uf": "RN"
}, {
	"Nome": "Lagoa de Velhos",
	"uf": "RN"
}, {
	"Nome": "Lagoa Nova",
	"uf": "RN"
}, {
	"Nome": "Lagoa Salgada",
	"uf": "RN"
}, {
	"Nome": "Lajes",
	"uf": "RN"
}, {
	"Nome": "Lajes Pintadas",
	"uf": "RN"
}, {
	"Nome": "Lucrécia",
	"uf": "RN"
}, {
	"Nome": "Luís Gomes",
	"uf": "RN"
}, {
	"Nome": "Macaíba",
	"uf": "RN"
}, {
	"Nome": "Macau",
	"uf": "RN"
}, {
	"Nome": "Major Sales",
	"uf": "RN"
}, {
	"Nome": "Marcelino Vieira",
	"uf": "RN"
}, {
	"Nome": "Martins",
	"uf": "RN"
}, {
	"Nome": "Maxaranguape",
	"uf": "RN"
}, {
	"Nome": "Messias Targino",
	"uf": "RN"
}, {
	"Nome": "Montanhas",
	"uf": "RN"
}, {
	"Nome": "Monte Alegre",
	"uf": "RN"
}, {
	"Nome": "Monte das Gameleiras",
	"uf": "RN"
}, {
	"Nome": "Mossoró",
	"uf": "RN"
}, {
	"Nome": "Natal",
	"uf": "RN"
}, {
	"Nome": "Nísia Floresta",
	"uf": "RN"
}, {
	"Nome": "Nova Cruz",
	"uf": "RN"
}, {
	"Nome": "Olho-d`Água do Borges",
	"uf": "RN"
}, {
	"Nome": "Ouro Branco",
	"uf": "RN"
}, {
	"Nome": "Paraná",
	"uf": "RN"
}, {
	"Nome": "Paraú",
	"uf": "RN"
}, {
	"Nome": "Parazinho",
	"uf": "RN"
}, {
	"Nome": "Parelhas",
	"uf": "RN"
}, {
	"Nome": "Parnamirim",
	"uf": "RN"
}, {
	"Nome": "Passa e Fica",
	"uf": "RN"
}, {
	"Nome": "Passagem",
	"uf": "RN"
}, {
	"Nome": "Patu",
	"uf": "RN"
}, {
	"Nome": "Pau dos Ferros",
	"uf": "RN"
}, {
	"Nome": "Pedra Grande",
	"uf": "RN"
}, {
	"Nome": "Pedra Preta",
	"uf": "RN"
}, {
	"Nome": "Pedro Avelino",
	"uf": "RN"
}, {
	"Nome": "Pedro Velho",
	"uf": "RN"
}, {
	"Nome": "Pendências",
	"uf": "RN"
}, {
	"Nome": "Pilões",
	"uf": "RN"
}, {
	"Nome": "Poço Branco",
	"uf": "RN"
}, {
	"Nome": "Portalegre",
	"uf": "RN"
}, {
	"Nome": "Porto do Mangue",
	"uf": "RN"
}, {
	"Nome": "Presidente Juscelino",
	"uf": "RN"
}, {
	"Nome": "Pureza",
	"uf": "RN"
}, {
	"Nome": "Rafael Fernandes",
	"uf": "RN"
}, {
	"Nome": "Rafael Godeiro",
	"uf": "RN"
}, {
	"Nome": "Riacho da Cruz",
	"uf": "RN"
}, {
	"Nome": "Riacho de Santana",
	"uf": "RN"
}, {
	"Nome": "Riachuelo",
	"uf": "RN"
}, {
	"Nome": "Rio do Fogo",
	"uf": "RN"
}, {
	"Nome": "Rodolfo Fernandes",
	"uf": "RN"
}, {
	"Nome": "Ruy Barbosa",
	"uf": "RN"
}, {
	"Nome": "Santa Cruz",
	"uf": "RN"
}, {
	"Nome": "Santa Maria",
	"uf": "RN"
}, {
	"Nome": "Santana do Matos",
	"uf": "RN"
}, {
	"Nome": "Santana do Seridó",
	"uf": "RN"
}, {
	"Nome": "Santo Antônio",
	"uf": "RN"
}, {
	"Nome": "São Bento do Norte",
	"uf": "RN"
}, {
	"Nome": "São Bento do Trairí",
	"uf": "RN"
}, {
	"Nome": "São Fernando",
	"uf": "RN"
}, {
	"Nome": "São Francisco do Oeste",
	"uf": "RN"
}, {
	"Nome": "São Gonçalo do Amarante",
	"uf": "RN"
}, {
	"Nome": "São João do Sabugi",
	"uf": "RN"
}, {
	"Nome": "São José de Mipibu",
	"uf": "RN"
}, {
	"Nome": "São José do Campestre",
	"uf": "RN"
}, {
	"Nome": "São José do Seridó",
	"uf": "RN"
}, {
	"Nome": "São Miguel",
	"uf": "RN"
}, {
	"Nome": "São Miguel do Gostoso",
	"uf": "RN"
}, {
	"Nome": "São Paulo do Potengi",
	"uf": "RN"
}, {
	"Nome": "São Pedro",
	"uf": "RN"
}, {
	"Nome": "São Rafael",
	"uf": "RN"
}, {
	"Nome": "São Tomé",
	"uf": "RN"
}, {
	"Nome": "São Vicente",
	"uf": "RN"
}, {
	"Nome": "Senador Elói de Souza",
	"uf": "RN"
}, {
	"Nome": "Senador Georgino Avelino",
	"uf": "RN"
}, {
	"Nome": "Serra de São Bento",
	"uf": "RN"
}, {
	"Nome": "Serra do Mel",
	"uf": "RN"
}, {
	"Nome": "Serra Negra do Norte",
	"uf": "RN"
}, {
	"Nome": "Serrinha",
	"uf": "RN"
}, {
	"Nome": "Serrinha dos Pintos",
	"uf": "RN"
}, {
	"Nome": "Severiano Melo",
	"uf": "RN"
}, {
	"Nome": "Sítio Novo",
	"uf": "RN"
}, {
	"Nome": "Taboleiro Grande",
	"uf": "RN"
}, {
	"Nome": "Taipu",
	"uf": "RN"
}, {
	"Nome": "Tangará",
	"uf": "RN"
}, {
	"Nome": "Tenente Ananias",
	"uf": "RN"
}, {
	"Nome": "Tenente Laurentino Cruz",
	"uf": "RN"
}, {
	"Nome": "Tibau",
	"uf": "RN"
}, {
	"Nome": "Tibau do Sul",
	"uf": "RN"
}, {
	"Nome": "Timbaúba dos Batistas",
	"uf": "RN"
}, {
	"Nome": "Touros",
	"uf": "RN"
}, {
	"Nome": "Triunfo Potiguar",
	"uf": "RN"
}, {
	"Nome": "Umarizal",
	"uf": "RN"
}, {
	"Nome": "Upanema",
	"uf": "RN"
}, {
	"Nome": "Várzea",
	"uf": "RN"
}, {
	"Nome": "Venha-Ver",
	"uf": "RN"
}, {
	"Nome": "Vera Cruz",
	"uf": "RN"
}, {
	"Nome": "Viçosa",
	"uf": "RN"
}, {
	"Nome": "Vila Flor",
	"uf": "RN"
}, {
	"Nome": "Aceguá",
	"uf": "RS"
}, {
	"Nome": "Água Santa",
	"uf": "RS"
}, {
	"Nome": "Agudo",
	"uf": "RS"
}, {
	"Nome": "Ajuricaba",
	"uf": "RS"
}, {
	"Nome": "Alecrim",
	"uf": "RS"
}, {
	"Nome": "Alegrete",
	"uf": "RS"
}, {
	"Nome": "Alegria",
	"uf": "RS"
}, {
	"Nome": "Almirante Tamandaré do Sul",
	"uf": "RS"
}, {
	"Nome": "Alpestre",
	"uf": "RS"
}, {
	"Nome": "Alto Alegre",
	"uf": "RS"
}, {
	"Nome": "Alto Feliz",
	"uf": "RS"
}, {
	"Nome": "Alvorada",
	"uf": "RS"
}, {
	"Nome": "Amaral Ferrador",
	"uf": "RS"
}, {
	"Nome": "Ametista do Sul",
	"uf": "RS"
}, {
	"Nome": "André da Rocha",
	"uf": "RS"
}, {
	"Nome": "Anta Gorda",
	"uf": "RS"
}, {
	"Nome": "Antônio Prado",
	"uf": "RS"
}, {
	"Nome": "Arambaré",
	"uf": "RS"
}, {
	"Nome": "Araricá",
	"uf": "RS"
}, {
	"Nome": "Aratiba",
	"uf": "RS"
}, {
	"Nome": "Arroio do Meio",
	"uf": "RS"
}, {
	"Nome": "Arroio do Padre",
	"uf": "RS"
}, {
	"Nome": "Arroio do Sal",
	"uf": "RS"
}, {
	"Nome": "Arroio do Tigre",
	"uf": "RS"
}, {
	"Nome": "Arroio dos Ratos",
	"uf": "RS"
}, {
	"Nome": "Arroio Grande",
	"uf": "RS"
}, {
	"Nome": "Arvorezinha",
	"uf": "RS"
}, {
	"Nome": "Augusto Pestana",
	"uf": "RS"
}, {
	"Nome": "Áurea",
	"uf": "RS"
}, {
	"Nome": "Bagé",
	"uf": "RS"
}, {
	"Nome": "Balneário Pinhal",
	"uf": "RS"
}, {
	"Nome": "Barão",
	"uf": "RS"
}, {
	"Nome": "Barão de Cotegipe",
	"uf": "RS"
}, {
	"Nome": "Barão do Triunfo",
	"uf": "RS"
}, {
	"Nome": "Barra do Guarita",
	"uf": "RS"
}, {
	"Nome": "Barra do Quaraí",
	"uf": "RS"
}, {
	"Nome": "Barra do Ribeiro",
	"uf": "RS"
}, {
	"Nome": "Barra do Rio Azul",
	"uf": "RS"
}, {
	"Nome": "Barra Funda",
	"uf": "RS"
}, {
	"Nome": "Barracão",
	"uf": "RS"
}, {
	"Nome": "Barros Cassal",
	"uf": "RS"
}, {
	"Nome": "Benjamin Constant do Sul",
	"uf": "RS"
}, {
	"Nome": "Bento Gonçalves",
	"uf": "RS"
}, {
	"Nome": "Boa Vista das Missões",
	"uf": "RS"
}, {
	"Nome": "Boa Vista do Buricá",
	"uf": "RS"
}, {
	"Nome": "Boa Vista do Cadeado",
	"uf": "RS"
}, {
	"Nome": "Boa Vista do Incra",
	"uf": "RS"
}, {
	"Nome": "Boa Vista do Sul",
	"uf": "RS"
}, {
	"Nome": "Bom Jesus",
	"uf": "RS"
}, {
	"Nome": "Bom Princípio",
	"uf": "RS"
}, {
	"Nome": "Bom Progresso",
	"uf": "RS"
}, {
	"Nome": "Bom Retiro do Sul",
	"uf": "RS"
}, {
	"Nome": "Boqueirão do Leão",
	"uf": "RS"
}, {
	"Nome": "Bossoroca",
	"uf": "RS"
}, {
	"Nome": "Bozano",
	"uf": "RS"
}, {
	"Nome": "Braga",
	"uf": "RS"
}, {
	"Nome": "Brochier",
	"uf": "RS"
}, {
	"Nome": "Butiá",
	"uf": "RS"
}, {
	"Nome": "Caçapava do Sul",
	"uf": "RS"
}, {
	"Nome": "Cacequi",
	"uf": "RS"
}, {
	"Nome": "Cachoeira do Sul",
	"uf": "RS"
}, {
	"Nome": "Cachoeirinha",
	"uf": "RS"
}, {
	"Nome": "Cacique Doble",
	"uf": "RS"
}, {
	"Nome": "Caibaté",
	"uf": "RS"
}, {
	"Nome": "Caiçara",
	"uf": "RS"
}, {
	"Nome": "Camaquã",
	"uf": "RS"
}, {
	"Nome": "Camargo",
	"uf": "RS"
}, {
	"Nome": "Cambará do Sul",
	"uf": "RS"
}, {
	"Nome": "Campestre da Serra",
	"uf": "RS"
}, {
	"Nome": "Campina das Missões",
	"uf": "RS"
}, {
	"Nome": "Campinas do Sul",
	"uf": "RS"
}, {
	"Nome": "Campo Bom",
	"uf": "RS"
}, {
	"Nome": "Campo Novo",
	"uf": "RS"
}, {
	"Nome": "Campos Borges",
	"uf": "RS"
}, {
	"Nome": "Candelária",
	"uf": "RS"
}, {
	"Nome": "Cândido Godói",
	"uf": "RS"
}, {
	"Nome": "Candiota",
	"uf": "RS"
}, {
	"Nome": "Canela",
	"uf": "RS"
}, {
	"Nome": "Canguçu",
	"uf": "RS"
}, {
	"Nome": "Canoas",
	"uf": "RS"
}, {
	"Nome": "Canudos do Vale",
	"uf": "RS"
}, {
	"Nome": "Capão Bonito do Sul",
	"uf": "RS"
}, {
	"Nome": "Capão da Canoa",
	"uf": "RS"
}, {
	"Nome": "Capão do Cipó",
	"uf": "RS"
}, {
	"Nome": "Capão do Leão",
	"uf": "RS"
}, {
	"Nome": "Capela de Santana",
	"uf": "RS"
}, {
	"Nome": "Capitão",
	"uf": "RS"
}, {
	"Nome": "Capivari do Sul",
	"uf": "RS"
}, {
	"Nome": "Caraá",
	"uf": "RS"
}, {
	"Nome": "Carazinho",
	"uf": "RS"
}, {
	"Nome": "Carlos Barbosa",
	"uf": "RS"
}, {
	"Nome": "Carlos Gomes",
	"uf": "RS"
}, {
	"Nome": "Casca",
	"uf": "RS"
}, {
	"Nome": "Caseiros",
	"uf": "RS"
}, {
	"Nome": "Catuípe",
	"uf": "RS"
}, {
	"Nome": "Caxias do Sul",
	"uf": "RS"
}, {
	"Nome": "Centenário",
	"uf": "RS"
}, {
	"Nome": "Cerrito",
	"uf": "RS"
}, {
	"Nome": "Cerro Branco",
	"uf": "RS"
}, {
	"Nome": "Cerro Grande",
	"uf": "RS"
}, {
	"Nome": "Cerro Grande do Sul",
	"uf": "RS"
}, {
	"Nome": "Cerro Largo",
	"uf": "RS"
}, {
	"Nome": "Chapada",
	"uf": "RS"
}, {
	"Nome": "Charqueadas",
	"uf": "RS"
}, {
	"Nome": "Charrua",
	"uf": "RS"
}, {
	"Nome": "Chiapeta",
	"uf": "RS"
}, {
	"Nome": "Chuí",
	"uf": "RS"
}, {
	"Nome": "Chuvisca",
	"uf": "RS"
}, {
	"Nome": "Cidreira",
	"uf": "RS"
}, {
	"Nome": "Ciríaco",
	"uf": "RS"
}, {
	"Nome": "Colinas",
	"uf": "RS"
}, {
	"Nome": "Colorado",
	"uf": "RS"
}, {
	"Nome": "Condor",
	"uf": "RS"
}, {
	"Nome": "Constantina",
	"uf": "RS"
}, {
	"Nome": "Coqueiro Baixo",
	"uf": "RS"
}, {
	"Nome": "Coqueiros do Sul",
	"uf": "RS"
}, {
	"Nome": "Coronel Barros",
	"uf": "RS"
}, {
	"Nome": "Coronel Bicaco",
	"uf": "RS"
}, {
	"Nome": "Coronel Pilar",
	"uf": "RS"
}, {
	"Nome": "Cotiporã",
	"uf": "RS"
}, {
	"Nome": "Coxilha",
	"uf": "RS"
}, {
	"Nome": "Crissiumal",
	"uf": "RS"
}, {
	"Nome": "Cristal",
	"uf": "RS"
}, {
	"Nome": "Cristal do Sul",
	"uf": "RS"
}, {
	"Nome": "Cruz Alta",
	"uf": "RS"
}, {
	"Nome": "Cruzaltense",
	"uf": "RS"
}, {
	"Nome": "Cruzeiro do Sul",
	"uf": "RS"
}, {
	"Nome": "David Canabarro",
	"uf": "RS"
}, {
	"Nome": "Derrubadas",
	"uf": "RS"
}, {
	"Nome": "Dezesseis de Novembro",
	"uf": "RS"
}, {
	"Nome": "Dilermando de Aguiar",
	"uf": "RS"
}, {
	"Nome": "Dois Irmãos",
	"uf": "RS"
}, {
	"Nome": "Dois Irmãos das Missões",
	"uf": "RS"
}, {
	"Nome": "Dois Lajeados",
	"uf": "RS"
}, {
	"Nome": "Dom Feliciano",
	"uf": "RS"
}, {
	"Nome": "Dom Pedrito",
	"uf": "RS"
}, {
	"Nome": "Dom Pedro de Alcântara",
	"uf": "RS"
}, {
	"Nome": "Dona Francisca",
	"uf": "RS"
}, {
	"Nome": "Doutor Maurício Cardoso",
	"uf": "RS"
}, {
	"Nome": "Doutor Ricardo",
	"uf": "RS"
}, {
	"Nome": "Eldorado do Sul",
	"uf": "RS"
}, {
	"Nome": "Encantado",
	"uf": "RS"
}, {
	"Nome": "Encruzilhada do Sul",
	"uf": "RS"
}, {
	"Nome": "Engenho Velho",
	"uf": "RS"
}, {
	"Nome": "Entre Rios do Sul",
	"uf": "RS"
}, {
	"Nome": "Entre-Ijuís",
	"uf": "RS"
}, {
	"Nome": "Erebango",
	"uf": "RS"
}, {
	"Nome": "Erechim",
	"uf": "RS"
}, {
	"Nome": "Ernestina",
	"uf": "RS"
}, {
	"Nome": "Erval Grande",
	"uf": "RS"
}, {
	"Nome": "Erval Seco",
	"uf": "RS"
}, {
	"Nome": "Esmeralda",
	"uf": "RS"
}, {
	"Nome": "Esperança do Sul",
	"uf": "RS"
}, {
	"Nome": "Espumoso",
	"uf": "RS"
}, {
	"Nome": "Estação",
	"uf": "RS"
}, {
	"Nome": "Estância Velha",
	"uf": "RS"
}, {
	"Nome": "Esteio",
	"uf": "RS"
}, {
	"Nome": "Estrela",
	"uf": "RS"
}, {
	"Nome": "Estrela Velha",
	"uf": "RS"
}, {
	"Nome": "Eugênio de Castro",
	"uf": "RS"
}, {
	"Nome": "Fagundes Varela",
	"uf": "RS"
}, {
	"Nome": "Farroupilha",
	"uf": "RS"
}, {
	"Nome": "Faxinal do Soturno",
	"uf": "RS"
}, {
	"Nome": "Faxinalzinho",
	"uf": "RS"
}, {
	"Nome": "Fazenda Vilanova",
	"uf": "RS"
}, {
	"Nome": "Feliz",
	"uf": "RS"
}, {
	"Nome": "Flores da Cunha",
	"uf": "RS"
}, {
	"Nome": "Floriano Peixoto",
	"uf": "RS"
}, {
	"Nome": "Fontoura Xavier",
	"uf": "RS"
}, {
	"Nome": "Formigueiro",
	"uf": "RS"
}, {
	"Nome": "Forquetinha",
	"uf": "RS"
}, {
	"Nome": "Fortaleza dos Valos",
	"uf": "RS"
}, {
	"Nome": "Frederico Westphalen",
	"uf": "RS"
}, {
	"Nome": "Garibaldi",
	"uf": "RS"
}, {
	"Nome": "Garruchos",
	"uf": "RS"
}, {
	"Nome": "Gaurama",
	"uf": "RS"
}, {
	"Nome": "General Câmara",
	"uf": "RS"
}, {
	"Nome": "Gentil",
	"uf": "RS"
}, {
	"Nome": "Getúlio Vargas",
	"uf": "RS"
}, {
	"Nome": "Giruá",
	"uf": "RS"
}, {
	"Nome": "Glorinha",
	"uf": "RS"
}, {
	"Nome": "Gramado",
	"uf": "RS"
}, {
	"Nome": "Gramado dos Loureiros",
	"uf": "RS"
}, {
	"Nome": "Gramado Xavier",
	"uf": "RS"
}, {
	"Nome": "Gravataí",
	"uf": "RS"
}, {
	"Nome": "Guabiju",
	"uf": "RS"
}, {
	"Nome": "Guaíba",
	"uf": "RS"
}, {
	"Nome": "Guaporé",
	"uf": "RS"
}, {
	"Nome": "Guarani das Missões",
	"uf": "RS"
}, {
	"Nome": "Harmonia",
	"uf": "RS"
}, {
	"Nome": "Herval",
	"uf": "RS"
}, {
	"Nome": "Herveiras",
	"uf": "RS"
}, {
	"Nome": "Horizontina",
	"uf": "RS"
}, {
	"Nome": "Hulha Negra",
	"uf": "RS"
}, {
	"Nome": "Humaitá",
	"uf": "RS"
}, {
	"Nome": "Ibarama",
	"uf": "RS"
}, {
	"Nome": "Ibiaçá",
	"uf": "RS"
}, {
	"Nome": "Ibiraiaras",
	"uf": "RS"
}, {
	"Nome": "Ibirapuitã",
	"uf": "RS"
}, {
	"Nome": "Ibirubá",
	"uf": "RS"
}, {
	"Nome": "Igrejinha",
	"uf": "RS"
}, {
	"Nome": "Ijuí",
	"uf": "RS"
}, {
	"Nome": "Ilópolis",
	"uf": "RS"
}, {
	"Nome": "Imbé",
	"uf": "RS"
}, {
	"Nome": "Imigrante",
	"uf": "RS"
}, {
	"Nome": "Independência",
	"uf": "RS"
}, {
	"Nome": "Inhacorá",
	"uf": "RS"
}, {
	"Nome": "Ipê",
	"uf": "RS"
}, {
	"Nome": "Ipiranga do Sul",
	"uf": "RS"
}, {
	"Nome": "Iraí",
	"uf": "RS"
}, {
	"Nome": "Itaara",
	"uf": "RS"
}, {
	"Nome": "Itacurubi",
	"uf": "RS"
}, {
	"Nome": "Itapuca",
	"uf": "RS"
}, {
	"Nome": "Itaqui",
	"uf": "RS"
}, {
	"Nome": "Itati",
	"uf": "RS"
}, {
	"Nome": "Itatiba do Sul",
	"uf": "RS"
}, {
	"Nome": "Ivorá",
	"uf": "RS"
}, {
	"Nome": "Ivoti",
	"uf": "RS"
}, {
	"Nome": "Jaboticaba",
	"uf": "RS"
}, {
	"Nome": "Jacuizinho",
	"uf": "RS"
}, {
	"Nome": "Jacutinga",
	"uf": "RS"
}, {
	"Nome": "Jaguarão",
	"uf": "RS"
}, {
	"Nome": "Jaguari",
	"uf": "RS"
}, {
	"Nome": "Jaquirana",
	"uf": "RS"
}, {
	"Nome": "Jari",
	"uf": "RS"
}, {
	"Nome": "Jóia",
	"uf": "RS"
}, {
	"Nome": "Júlio de Castilhos",
	"uf": "RS"
}, {
	"Nome": "Lagoa Bonita do Sul",
	"uf": "RS"
}, {
	"Nome": "Lagoa dos Três Cantos",
	"uf": "RS"
}, {
	"Nome": "Lagoa Vermelha",
	"uf": "RS"
}, {
	"Nome": "Lagoão",
	"uf": "RS"
}, {
	"Nome": "Lajeado",
	"uf": "RS"
}, {
	"Nome": "Lajeado do Bugre",
	"uf": "RS"
}, {
	"Nome": "Lavras do Sul",
	"uf": "RS"
}, {
	"Nome": "Liberato Salzano",
	"uf": "RS"
}, {
	"Nome": "Lindolfo Collor",
	"uf": "RS"
}, {
	"Nome": "Linha Nova",
	"uf": "RS"
}, {
	"Nome": "Maçambara",
	"uf": "RS"
}, {
	"Nome": "Machadinho",
	"uf": "RS"
}, {
	"Nome": "Mampituba",
	"uf": "RS"
}, {
	"Nome": "Manoel Viana",
	"uf": "RS"
}, {
	"Nome": "Maquiné",
	"uf": "RS"
}, {
	"Nome": "Maratá",
	"uf": "RS"
}, {
	"Nome": "Marau",
	"uf": "RS"
}, {
	"Nome": "Marcelino Ramos",
	"uf": "RS"
}, {
	"Nome": "Mariana Pimentel",
	"uf": "RS"
}, {
	"Nome": "Mariano Moro",
	"uf": "RS"
}, {
	"Nome": "Marques de Souza",
	"uf": "RS"
}, {
	"Nome": "Mata",
	"uf": "RS"
}, {
	"Nome": "Mato Castelhano",
	"uf": "RS"
}, {
	"Nome": "Mato Leitão",
	"uf": "RS"
}, {
	"Nome": "Mato Queimado",
	"uf": "RS"
}, {
	"Nome": "Maximiliano de Almeida",
	"uf": "RS"
}, {
	"Nome": "Minas do Leão",
	"uf": "RS"
}, {
	"Nome": "Miraguaí",
	"uf": "RS"
}, {
	"Nome": "Montauri",
	"uf": "RS"
}, {
	"Nome": "Monte Alegre dos Campos",
	"uf": "RS"
}, {
	"Nome": "Monte Belo do Sul",
	"uf": "RS"
}, {
	"Nome": "Montenegro",
	"uf": "RS"
}, {
	"Nome": "Mormaço",
	"uf": "RS"
}, {
	"Nome": "Morrinhos do Sul",
	"uf": "RS"
}, {
	"Nome": "Morro Redondo",
	"uf": "RS"
}, {
	"Nome": "Morro Reuter",
	"uf": "RS"
}, {
	"Nome": "Mostardas",
	"uf": "RS"
}, {
	"Nome": "Muçum",
	"uf": "RS"
}, {
	"Nome": "Muitos Capões",
	"uf": "RS"
}, {
	"Nome": "Muliterno",
	"uf": "RS"
}, {
	"Nome": "Não-Me-Toque",
	"uf": "RS"
}, {
	"Nome": "Nicolau Vergueiro",
	"uf": "RS"
}, {
	"Nome": "Nonoai",
	"uf": "RS"
}, {
	"Nome": "Nova Alvorada",
	"uf": "RS"
}, {
	"Nome": "Nova Araçá",
	"uf": "RS"
}, {
	"Nome": "Nova Bassano",
	"uf": "RS"
}, {
	"Nome": "Nova Boa Vista",
	"uf": "RS"
}, {
	"Nome": "Nova Bréscia",
	"uf": "RS"
}, {
	"Nome": "Nova Candelária",
	"uf": "RS"
}, {
	"Nome": "Nova Esperança do Sul",
	"uf": "RS"
}, {
	"Nome": "Nova Hartz",
	"uf": "RS"
}, {
	"Nome": "Nova Pádua",
	"uf": "RS"
}, {
	"Nome": "Nova Palma",
	"uf": "RS"
}, {
	"Nome": "Nova Petrópolis",
	"uf": "RS"
}, {
	"Nome": "Nova Prata",
	"uf": "RS"
}, {
	"Nome": "Nova Ramada",
	"uf": "RS"
}, {
	"Nome": "Nova Roma do Sul",
	"uf": "RS"
}, {
	"Nome": "Nova Santa Rita",
	"uf": "RS"
}, {
	"Nome": "Novo Barreiro",
	"uf": "RS"
}, {
	"Nome": "Novo Cabrais",
	"uf": "RS"
}, {
	"Nome": "Novo Hamburgo",
	"uf": "RS"
}, {
	"Nome": "Novo Machado",
	"uf": "RS"
}, {
	"Nome": "Novo Tiradentes",
	"uf": "RS"
}, {
	"Nome": "Novo Xingu",
	"uf": "RS"
}, {
	"Nome": "Osório",
	"uf": "RS"
}, {
	"Nome": "Paim Filho",
	"uf": "RS"
}, {
	"Nome": "Palmares do Sul",
	"uf": "RS"
}, {
	"Nome": "Palmeira das Missões",
	"uf": "RS"
}, {
	"Nome": "Palmitinho",
	"uf": "RS"
}, {
	"Nome": "Panambi",
	"uf": "RS"
}, {
	"Nome": "Pantano Grande",
	"uf": "RS"
}, {
	"Nome": "Paraí",
	"uf": "RS"
}, {
	"Nome": "Paraíso do Sul",
	"uf": "RS"
}, {
	"Nome": "Pareci Novo",
	"uf": "RS"
}, {
	"Nome": "Parobé",
	"uf": "RS"
}, {
	"Nome": "Passa Sete",
	"uf": "RS"
}, {
	"Nome": "Passo do Sobrado",
	"uf": "RS"
}, {
	"Nome": "Passo Fundo",
	"uf": "RS"
}, {
	"Nome": "Paulo Bento",
	"uf": "RS"
}, {
	"Nome": "Paverama",
	"uf": "RS"
}, {
	"Nome": "Pedras Altas",
	"uf": "RS"
}, {
	"Nome": "Pedro Osório",
	"uf": "RS"
}, {
	"Nome": "Pejuçara",
	"uf": "RS"
}, {
	"Nome": "Pelotas",
	"uf": "RS"
}, {
	"Nome": "Picada Café",
	"uf": "RS"
}, {
	"Nome": "Pinhal",
	"uf": "RS"
}, {
	"Nome": "Pinhal da Serra",
	"uf": "RS"
}, {
	"Nome": "Pinhal Grande",
	"uf": "RS"
}, {
	"Nome": "Pinheirinho do Vale",
	"uf": "RS"
}, {
	"Nome": "Pinheiro Machado",
	"uf": "RS"
}, {
	"Nome": "Pirapó",
	"uf": "RS"
}, {
	"Nome": "Piratini",
	"uf": "RS"
}, {
	"Nome": "Planalto",
	"uf": "RS"
}, {
	"Nome": "Poço das Antas",
	"uf": "RS"
}, {
	"Nome": "Pontão",
	"uf": "RS"
}, {
	"Nome": "Ponte Preta",
	"uf": "RS"
}, {
	"Nome": "Portão",
	"uf": "RS"
}, {
	"Nome": "Porto Alegre",
	"uf": "RS"
}, {
	"Nome": "Porto Lucena",
	"uf": "RS"
}, {
	"Nome": "Porto Mauá",
	"uf": "RS"
}, {
	"Nome": "Porto Vera Cruz",
	"uf": "RS"
}, {
	"Nome": "Porto Xavier",
	"uf": "RS"
}, {
	"Nome": "Pouso Novo",
	"uf": "RS"
}, {
	"Nome": "Presidente Lucena",
	"uf": "RS"
}, {
	"Nome": "Progresso",
	"uf": "RS"
}, {
	"Nome": "Protásio Alves",
	"uf": "RS"
}, {
	"Nome": "Putinga",
	"uf": "RS"
}, {
	"Nome": "Quaraí",
	"uf": "RS"
}, {
	"Nome": "Quatro Irmãos",
	"uf": "RS"
}, {
	"Nome": "Quevedos",
	"uf": "RS"
}, {
	"Nome": "Quinze de Novembro",
	"uf": "RS"
}, {
	"Nome": "Redentora",
	"uf": "RS"
}, {
	"Nome": "Relvado",
	"uf": "RS"
}, {
	"Nome": "Restinga Seca",
	"uf": "RS"
}, {
	"Nome": "Rio dos Índios",
	"uf": "RS"
}, {
	"Nome": "Rio Grande",
	"uf": "RS"
}, {
	"Nome": "Rio Pardo",
	"uf": "RS"
}, {
	"Nome": "Riozinho",
	"uf": "RS"
}, {
	"Nome": "Roca Sales",
	"uf": "RS"
}, {
	"Nome": "Rodeio Bonito",
	"uf": "RS"
}, {
	"Nome": "Rolador",
	"uf": "RS"
}, {
	"Nome": "Rolante",
	"uf": "RS"
}, {
	"Nome": "Ronda Alta",
	"uf": "RS"
}, {
	"Nome": "Rondinha",
	"uf": "RS"
}, {
	"Nome": "Roque Gonzales",
	"uf": "RS"
}, {
	"Nome": "Rosário do Sul",
	"uf": "RS"
}, {
	"Nome": "Sagrada Família",
	"uf": "RS"
}, {
	"Nome": "Saldanha Marinho",
	"uf": "RS"
}, {
	"Nome": "Salto do Jacuí",
	"uf": "RS"
}, {
	"Nome": "Salvador das Missões",
	"uf": "RS"
}, {
	"Nome": "Salvador do Sul",
	"uf": "RS"
}, {
	"Nome": "Sananduva",
	"uf": "RS"
}, {
	"Nome": "Santa Bárbara do Sul",
	"uf": "RS"
}, {
	"Nome": "Santa Cecília do Sul",
	"uf": "RS"
}, {
	"Nome": "Santa Clara do Sul",
	"uf": "RS"
}, {
	"Nome": "Santa Cruz do Sul",
	"uf": "RS"
}, {
	"Nome": "Santa Margarida do Sul",
	"uf": "RS"
}, {
	"Nome": "Santa Maria",
	"uf": "RS"
}, {
	"Nome": "Santa Maria do Herval",
	"uf": "RS"
}, {
	"Nome": "Santa Rosa",
	"uf": "RS"
}, {
	"Nome": "Santa Tereza",
	"uf": "RS"
}, {
	"Nome": "Santa Vitória do Palmar",
	"uf": "RS"
}, {
	"Nome": "Santana da Boa Vista",
	"uf": "RS"
}, {
	"Nome": "Santana do Livramento",
	"uf": "RS"
}, {
	"Nome": "Santiago",
	"uf": "RS"
}, {
	"Nome": "Santo Ângelo",
	"uf": "RS"
}, {
	"Nome": "Santo Antônio da Patrulha",
	"uf": "RS"
}, {
	"Nome": "Santo Antônio das Missões",
	"uf": "RS"
}, {
	"Nome": "Santo Antônio do Palma",
	"uf": "RS"
}, {
	"Nome": "Santo Antônio do Planalto",
	"uf": "RS"
}, {
	"Nome": "Santo Augusto",
	"uf": "RS"
}, {
	"Nome": "Santo Cristo",
	"uf": "RS"
}, {
	"Nome": "Santo Expedito do Sul",
	"uf": "RS"
}, {
	"Nome": "São Borja",
	"uf": "RS"
}, {
	"Nome": "São Domingos do Sul",
	"uf": "RS"
}, {
	"Nome": "São Francisco de Assis",
	"uf": "RS"
}, {
	"Nome": "São Francisco de Paula",
	"uf": "RS"
}, {
	"Nome": "São Gabriel",
	"uf": "RS"
}, {
	"Nome": "São Jerônimo",
	"uf": "RS"
}, {
	"Nome": "São João da Urtiga",
	"uf": "RS"
}, {
	"Nome": "São João do Polêsine",
	"uf": "RS"
}, {
	"Nome": "São Jorge",
	"uf": "RS"
}, {
	"Nome": "São José das Missões",
	"uf": "RS"
}, {
	"Nome": "São José do Herval",
	"uf": "RS"
}, {
	"Nome": "São José do Hortêncio",
	"uf": "RS"
}, {
	"Nome": "São José do Inhacorá",
	"uf": "RS"
}, {
	"Nome": "São José do Norte",
	"uf": "RS"
}, {
	"Nome": "São José do Ouro",
	"uf": "RS"
}, {
	"Nome": "São José do Sul",
	"uf": "RS"
}, {
	"Nome": "São José dos Ausentes",
	"uf": "RS"
}, {
	"Nome": "São Leopoldo",
	"uf": "RS"
}, {
	"Nome": "São Lourenço do Sul",
	"uf": "RS"
}, {
	"Nome": "São Luiz Gonzaga",
	"uf": "RS"
}, {
	"Nome": "São Marcos",
	"uf": "RS"
}, {
	"Nome": "São Martinho",
	"uf": "RS"
}, {
	"Nome": "São Martinho da Serra",
	"uf": "RS"
}, {
	"Nome": "São Miguel das Missões",
	"uf": "RS"
}, {
	"Nome": "São Nicolau",
	"uf": "RS"
}, {
	"Nome": "São Paulo das Missões",
	"uf": "RS"
}, {
	"Nome": "São Pedro da Serra",
	"uf": "RS"
}, {
	"Nome": "São Pedro das Missões",
	"uf": "RS"
}, {
	"Nome": "São Pedro do Butiá",
	"uf": "RS"
}, {
	"Nome": "São Pedro do Sul",
	"uf": "RS"
}, {
	"Nome": "São Sebastião do Caí",
	"uf": "RS"
}, {
	"Nome": "São Sepé",
	"uf": "RS"
}, {
	"Nome": "São Valentim",
	"uf": "RS"
}, {
	"Nome": "São Valentim do Sul",
	"uf": "RS"
}, {
	"Nome": "São Valério do Sul",
	"uf": "RS"
}, {
	"Nome": "São Vendelino",
	"uf": "RS"
}, {
	"Nome": "São Vicente do Sul",
	"uf": "RS"
}, {
	"Nome": "Sapiranga",
	"uf": "RS"
}, {
	"Nome": "Sapucaia do Sul",
	"uf": "RS"
}, {
	"Nome": "Sarandi",
	"uf": "RS"
}, {
	"Nome": "Seberi",
	"uf": "RS"
}, {
	"Nome": "Sede Nova",
	"uf": "RS"
}, {
	"Nome": "Segredo",
	"uf": "RS"
}, {
	"Nome": "Selbach",
	"uf": "RS"
}, {
	"Nome": "Senador Salgado Filho",
	"uf": "RS"
}, {
	"Nome": "Sentinela do Sul",
	"uf": "RS"
}, {
	"Nome": "Serafina Corrêa",
	"uf": "RS"
}, {
	"Nome": "Sério",
	"uf": "RS"
}, {
	"Nome": "Sertão",
	"uf": "RS"
}, {
	"Nome": "Sertão Santana",
	"uf": "RS"
}, {
	"Nome": "Sete de Setembro",
	"uf": "RS"
}, {
	"Nome": "Severiano de Almeida",
	"uf": "RS"
}, {
	"Nome": "Silveira Martins",
	"uf": "RS"
}, {
	"Nome": "Sinimbu",
	"uf": "RS"
}, {
	"Nome": "Sobradinho",
	"uf": "RS"
}, {
	"Nome": "Soledade",
	"uf": "RS"
}, {
	"Nome": "Tabaí",
	"uf": "RS"
}, {
	"Nome": "Tapejara",
	"uf": "RS"
}, {
	"Nome": "Tapera",
	"uf": "RS"
}, {
	"Nome": "Tapes",
	"uf": "RS"
}, {
	"Nome": "Taquara",
	"uf": "RS"
}, {
	"Nome": "Taquari",
	"uf": "RS"
}, {
	"Nome": "Taquaruçu do Sul",
	"uf": "RS"
}, {
	"Nome": "Tavares",
	"uf": "RS"
}, {
	"Nome": "Tenente Portela",
	"uf": "RS"
}, {
	"Nome": "Terra de Areia",
	"uf": "RS"
}, {
	"Nome": "Teutônia",
	"uf": "RS"
}, {
	"Nome": "Tio Hugo",
	"uf": "RS"
}, {
	"Nome": "Tiradentes do Sul",
	"uf": "RS"
}, {
	"Nome": "Toropi",
	"uf": "RS"
}, {
	"Nome": "Torres",
	"uf": "RS"
}, {
	"Nome": "Tramandaí",
	"uf": "RS"
}, {
	"Nome": "Travesseiro",
	"uf": "RS"
}, {
	"Nome": "Três Arroios",
	"uf": "RS"
}, {
	"Nome": "Três Cachoeiras",
	"uf": "RS"
}, {
	"Nome": "Três Coroas",
	"uf": "RS"
}, {
	"Nome": "Três de Maio",
	"uf": "RS"
}, {
	"Nome": "Três Forquilhas",
	"uf": "RS"
}, {
	"Nome": "Três Palmeiras",
	"uf": "RS"
}, {
	"Nome": "Três Passos",
	"uf": "RS"
}, {
	"Nome": "Trindade do Sul",
	"uf": "RS"
}, {
	"Nome": "Triunfo",
	"uf": "RS"
}, {
	"Nome": "Tucunduva",
	"uf": "RS"
}, {
	"Nome": "Tunas",
	"uf": "RS"
}, {
	"Nome": "Tupanci do Sul",
	"uf": "RS"
}, {
	"Nome": "Tupanciretã",
	"uf": "RS"
}, {
	"Nome": "Tupandi",
	"uf": "RS"
}, {
	"Nome": "Tuparendi",
	"uf": "RS"
}, {
	"Nome": "Turuçu",
	"uf": "RS"
}, {
	"Nome": "Ubiretama",
	"uf": "RS"
}, {
	"Nome": "União da Serra",
	"uf": "RS"
}, {
	"Nome": "Unistalda",
	"uf": "RS"
}, {
	"Nome": "Uruguaiana",
	"uf": "RS"
}, {
	"Nome": "Vacaria",
	"uf": "RS"
}, {
	"Nome": "Vale do Sol",
	"uf": "RS"
}, {
	"Nome": "Vale Real",
	"uf": "RS"
}, {
	"Nome": "Vale Verde",
	"uf": "RS"
}, {
	"Nome": "Vanini",
	"uf": "RS"
}, {
	"Nome": "Venâncio Aires",
	"uf": "RS"
}, {
	"Nome": "Vera Cruz",
	"uf": "RS"
}, {
	"Nome": "Veranópolis",
	"uf": "RS"
}, {
	"Nome": "Vespasiano Correa",
	"uf": "RS"
}, {
	"Nome": "Viadutos",
	"uf": "RS"
}, {
	"Nome": "Viamão",
	"uf": "RS"
}, {
	"Nome": "Vicente Dutra",
	"uf": "RS"
}, {
	"Nome": "Victor Graeff",
	"uf": "RS"
}, {
	"Nome": "Vila Flores",
	"uf": "RS"
}, {
	"Nome": "Vila Lângaro",
	"uf": "RS"
}, {
	"Nome": "Vila Maria",
	"uf": "RS"
}, {
	"Nome": "Vila Nova do Sul",
	"uf": "RS"
}, {
	"Nome": "Vista Alegre",
	"uf": "RS"
}, {
	"Nome": "Vista Alegre do Prata",
	"uf": "RS"
}, {
	"Nome": "Vista Gaúcha",
	"uf": "RS"
}, {
	"Nome": "Vitória das Missões",
	"uf": "RS"
}, {
	"Nome": "Westfália",
	"uf": "RS"
}, {
	"Nome": "Xangri-lá",
	"uf": "RS"
}, {
	"Nome": "Alta Floresta d`Oeste",
	"uf": "RO"
}, {
	"Nome": "Alto Alegre dos Parecis",
	"uf": "RO"
}, {
	"Nome": "Alto Paraíso",
	"uf": "RO"
}, {
	"Nome": "Alvorada d`Oeste",
	"uf": "RO"
}, {
	"Nome": "Ariquemes",
	"uf": "RO"
}, {
	"Nome": "Buritis",
	"uf": "RO"
}, {
	"Nome": "Cabixi",
	"uf": "RO"
}, {
	"Nome": "Cacaulândia",
	"uf": "RO"
}, {
	"Nome": "Cacoal",
	"uf": "RO"
}, {
	"Nome": "Campo Novo de Rondônia",
	"uf": "RO"
}, {
	"Nome": "Candeias do Jamari",
	"uf": "RO"
}, {
	"Nome": "Castanheiras",
	"uf": "RO"
}, {
	"Nome": "Cerejeiras",
	"uf": "RO"
}, {
	"Nome": "Chupinguaia",
	"uf": "RO"
}, {
	"Nome": "Colorado do Oeste",
	"uf": "RO"
}, {
	"Nome": "Corumbiara",
	"uf": "RO"
}, {
	"Nome": "Costa Marques",
	"uf": "RO"
}, {
	"Nome": "Cujubim",
	"uf": "RO"
}, {
	"Nome": "Espigão d`Oeste",
	"uf": "RO"
}, {
	"Nome": "Governador Jorge Teixeira",
	"uf": "RO"
}, {
	"Nome": "Guajará-Mirim",
	"uf": "RO"
}, {
	"Nome": "Itapuã do Oeste",
	"uf": "RO"
}, {
	"Nome": "Jaru",
	"uf": "RO"
}, {
	"Nome": "Ji-Paraná",
	"uf": "RO"
}, {
	"Nome": "Machadinho d`Oeste",
	"uf": "RO"
}, {
	"Nome": "Ministro Andreazza",
	"uf": "RO"
}, {
	"Nome": "Mirante da Serra",
	"uf": "RO"
}, {
	"Nome": "Monte Negro",
	"uf": "RO"
}, {
	"Nome": "Nova Brasilândia d`Oeste",
	"uf": "RO"
}, {
	"Nome": "Nova Mamoré",
	"uf": "RO"
}, {
	"Nome": "Nova União",
	"uf": "RO"
}, {
	"Nome": "Novo Horizonte do Oeste",
	"uf": "RO"
}, {
	"Nome": "Ouro Preto do Oeste",
	"uf": "RO"
}, {
	"Nome": "Parecis",
	"uf": "RO"
}, {
	"Nome": "Pimenta Bueno",
	"uf": "RO"
}, {
	"Nome": "Pimenteiras do Oeste",
	"uf": "RO"
}, {
	"Nome": "Porto Velho",
	"uf": "RO"
}, {
	"Nome": "Presidente Médici",
	"uf": "RO"
}, {
	"Nome": "Primavera de Rondônia",
	"uf": "RO"
}, {
	"Nome": "Rio Crespo",
	"uf": "RO"
}, {
	"Nome": "Rolim de Moura",
	"uf": "RO"
}, {
	"Nome": "Santa Luzia d`Oeste",
	"uf": "RO"
}, {
	"Nome": "São Felipe d`Oeste",
	"uf": "RO"
}, {
	"Nome": "São Francisco do Guaporé",
	"uf": "RO"
}, {
	"Nome": "São Miguel do Guaporé",
	"uf": "RO"
}, {
	"Nome": "Seringueiras",
	"uf": "RO"
}, {
	"Nome": "Teixeirópolis",
	"uf": "RO"
}, {
	"Nome": "Theobroma",
	"uf": "RO"
}, {
	"Nome": "Urupá",
	"uf": "RO"
}, {
	"Nome": "Vale do Anari",
	"uf": "RO"
}, {
	"Nome": "Vale do Paraíso",
	"uf": "RO"
}, {
	"Nome": "Vilhena",
	"uf": "RO"
}, {
	"Nome": "Alto Alegre",
	"uf": "RR"
}, {
	"Nome": "Amajari",
	"uf": "RR"
}, {
	"Nome": "Boa Vista",
	"uf": "RR"
}, {
	"Nome": "Bonfim",
	"uf": "RR"
}, {
	"Nome": "Cantá",
	"uf": "RR"
}, {
	"Nome": "Caracaraí",
	"uf": "RR"
}, {
	"Nome": "Caroebe",
	"uf": "RR"
}, {
	"Nome": "Iracema",
	"uf": "RR"
}, {
	"Nome": "Mucajaí",
	"uf": "RR"
}, {
	"Nome": "Normandia",
	"uf": "RR"
}, {
	"Nome": "Pacaraima",
	"uf": "RR"
}, {
	"Nome": "Rorainópolis",
	"uf": "RR"
}, {
	"Nome": "São João da Baliza",
	"uf": "RR"
}, {
	"Nome": "São Luiz",
	"uf": "RR"
}, {
	"Nome": "Uiramutã",
	"uf": "RR"
}, {
	"Nome": "Abdon Batista",
	"uf": "SC"
}, {
	"Nome": "Abelardo Luz",
	"uf": "SC"
}, {
	"Nome": "Agrolândia",
	"uf": "SC"
}, {
	"Nome": "Agronômica",
	"uf": "SC"
}, {
	"Nome": "Água Doce",
	"uf": "SC"
}, {
	"Nome": "Águas de Chapecó",
	"uf": "SC"
}, {
	"Nome": "Águas Frias",
	"uf": "SC"
}, {
	"Nome": "Águas Mornas",
	"uf": "SC"
}, {
	"Nome": "Alfredo Wagner",
	"uf": "SC"
}, {
	"Nome": "Alto Bela Vista",
	"uf": "SC"
}, {
	"Nome": "Anchieta",
	"uf": "SC"
}, {
	"Nome": "Angelina",
	"uf": "SC"
}, {
	"Nome": "Anita Garibaldi",
	"uf": "SC"
}, {
	"Nome": "Anitápolis",
	"uf": "SC"
}, {
	"Nome": "Antônio Carlos",
	"uf": "SC"
}, {
	"Nome": "Apiúna",
	"uf": "SC"
}, {
	"Nome": "Arabutã",
	"uf": "SC"
}, {
	"Nome": "Araquari",
	"uf": "SC"
}, {
	"Nome": "Araranguá",
	"uf": "SC"
}, {
	"Nome": "Armazém",
	"uf": "SC"
}, {
	"Nome": "Arroio Trinta",
	"uf": "SC"
}, {
	"Nome": "Arvoredo",
	"uf": "SC"
}, {
	"Nome": "Ascurra",
	"uf": "SC"
}, {
	"Nome": "Atalanta",
	"uf": "SC"
}, {
	"Nome": "Aurora",
	"uf": "SC"
}, {
	"Nome": "Balneário Arroio do Silva",
	"uf": "SC"
}, {
	"Nome": "Balneário Barra do Sul",
	"uf": "SC"
}, {
	"Nome": "Balneário Camboriú",
	"uf": "SC"
}, {
	"Nome": "Balneário Gaivota",
	"uf": "SC"
}, {
	"Nome": "Bandeirante",
	"uf": "SC"
}, {
	"Nome": "Barra Bonita",
	"uf": "SC"
}, {
	"Nome": "Barra Velha",
	"uf": "SC"
}, {
	"Nome": "Bela Vista do Toldo",
	"uf": "SC"
}, {
	"Nome": "Belmonte",
	"uf": "SC"
}, {
	"Nome": "Benedito Novo",
	"uf": "SC"
}, {
	"Nome": "Biguaçu",
	"uf": "SC"
}, {
	"Nome": "Blumenau",
	"uf": "SC"
}, {
	"Nome": "Bocaina do Sul",
	"uf": "SC"
}, {
	"Nome": "Bom Jardim da Serra",
	"uf": "SC"
}, {
	"Nome": "Bom Jesus",
	"uf": "SC"
}, {
	"Nome": "Bom Jesus do Oeste",
	"uf": "SC"
}, {
	"Nome": "Bom Retiro",
	"uf": "SC"
}, {
	"Nome": "Bombinhas",
	"uf": "SC"
}, {
	"Nome": "Botuverá",
	"uf": "SC"
}, {
	"Nome": "Braço do Norte",
	"uf": "SC"
}, {
	"Nome": "Braço do Trombudo",
	"uf": "SC"
}, {
	"Nome": "Brunópolis",
	"uf": "SC"
}, {
	"Nome": "Brusque",
	"uf": "SC"
}, {
	"Nome": "Caçador",
	"uf": "SC"
}, {
	"Nome": "Caibi",
	"uf": "SC"
}, {
	"Nome": "Calmon",
	"uf": "SC"
}, {
	"Nome": "Camboriú",
	"uf": "SC"
}, {
	"Nome": "Campo Alegre",
	"uf": "SC"
}, {
	"Nome": "Campo Belo do Sul",
	"uf": "SC"
}, {
	"Nome": "Campo Erê",
	"uf": "SC"
}, {
	"Nome": "Campos Novos",
	"uf": "SC"
}, {
	"Nome": "Canelinha",
	"uf": "SC"
}, {
	"Nome": "Canoinhas",
	"uf": "SC"
}, {
	"Nome": "Capão Alto",
	"uf": "SC"
}, {
	"Nome": "Capinzal",
	"uf": "SC"
}, {
	"Nome": "Capivari de Baixo",
	"uf": "SC"
}, {
	"Nome": "Catanduvas",
	"uf": "SC"
}, {
	"Nome": "Caxambu do Sul",
	"uf": "SC"
}, {
	"Nome": "Celso Ramos",
	"uf": "SC"
}, {
	"Nome": "Cerro Negro",
	"uf": "SC"
}, {
	"Nome": "Chapadão do Lageado",
	"uf": "SC"
}, {
	"Nome": "Chapecó",
	"uf": "SC"
}, {
	"Nome": "Cocal do Sul",
	"uf": "SC"
}, {
	"Nome": "Concórdia",
	"uf": "SC"
}, {
	"Nome": "Cordilheira Alta",
	"uf": "SC"
}, {
	"Nome": "Coronel Freitas",
	"uf": "SC"
}, {
	"Nome": "Coronel Martins",
	"uf": "SC"
}, {
	"Nome": "Correia Pinto",
	"uf": "SC"
}, {
	"Nome": "Corupá",
	"uf": "SC"
}, {
	"Nome": "Criciúma",
	"uf": "SC"
}, {
	"Nome": "Cunha Porã",
	"uf": "SC"
}, {
	"Nome": "Cunhataí",
	"uf": "SC"
}, {
	"Nome": "Curitibanos",
	"uf": "SC"
}, {
	"Nome": "Descanso",
	"uf": "SC"
}, {
	"Nome": "Dionísio Cerqueira",
	"uf": "SC"
}, {
	"Nome": "Dona Emma",
	"uf": "SC"
}, {
	"Nome": "Doutor Pedrinho",
	"uf": "SC"
}, {
	"Nome": "Entre Rios",
	"uf": "SC"
}, {
	"Nome": "Ermo",
	"uf": "SC"
}, {
	"Nome": "Erval Velho",
	"uf": "SC"
}, {
	"Nome": "Faxinal dos Guedes",
	"uf": "SC"
}, {
	"Nome": "Flor do Sertão",
	"uf": "SC"
}, {
	"Nome": "Florianópolis",
	"uf": "SC"
}, {
	"Nome": "Formosa do Sul",
	"uf": "SC"
}, {
	"Nome": "Forquilhinha",
	"uf": "SC"
}, {
	"Nome": "Fraiburgo",
	"uf": "SC"
}, {
	"Nome": "Frei Rogério",
	"uf": "SC"
}, {
	"Nome": "Galvão",
	"uf": "SC"
}, {
	"Nome": "Garopaba",
	"uf": "SC"
}, {
	"Nome": "Garuva",
	"uf": "SC"
}, {
	"Nome": "Gaspar",
	"uf": "SC"
}, {
	"Nome": "Governador Celso Ramos",
	"uf": "SC"
}, {
	"Nome": "Grão Pará",
	"uf": "SC"
}, {
	"Nome": "Gravatal",
	"uf": "SC"
}, {
	"Nome": "Guabiruba",
	"uf": "SC"
}, {
	"Nome": "Guaraciaba",
	"uf": "SC"
}, {
	"Nome": "Guaramirim",
	"uf": "SC"
}, {
	"Nome": "Guarujá do Sul",
	"uf": "SC"
}, {
	"Nome": "Guatambú",
	"uf": "SC"
}, {
	"Nome": "Herval d`Oeste",
	"uf": "SC"
}, {
	"Nome": "Ibiam",
	"uf": "SC"
}, {
	"Nome": "Ibicaré",
	"uf": "SC"
}, {
	"Nome": "Ibirama",
	"uf": "SC"
}, {
	"Nome": "Içara",
	"uf": "SC"
}, {
	"Nome": "Ilhota",
	"uf": "SC"
}, {
	"Nome": "Imaruí",
	"uf": "SC"
}, {
	"Nome": "Imbituba",
	"uf": "SC"
}, {
	"Nome": "Imbuia",
	"uf": "SC"
}, {
	"Nome": "Indaial",
	"uf": "SC"
}, {
	"Nome": "Iomerê",
	"uf": "SC"
}, {
	"Nome": "Ipira",
	"uf": "SC"
}, {
	"Nome": "Iporã do Oeste",
	"uf": "SC"
}, {
	"Nome": "Ipuaçu",
	"uf": "SC"
}, {
	"Nome": "Ipumirim",
	"uf": "SC"
}, {
	"Nome": "Iraceminha",
	"uf": "SC"
}, {
	"Nome": "Irani",
	"uf": "SC"
}, {
	"Nome": "Irati",
	"uf": "SC"
}, {
	"Nome": "Irineópolis",
	"uf": "SC"
}, {
	"Nome": "Itá",
	"uf": "SC"
}, {
	"Nome": "Itaiópolis",
	"uf": "SC"
}, {
	"Nome": "Itajaí",
	"uf": "SC"
}, {
	"Nome": "Itapema",
	"uf": "SC"
}, {
	"Nome": "Itapiranga",
	"uf": "SC"
}, {
	"Nome": "Itapoá",
	"uf": "SC"
}, {
	"Nome": "Ituporanga",
	"uf": "SC"
}, {
	"Nome": "Jaborá",
	"uf": "SC"
}, {
	"Nome": "Jacinto Machado",
	"uf": "SC"
}, {
	"Nome": "Jaguaruna",
	"uf": "SC"
}, {
	"Nome": "Jaraguá do Sul",
	"uf": "SC"
}, {
	"Nome": "Jardinópolis",
	"uf": "SC"
}, {
	"Nome": "Joaçaba",
	"uf": "SC"
}, {
	"Nome": "Joinville",
	"uf": "SC"
}, {
	"Nome": "José Boiteux",
	"uf": "SC"
}, {
	"Nome": "Jupiá",
	"uf": "SC"
}, {
	"Nome": "Lacerdópolis",
	"uf": "SC"
}, {
	"Nome": "Lages",
	"uf": "SC"
}, {
	"Nome": "Laguna",
	"uf": "SC"
}, {
	"Nome": "Lajeado Grande",
	"uf": "SC"
}, {
	"Nome": "Laurentino",
	"uf": "SC"
}, {
	"Nome": "Lauro Muller",
	"uf": "SC"
}, {
	"Nome": "Lebon Régis",
	"uf": "SC"
}, {
	"Nome": "Leoberto Leal",
	"uf": "SC"
}, {
	"Nome": "Lindóia do Sul",
	"uf": "SC"
}, {
	"Nome": "Lontras",
	"uf": "SC"
}, {
	"Nome": "Luiz Alves",
	"uf": "SC"
}, {
	"Nome": "Luzerna",
	"uf": "SC"
}, {
	"Nome": "Macieira",
	"uf": "SC"
}, {
	"Nome": "Mafra",
	"uf": "SC"
}, {
	"Nome": "Major Gercino",
	"uf": "SC"
}, {
	"Nome": "Major Vieira",
	"uf": "SC"
}, {
	"Nome": "Maracajá",
	"uf": "SC"
}, {
	"Nome": "Maravilha",
	"uf": "SC"
}, {
	"Nome": "Marema",
	"uf": "SC"
}, {
	"Nome": "Massaranduba",
	"uf": "SC"
}, {
	"Nome": "Matos Costa",
	"uf": "SC"
}, {
	"Nome": "Meleiro",
	"uf": "SC"
}, {
	"Nome": "Mirim Doce",
	"uf": "SC"
}, {
	"Nome": "Modelo",
	"uf": "SC"
}, {
	"Nome": "Mondaí",
	"uf": "SC"
}, {
	"Nome": "Monte Carlo",
	"uf": "SC"
}, {
	"Nome": "Monte Castelo",
	"uf": "SC"
}, {
	"Nome": "Morro da Fumaça",
	"uf": "SC"
}, {
	"Nome": "Morro Grande",
	"uf": "SC"
}, {
	"Nome": "Navegantes",
	"uf": "SC"
}, {
	"Nome": "Nova Erechim",
	"uf": "SC"
}, {
	"Nome": "Nova Itaberaba",
	"uf": "SC"
}, {
	"Nome": "Nova Trento",
	"uf": "SC"
}, {
	"Nome": "Nova Veneza",
	"uf": "SC"
}, {
	"Nome": "Novo Horizonte",
	"uf": "SC"
}, {
	"Nome": "Orleans",
	"uf": "SC"
}, {
	"Nome": "Otacílio Costa",
	"uf": "SC"
}, {
	"Nome": "Ouro",
	"uf": "SC"
}, {
	"Nome": "Ouro Verde",
	"uf": "SC"
}, {
	"Nome": "Paial",
	"uf": "SC"
}, {
	"Nome": "Painel",
	"uf": "SC"
}, {
	"Nome": "Palhoça",
	"uf": "SC"
}, {
	"Nome": "Palma Sola",
	"uf": "SC"
}, {
	"Nome": "Palmeira",
	"uf": "SC"
}, {
	"Nome": "Palmitos",
	"uf": "SC"
}, {
	"Nome": "Papanduva",
	"uf": "SC"
}, {
	"Nome": "Paraíso",
	"uf": "SC"
}, {
	"Nome": "Passo de Torres",
	"uf": "SC"
}, {
	"Nome": "Passos Maia",
	"uf": "SC"
}, {
	"Nome": "Paulo Lopes",
	"uf": "SC"
}, {
	"Nome": "Pedras Grandes",
	"uf": "SC"
}, {
	"Nome": "Penha",
	"uf": "SC"
}, {
	"Nome": "Peritiba",
	"uf": "SC"
}, {
	"Nome": "Petrolândia",
	"uf": "SC"
}, {
	"Nome": "Piçarras",
	"uf": "SC"
}, {
	"Nome": "Pinhalzinho",
	"uf": "SC"
}, {
	"Nome": "Pinheiro Preto",
	"uf": "SC"
}, {
	"Nome": "Piratuba",
	"uf": "SC"
}, {
	"Nome": "Planalto Alegre",
	"uf": "SC"
}, {
	"Nome": "Pomerode",
	"uf": "SC"
}, {
	"Nome": "Ponte Alta",
	"uf": "SC"
}, {
	"Nome": "Ponte Alta do Norte",
	"uf": "SC"
}, {
	"Nome": "Ponte Serrada",
	"uf": "SC"
}, {
	"Nome": "Porto Belo",
	"uf": "SC"
}, {
	"Nome": "Porto União",
	"uf": "SC"
}, {
	"Nome": "Pouso Redondo",
	"uf": "SC"
}, {
	"Nome": "Praia Grande",
	"uf": "SC"
}, {
	"Nome": "Presidente Castelo Branco",
	"uf": "SC"
}, {
	"Nome": "Presidente Getúlio",
	"uf": "SC"
}, {
	"Nome": "Presidente Nereu",
	"uf": "SC"
}, {
	"Nome": "Princesa",
	"uf": "SC"
}, {
	"Nome": "Quilombo",
	"uf": "SC"
}, {
	"Nome": "Rancho Queimado",
	"uf": "SC"
}, {
	"Nome": "Rio das Antas",
	"uf": "SC"
}, {
	"Nome": "Rio do Campo",
	"uf": "SC"
}, {
	"Nome": "Rio do Oeste",
	"uf": "SC"
}, {
	"Nome": "Rio do Sul",
	"uf": "SC"
}, {
	"Nome": "Rio dos Cedros",
	"uf": "SC"
}, {
	"Nome": "Rio Fortuna",
	"uf": "SC"
}, {
	"Nome": "Rio Negrinho",
	"uf": "SC"
}, {
	"Nome": "Rio Rufino",
	"uf": "SC"
}, {
	"Nome": "Riqueza",
	"uf": "SC"
}, {
	"Nome": "Rodeio",
	"uf": "SC"
}, {
	"Nome": "Romelândia",
	"uf": "SC"
}, {
	"Nome": "Salete",
	"uf": "SC"
}, {
	"Nome": "Saltinho",
	"uf": "SC"
}, {
	"Nome": "Salto Veloso",
	"uf": "SC"
}, {
	"Nome": "Sangão",
	"uf": "SC"
}, {
	"Nome": "Santa Cecília",
	"uf": "SC"
}, {
	"Nome": "Santa Helena",
	"uf": "SC"
}, {
	"Nome": "Santa Rosa de Lima",
	"uf": "SC"
}, {
	"Nome": "Santa Rosa do Sul",
	"uf": "SC"
}, {
	"Nome": "Santa Terezinha",
	"uf": "SC"
}, {
	"Nome": "Santa Terezinha do Progresso",
	"uf": "SC"
}, {
	"Nome": "Santiago do Sul",
	"uf": "SC"
}, {
	"Nome": "Santo Amaro da Imperatriz",
	"uf": "SC"
}, {
	"Nome": "São Bento do Sul",
	"uf": "SC"
}, {
	"Nome": "São Bernardino",
	"uf": "SC"
}, {
	"Nome": "São Bonifácio",
	"uf": "SC"
}, {
	"Nome": "São Carlos",
	"uf": "SC"
}, {
	"Nome": "São Cristovão do Sul",
	"uf": "SC"
}, {
	"Nome": "São Domingos",
	"uf": "SC"
}, {
	"Nome": "São Francisco do Sul",
	"uf": "SC"
}, {
	"Nome": "São João Batista",
	"uf": "SC"
}, {
	"Nome": "São João do Itaperiú",
	"uf": "SC"
}, {
	"Nome": "São João do Oeste",
	"uf": "SC"
}, {
	"Nome": "São João do Sul",
	"uf": "SC"
}, {
	"Nome": "São Joaquim",
	"uf": "SC"
}, {
	"Nome": "São José",
	"uf": "SC"
}, {
	"Nome": "São José do Cedro",
	"uf": "SC"
}, {
	"Nome": "São José do Cerrito",
	"uf": "SC"
}, {
	"Nome": "São Lourenço do Oeste",
	"uf": "SC"
}, {
	"Nome": "São Ludgero",
	"uf": "SC"
}, {
	"Nome": "São Martinho",
	"uf": "SC"
}, {
	"Nome": "São Miguel da Boa Vista",
	"uf": "SC"
}, {
	"Nome": "São Miguel do Oeste",
	"uf": "SC"
}, {
	"Nome": "São Pedro de Alcântara",
	"uf": "SC"
}, {
	"Nome": "Saudades",
	"uf": "SC"
}, {
	"Nome": "Schroeder",
	"uf": "SC"
}, {
	"Nome": "Seara",
	"uf": "SC"
}, {
	"Nome": "Serra Alta",
	"uf": "SC"
}, {
	"Nome": "Siderópolis",
	"uf": "SC"
}, {
	"Nome": "Sombrio",
	"uf": "SC"
}, {
	"Nome": "Sul Brasil",
	"uf": "SC"
}, {
	"Nome": "Taió",
	"uf": "SC"
}, {
	"Nome": "Tangará",
	"uf": "SC"
}, {
	"Nome": "Tigrinhos",
	"uf": "SC"
}, {
	"Nome": "Tijucas",
	"uf": "SC"
}, {
	"Nome": "Timbé do Sul",
	"uf": "SC"
}, {
	"Nome": "Timbó",
	"uf": "SC"
}, {
	"Nome": "Timbó Grande",
	"uf": "SC"
}, {
	"Nome": "Três Barras",
	"uf": "SC"
}, {
	"Nome": "Treviso",
	"uf": "SC"
}, {
	"Nome": "Treze de Maio",
	"uf": "SC"
}, {
	"Nome": "Treze Tílias",
	"uf": "SC"
}, {
	"Nome": "Trombudo Central",
	"uf": "SC"
}, {
	"Nome": "Tubarão",
	"uf": "SC"
}, {
	"Nome": "Tunápolis",
	"uf": "SC"
}, {
	"Nome": "Turvo",
	"uf": "SC"
}, {
	"Nome": "União do Oeste",
	"uf": "SC"
}, {
	"Nome": "Urubici",
	"uf": "SC"
}, {
	"Nome": "Urupema",
	"uf": "SC"
}, {
	"Nome": "Urussanga",
	"uf": "SC"
}, {
	"Nome": "Vargeão",
	"uf": "SC"
}, {
	"Nome": "Vargem",
	"uf": "SC"
}, {
	"Nome": "Vargem Bonita",
	"uf": "SC"
}, {
	"Nome": "Vidal Ramos",
	"uf": "SC"
}, {
	"Nome": "Videira",
	"uf": "SC"
}, {
	"Nome": "Vitor Meireles",
	"uf": "SC"
}, {
	"Nome": "Witmarsum",
	"uf": "SC"
}, {
	"Nome": "Xanxerê",
	"uf": "SC"
}, {
	"Nome": "Xavantina",
	"uf": "SC"
}, {
	"Nome": "Xaxim",
	"uf": "SC"
}, {
	"Nome": "Zortéa",
	"uf": "SC"
}, {
	"Nome": "Adamantina",
	"uf": "SP"
}, {
	"Nome": "Adolfo",
	"uf": "SP"
}, {
	"Nome": "Aguaí",
	"uf": "SP"
}, {
	"Nome": "Águas da Prata",
	"uf": "SP"
}, {
	"Nome": "Águas de Lindóia",
	"uf": "SP"
}, {
	"Nome": "Águas de Santa Bárbara",
	"uf": "SP"
}, {
	"Nome": "Águas de São Pedro",
	"uf": "SP"
}, {
	"Nome": "Agudos",
	"uf": "SP"
}, {
	"Nome": "Alambari",
	"uf": "SP"
}, {
	"Nome": "Alfredo Marcondes",
	"uf": "SP"
}, {
	"Nome": "Altair",
	"uf": "SP"
}, {
	"Nome": "Altinópolis",
	"uf": "SP"
}, {
	"Nome": "Alto Alegre",
	"uf": "SP"
}, {
	"Nome": "Alumínio",
	"uf": "SP"
}, {
	"Nome": "Álvares Florence",
	"uf": "SP"
}, {
	"Nome": "Álvares Machado",
	"uf": "SP"
}, {
	"Nome": "Álvaro de Carvalho",
	"uf": "SP"
}, {
	"Nome": "Alvinlândia",
	"uf": "SP"
}, {
	"Nome": "Americana",
	"uf": "SP"
}, {
	"Nome": "Américo Brasiliense",
	"uf": "SP"
}, {
	"Nome": "Américo de Campos",
	"uf": "SP"
}, {
	"Nome": "Amparo",
	"uf": "SP"
}, {
	"Nome": "Analândia",
	"uf": "SP"
}, {
	"Nome": "Andradina",
	"uf": "SP"
}, {
	"Nome": "Angatuba",
	"uf": "SP"
}, {
	"Nome": "Anhembi",
	"uf": "SP"
}, {
	"Nome": "Anhumas",
	"uf": "SP"
}, {
	"Nome": "Aparecida",
	"uf": "SP"
}, {
	"Nome": "Aparecida d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Apiaí",
	"uf": "SP"
}, {
	"Nome": "Araçariguama",
	"uf": "SP"
}, {
	"Nome": "Araçatuba",
	"uf": "SP"
}, {
	"Nome": "Araçoiaba da Serra",
	"uf": "SP"
}, {
	"Nome": "Aramina",
	"uf": "SP"
}, {
	"Nome": "Arandu",
	"uf": "SP"
}, {
	"Nome": "Arapeí",
	"uf": "SP"
}, {
	"Nome": "Araraquara",
	"uf": "SP"
}, {
	"Nome": "Araras",
	"uf": "SP"
}, {
	"Nome": "Arco-Íris",
	"uf": "SP"
}, {
	"Nome": "Arealva",
	"uf": "SP"
}, {
	"Nome": "Areias",
	"uf": "SP"
}, {
	"Nome": "Areiópolis",
	"uf": "SP"
}, {
	"Nome": "Ariranha",
	"uf": "SP"
}, {
	"Nome": "Artur Nogueira",
	"uf": "SP"
}, {
	"Nome": "Arujá",
	"uf": "SP"
}, {
	"Nome": "Aspásia",
	"uf": "SP"
}, {
	"Nome": "Assis",
	"uf": "SP"
}, {
	"Nome": "Atibaia",
	"uf": "SP"
}, {
	"Nome": "Auriflama",
	"uf": "SP"
}, {
	"Nome": "Avaí",
	"uf": "SP"
}, {
	"Nome": "Avanhandava",
	"uf": "SP"
}, {
	"Nome": "Avaré",
	"uf": "SP"
}, {
	"Nome": "Bady Bassitt",
	"uf": "SP"
}, {
	"Nome": "Balbinos",
	"uf": "SP"
}, {
	"Nome": "Bálsamo",
	"uf": "SP"
}, {
	"Nome": "Bananal",
	"uf": "SP"
}, {
	"Nome": "Barão de Antonina",
	"uf": "SP"
}, {
	"Nome": "Barbosa",
	"uf": "SP"
}, {
	"Nome": "Bariri",
	"uf": "SP"
}, {
	"Nome": "Barra Bonita",
	"uf": "SP"
}, {
	"Nome": "Barra do Chapéu",
	"uf": "SP"
}, {
	"Nome": "Barra do Turvo",
	"uf": "SP"
}, {
	"Nome": "Barretos",
	"uf": "SP"
}, {
	"Nome": "Barrinha",
	"uf": "SP"
}, {
	"Nome": "Barueri",
	"uf": "SP"
}, {
	"Nome": "Bastos",
	"uf": "SP"
}, {
	"Nome": "Batatais",
	"uf": "SP"
}, {
	"Nome": "Bauru",
	"uf": "SP"
}, {
	"Nome": "Bebedouro",
	"uf": "SP"
}, {
	"Nome": "Bento de Abreu",
	"uf": "SP"
}, {
	"Nome": "Bernardino de Campos",
	"uf": "SP"
}, {
	"Nome": "Bertioga",
	"uf": "SP"
}, {
	"Nome": "Bilac",
	"uf": "SP"
}, {
	"Nome": "Birigui",
	"uf": "SP"
}, {
	"Nome": "Biritiba-Mirim",
	"uf": "SP"
}, {
	"Nome": "Boa Esperança do Sul",
	"uf": "SP"
}, {
	"Nome": "Bocaina",
	"uf": "SP"
}, {
	"Nome": "Bofete",
	"uf": "SP"
}, {
	"Nome": "Boituva",
	"uf": "SP"
}, {
	"Nome": "Bom Jesus dos Perdões",
	"uf": "SP"
}, {
	"Nome": "Bom Sucesso de Itararé",
	"uf": "SP"
}, {
	"Nome": "Borá",
	"uf": "SP"
}, {
	"Nome": "Boracéia",
	"uf": "SP"
}, {
	"Nome": "Borborema",
	"uf": "SP"
}, {
	"Nome": "Borebi",
	"uf": "SP"
}, {
	"Nome": "Botucatu",
	"uf": "SP"
}, {
	"Nome": "Bragança Paulista",
	"uf": "SP"
}, {
	"Nome": "Braúna",
	"uf": "SP"
}, {
	"Nome": "Brejo Alegre",
	"uf": "SP"
}, {
	"Nome": "Brodowski",
	"uf": "SP"
}, {
	"Nome": "Brotas",
	"uf": "SP"
}, {
	"Nome": "Buri",
	"uf": "SP"
}, {
	"Nome": "Buritama",
	"uf": "SP"
}, {
	"Nome": "Buritizal",
	"uf": "SP"
}, {
	"Nome": "Cabrália Paulista",
	"uf": "SP"
}, {
	"Nome": "Cabreúva",
	"uf": "SP"
}, {
	"Nome": "Caçapava",
	"uf": "SP"
}, {
	"Nome": "Cachoeira Paulista",
	"uf": "SP"
}, {
	"Nome": "Caconde",
	"uf": "SP"
}, {
	"Nome": "Cafelândia",
	"uf": "SP"
}, {
	"Nome": "Caiabu",
	"uf": "SP"
}, {
	"Nome": "Caieiras",
	"uf": "SP"
}, {
	"Nome": "Caiuá",
	"uf": "SP"
}, {
	"Nome": "Cajamar",
	"uf": "SP"
}, {
	"Nome": "Cajati",
	"uf": "SP"
}, {
	"Nome": "Cajobi",
	"uf": "SP"
}, {
	"Nome": "Cajuru",
	"uf": "SP"
}, {
	"Nome": "Campina do Monte Alegre",
	"uf": "SP"
}, {
	"Nome": "Campinas",
	"uf": "SP"
}, {
	"Nome": "Campo Limpo Paulista",
	"uf": "SP"
}, {
	"Nome": "Campos do Jordão",
	"uf": "SP"
}, {
	"Nome": "Campos Novos Paulista",
	"uf": "SP"
}, {
	"Nome": "Cananéia",
	"uf": "SP"
}, {
	"Nome": "Canas",
	"uf": "SP"
}, {
	"Nome": "Cândido Mota",
	"uf": "SP"
}, {
	"Nome": "Cândido Rodrigues",
	"uf": "SP"
}, {
	"Nome": "Canitar",
	"uf": "SP"
}, {
	"Nome": "Capão Bonito",
	"uf": "SP"
}, {
	"Nome": "Capela do Alto",
	"uf": "SP"
}, {
	"Nome": "Capivari",
	"uf": "SP"
}, {
	"Nome": "Caraguatatuba",
	"uf": "SP"
}, {
	"Nome": "Carapicuíba",
	"uf": "SP"
}, {
	"Nome": "Cardoso",
	"uf": "SP"
}, {
	"Nome": "Casa Branca",
	"uf": "SP"
}, {
	"Nome": "Cássia dos Coqueiros",
	"uf": "SP"
}, {
	"Nome": "Castilho",
	"uf": "SP"
}, {
	"Nome": "Catanduva",
	"uf": "SP"
}, {
	"Nome": "Catiguá",
	"uf": "SP"
}, {
	"Nome": "Cedral",
	"uf": "SP"
}, {
	"Nome": "Cerqueira César",
	"uf": "SP"
}, {
	"Nome": "Cerquilho",
	"uf": "SP"
}, {
	"Nome": "Cesário Lange",
	"uf": "SP"
}, {
	"Nome": "Charqueada",
	"uf": "SP"
}, {
	"Nome": "Chavantes",
	"uf": "SP"
}, {
	"Nome": "Clementina",
	"uf": "SP"
}, {
	"Nome": "Colina",
	"uf": "SP"
}, {
	"Nome": "Colômbia",
	"uf": "SP"
}, {
	"Nome": "Conchal",
	"uf": "SP"
}, {
	"Nome": "Conchas",
	"uf": "SP"
}, {
	"Nome": "Cordeirópolis",
	"uf": "SP"
}, {
	"Nome": "Coroados",
	"uf": "SP"
}, {
	"Nome": "Coronel Macedo",
	"uf": "SP"
}, {
	"Nome": "Corumbataí",
	"uf": "SP"
}, {
	"Nome": "Cosmópolis",
	"uf": "SP"
}, {
	"Nome": "Cosmorama",
	"uf": "SP"
}, {
	"Nome": "Cotia",
	"uf": "SP"
}, {
	"Nome": "Cravinhos",
	"uf": "SP"
}, {
	"Nome": "Cristais Paulista",
	"uf": "SP"
}, {
	"Nome": "Cruzália",
	"uf": "SP"
}, {
	"Nome": "Cruzeiro",
	"uf": "SP"
}, {
	"Nome": "Cubatão",
	"uf": "SP"
}, {
	"Nome": "Cunha",
	"uf": "SP"
}, {
	"Nome": "Descalvado",
	"uf": "SP"
}, {
	"Nome": "Diadema",
	"uf": "SP"
}, {
	"Nome": "Dirce Reis",
	"uf": "SP"
}, {
	"Nome": "Divinolândia",
	"uf": "SP"
}, {
	"Nome": "Dobrada",
	"uf": "SP"
}, {
	"Nome": "Dois Córregos",
	"uf": "SP"
}, {
	"Nome": "Dolcinópolis",
	"uf": "SP"
}, {
	"Nome": "Dourado",
	"uf": "SP"
}, {
	"Nome": "Dracena",
	"uf": "SP"
}, {
	"Nome": "Duartina",
	"uf": "SP"
}, {
	"Nome": "Dumont",
	"uf": "SP"
}, {
	"Nome": "Echaporã",
	"uf": "SP"
}, {
	"Nome": "Eldorado",
	"uf": "SP"
}, {
	"Nome": "Elias Fausto",
	"uf": "SP"
}, {
	"Nome": "Elisiário",
	"uf": "SP"
}, {
	"Nome": "Embaúba",
	"uf": "SP"
}, {
	"Nome": "Embu",
	"uf": "SP"
}, {
	"Nome": "Embu-Guaçu",
	"uf": "SP"
}, {
	"Nome": "Emilianópolis",
	"uf": "SP"
}, {
	"Nome": "Engenheiro Coelho",
	"uf": "SP"
}, {
	"Nome": "Espírito Santo do Pinhal",
	"uf": "SP"
}, {
	"Nome": "Espírito Santo do Turvo",
	"uf": "SP"
}, {
	"Nome": "Estiva Gerbi",
	"uf": "SP"
}, {
	"Nome": "Estrela d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Estrela do Norte",
	"uf": "SP"
}, {
	"Nome": "Euclides da Cunha Paulista",
	"uf": "SP"
}, {
	"Nome": "Fartura",
	"uf": "SP"
}, {
	"Nome": "Fernando Prestes",
	"uf": "SP"
}, {
	"Nome": "Fernandópolis",
	"uf": "SP"
}, {
	"Nome": "Fernão",
	"uf": "SP"
}, {
	"Nome": "Ferraz de Vasconcelos",
	"uf": "SP"
}, {
	"Nome": "Flora Rica",
	"uf": "SP"
}, {
	"Nome": "Floreal",
	"uf": "SP"
}, {
	"Nome": "Flórida Paulista",
	"uf": "SP"
}, {
	"Nome": "Florínia",
	"uf": "SP"
}, {
	"Nome": "Franca",
	"uf": "SP"
}, {
	"Nome": "Francisco Morato",
	"uf": "SP"
}, {
	"Nome": "Franco da Rocha",
	"uf": "SP"
}, {
	"Nome": "Gabriel Monteiro",
	"uf": "SP"
}, {
	"Nome": "Gália",
	"uf": "SP"
}, {
	"Nome": "Garça",
	"uf": "SP"
}, {
	"Nome": "Gastão Vidigal",
	"uf": "SP"
}, {
	"Nome": "Gavião Peixoto",
	"uf": "SP"
}, {
	"Nome": "General Salgado",
	"uf": "SP"
}, {
	"Nome": "Getulina",
	"uf": "SP"
}, {
	"Nome": "Glicério",
	"uf": "SP"
}, {
	"Nome": "Guaiçara",
	"uf": "SP"
}, {
	"Nome": "Guaimbê",
	"uf": "SP"
}, {
	"Nome": "Guaíra",
	"uf": "SP"
}, {
	"Nome": "Guapiaçu",
	"uf": "SP"
}, {
	"Nome": "Guapiara",
	"uf": "SP"
}, {
	"Nome": "Guará",
	"uf": "SP"
}, {
	"Nome": "Guaraçaí",
	"uf": "SP"
}, {
	"Nome": "Guaraci",
	"uf": "SP"
}, {
	"Nome": "Guarani d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Guarantã",
	"uf": "SP"
}, {
	"Nome": "Guararapes",
	"uf": "SP"
}, {
	"Nome": "Guararema",
	"uf": "SP"
}, {
	"Nome": "Guaratinguetá",
	"uf": "SP"
}, {
	"Nome": "Guareí",
	"uf": "SP"
}, {
	"Nome": "Guariba",
	"uf": "SP"
}, {
	"Nome": "Guarujá",
	"uf": "SP"
}, {
	"Nome": "Guarulhos",
	"uf": "SP"
}, {
	"Nome": "Guatapará",
	"uf": "SP"
}, {
	"Nome": "Guzolândia",
	"uf": "SP"
}, {
	"Nome": "Herculândia",
	"uf": "SP"
}, {
	"Nome": "Holambra",
	"uf": "SP"
}, {
	"Nome": "Hortolândia",
	"uf": "SP"
}, {
	"Nome": "Iacanga",
	"uf": "SP"
}, {
	"Nome": "Iacri",
	"uf": "SP"
}, {
	"Nome": "Iaras",
	"uf": "SP"
}, {
	"Nome": "Ibaté",
	"uf": "SP"
}, {
	"Nome": "Ibirá",
	"uf": "SP"
}, {
	"Nome": "Ibirarema",
	"uf": "SP"
}, {
	"Nome": "Ibitinga",
	"uf": "SP"
}, {
	"Nome": "Ibiúna",
	"uf": "SP"
}, {
	"Nome": "Icém",
	"uf": "SP"
}, {
	"Nome": "Iepê",
	"uf": "SP"
}, {
	"Nome": "Igaraçu do Tietê",
	"uf": "SP"
}, {
	"Nome": "Igarapava",
	"uf": "SP"
}, {
	"Nome": "Igaratá",
	"uf": "SP"
}, {
	"Nome": "Iguape",
	"uf": "SP"
}, {
	"Nome": "Ilha Comprida",
	"uf": "SP"
}, {
	"Nome": "Ilha Solteira",
	"uf": "SP"
}, {
	"Nome": "Ilhabela",
	"uf": "SP"
}, {
	"Nome": "Indaiatuba",
	"uf": "SP"
}, {
	"Nome": "Indiana",
	"uf": "SP"
}, {
	"Nome": "Indiaporã",
	"uf": "SP"
}, {
	"Nome": "Inúbia Paulista",
	"uf": "SP"
}, {
	"Nome": "Ipaussu",
	"uf": "SP"
}, {
	"Nome": "Iperó",
	"uf": "SP"
}, {
	"Nome": "Ipeúna",
	"uf": "SP"
}, {
	"Nome": "Ipiguá",
	"uf": "SP"
}, {
	"Nome": "Iporanga",
	"uf": "SP"
}, {
	"Nome": "Ipuã",
	"uf": "SP"
}, {
	"Nome": "Iracemápolis",
	"uf": "SP"
}, {
	"Nome": "Irapuã",
	"uf": "SP"
}, {
	"Nome": "Irapuru",
	"uf": "SP"
}, {
	"Nome": "Itaberá",
	"uf": "SP"
}, {
	"Nome": "Itaí",
	"uf": "SP"
}, {
	"Nome": "Itajobi",
	"uf": "SP"
}, {
	"Nome": "Itaju",
	"uf": "SP"
}, {
	"Nome": "Itanhaém",
	"uf": "SP"
}, {
	"Nome": "Itaóca",
	"uf": "SP"
}, {
	"Nome": "Itapecerica da Serra",
	"uf": "SP"
}, {
	"Nome": "Itapetininga",
	"uf": "SP"
}, {
	"Nome": "Itapeva",
	"uf": "SP"
}, {
	"Nome": "Itapevi",
	"uf": "SP"
}, {
	"Nome": "Itapira",
	"uf": "SP"
}, {
	"Nome": "Itapirapuã Paulista",
	"uf": "SP"
}, {
	"Nome": "Itápolis",
	"uf": "SP"
}, {
	"Nome": "Itaporanga",
	"uf": "SP"
}, {
	"Nome": "Itapuí",
	"uf": "SP"
}, {
	"Nome": "Itapura",
	"uf": "SP"
}, {
	"Nome": "Itaquaquecetuba",
	"uf": "SP"
}, {
	"Nome": "Itararé",
	"uf": "SP"
}, {
	"Nome": "Itariri",
	"uf": "SP"
}, {
	"Nome": "Itatiba",
	"uf": "SP"
}, {
	"Nome": "Itatinga",
	"uf": "SP"
}, {
	"Nome": "Itirapina",
	"uf": "SP"
}, {
	"Nome": "Itirapuã",
	"uf": "SP"
}, {
	"Nome": "Itobi",
	"uf": "SP"
}, {
	"Nome": "Itu",
	"uf": "SP"
}, {
	"Nome": "Itupeva",
	"uf": "SP"
}, {
	"Nome": "Ituverava",
	"uf": "SP"
}, {
	"Nome": "Jaborandi",
	"uf": "SP"
}, {
	"Nome": "Jaboticabal",
	"uf": "SP"
}, {
	"Nome": "Jacareí",
	"uf": "SP"
}, {
	"Nome": "Jaci",
	"uf": "SP"
}, {
	"Nome": "Jacupiranga",
	"uf": "SP"
}, {
	"Nome": "Jaguariúna",
	"uf": "SP"
}, {
	"Nome": "Jales",
	"uf": "SP"
}, {
	"Nome": "Jambeiro",
	"uf": "SP"
}, {
	"Nome": "Jandira",
	"uf": "SP"
}, {
	"Nome": "Jardinópolis",
	"uf": "SP"
}, {
	"Nome": "Jarinu",
	"uf": "SP"
}, {
	"Nome": "Jaú",
	"uf": "SP"
}, {
	"Nome": "Jeriquara",
	"uf": "SP"
}, {
	"Nome": "Joanópolis",
	"uf": "SP"
}, {
	"Nome": "João Ramalho",
	"uf": "SP"
}, {
	"Nome": "José Bonifácio",
	"uf": "SP"
}, {
	"Nome": "Júlio Mesquita",
	"uf": "SP"
}, {
	"Nome": "Jumirim",
	"uf": "SP"
}, {
	"Nome": "Jundiaí",
	"uf": "SP"
}, {
	"Nome": "Junqueirópolis",
	"uf": "SP"
}, {
	"Nome": "Juquiá",
	"uf": "SP"
}, {
	"Nome": "Juquitiba",
	"uf": "SP"
}, {
	"Nome": "Lagoinha",
	"uf": "SP"
}, {
	"Nome": "Laranjal Paulista",
	"uf": "SP"
}, {
	"Nome": "Lavínia",
	"uf": "SP"
}, {
	"Nome": "Lavrinhas",
	"uf": "SP"
}, {
	"Nome": "Leme",
	"uf": "SP"
}, {
	"Nome": "Lençóis Paulista",
	"uf": "SP"
}, {
	"Nome": "Limeira",
	"uf": "SP"
}, {
	"Nome": "Lindóia",
	"uf": "SP"
}, {
	"Nome": "Lins",
	"uf": "SP"
}, {
	"Nome": "Lorena",
	"uf": "SP"
}, {
	"Nome": "Lourdes",
	"uf": "SP"
}, {
	"Nome": "Louveira",
	"uf": "SP"
}, {
	"Nome": "Lucélia",
	"uf": "SP"
}, {
	"Nome": "Lucianópolis",
	"uf": "SP"
}, {
	"Nome": "Luís Antônio",
	"uf": "SP"
}, {
	"Nome": "Luiziânia",
	"uf": "SP"
}, {
	"Nome": "Lupércio",
	"uf": "SP"
}, {
	"Nome": "Lutécia",
	"uf": "SP"
}, {
	"Nome": "Macatuba",
	"uf": "SP"
}, {
	"Nome": "Macaubal",
	"uf": "SP"
}, {
	"Nome": "Macedônia",
	"uf": "SP"
}, {
	"Nome": "Magda",
	"uf": "SP"
}, {
	"Nome": "Mairinque",
	"uf": "SP"
}, {
	"Nome": "Mairiporã",
	"uf": "SP"
}, {
	"Nome": "Manduri",
	"uf": "SP"
}, {
	"Nome": "Marabá Paulista",
	"uf": "SP"
}, {
	"Nome": "Maracaí",
	"uf": "SP"
}, {
	"Nome": "Marapoama",
	"uf": "SP"
}, {
	"Nome": "Mariápolis",
	"uf": "SP"
}, {
	"Nome": "Marília",
	"uf": "SP"
}, {
	"Nome": "Marinópolis",
	"uf": "SP"
}, {
	"Nome": "Martinópolis",
	"uf": "SP"
}, {
	"Nome": "Matão",
	"uf": "SP"
}, {
	"Nome": "Mauá",
	"uf": "SP"
}, {
	"Nome": "Mendonça",
	"uf": "SP"
}, {
	"Nome": "Meridiano",
	"uf": "SP"
}, {
	"Nome": "Mesópolis",
	"uf": "SP"
}, {
	"Nome": "Miguelópolis",
	"uf": "SP"
}, {
	"Nome": "Mineiros do Tietê",
	"uf": "SP"
}, {
	"Nome": "Mira Estrela",
	"uf": "SP"
}, {
	"Nome": "Miracatu",
	"uf": "SP"
}, {
	"Nome": "Mirandópolis",
	"uf": "SP"
}, {
	"Nome": "Mirante do Paranapanema",
	"uf": "SP"
}, {
	"Nome": "Mirassol",
	"uf": "SP"
}, {
	"Nome": "Mirassolândia",
	"uf": "SP"
}, {
	"Nome": "Mococa",
	"uf": "SP"
}, {
	"Nome": "Mogi das Cruzes",
	"uf": "SP"
}, {
	"Nome": "Mogi Guaçu",
	"uf": "SP"
}, {
	"Nome": "Moji Mirim",
	"uf": "SP"
}, {
	"Nome": "Mombuca",
	"uf": "SP"
}, {
	"Nome": "Monções",
	"uf": "SP"
}, {
	"Nome": "Mongaguá",
	"uf": "SP"
}, {
	"Nome": "Monte Alegre do Sul",
	"uf": "SP"
}, {
	"Nome": "Monte Alto",
	"uf": "SP"
}, {
	"Nome": "Monte Aprazível",
	"uf": "SP"
}, {
	"Nome": "Monte Azul Paulista",
	"uf": "SP"
}, {
	"Nome": "Monte Castelo",
	"uf": "SP"
}, {
	"Nome": "Monte Mor",
	"uf": "SP"
}, {
	"Nome": "Monteiro Lobato",
	"uf": "SP"
}, {
	"Nome": "Morro Agudo",
	"uf": "SP"
}, {
	"Nome": "Morungaba",
	"uf": "SP"
}, {
	"Nome": "Motuca",
	"uf": "SP"
}, {
	"Nome": "Murutinga do Sul",
	"uf": "SP"
}, {
	"Nome": "Nantes",
	"uf": "SP"
}, {
	"Nome": "Narandiba",
	"uf": "SP"
}, {
	"Nome": "Natividade da Serra",
	"uf": "SP"
}, {
	"Nome": "Nazaré Paulista",
	"uf": "SP"
}, {
	"Nome": "Neves Paulista",
	"uf": "SP"
}, {
	"Nome": "Nhandeara",
	"uf": "SP"
}, {
	"Nome": "Nipoã",
	"uf": "SP"
}, {
	"Nome": "Nova Aliança",
	"uf": "SP"
}, {
	"Nome": "Nova Campina",
	"uf": "SP"
}, {
	"Nome": "Nova Canaã Paulista",
	"uf": "SP"
}, {
	"Nome": "Nova Castilho",
	"uf": "SP"
}, {
	"Nome": "Nova Europa",
	"uf": "SP"
}, {
	"Nome": "Nova Granada",
	"uf": "SP"
}, {
	"Nome": "Nova Guataporanga",
	"uf": "SP"
}, {
	"Nome": "Nova Independência",
	"uf": "SP"
}, {
	"Nome": "Nova Luzitânia",
	"uf": "SP"
}, {
	"Nome": "Nova Odessa",
	"uf": "SP"
}, {
	"Nome": "Novais",
	"uf": "SP"
}, {
	"Nome": "Novo Horizonte",
	"uf": "SP"
}, {
	"Nome": "Nuporanga",
	"uf": "SP"
}, {
	"Nome": "Ocauçu",
	"uf": "SP"
}, {
	"Nome": "Óleo",
	"uf": "SP"
}, {
	"Nome": "Olímpia",
	"uf": "SP"
}, {
	"Nome": "Onda Verde",
	"uf": "SP"
}, {
	"Nome": "Oriente",
	"uf": "SP"
}, {
	"Nome": "Orindiúva",
	"uf": "SP"
}, {
	"Nome": "Orlândia",
	"uf": "SP"
}, {
	"Nome": "Osasco",
	"uf": "SP"
}, {
	"Nome": "Oscar Bressane",
	"uf": "SP"
}, {
	"Nome": "Osvaldo Cruz",
	"uf": "SP"
}, {
	"Nome": "Ourinhos",
	"uf": "SP"
}, {
	"Nome": "Ouro Verde",
	"uf": "SP"
}, {
	"Nome": "Ouroeste",
	"uf": "SP"
}, {
	"Nome": "Pacaembu",
	"uf": "SP"
}, {
	"Nome": "Palestina",
	"uf": "SP"
}, {
	"Nome": "Palmares Paulista",
	"uf": "SP"
}, {
	"Nome": "Palmeira d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Palmital",
	"uf": "SP"
}, {
	"Nome": "Panorama",
	"uf": "SP"
}, {
	"Nome": "Paraguaçu Paulista",
	"uf": "SP"
}, {
	"Nome": "Paraibuna",
	"uf": "SP"
}, {
	"Nome": "Paraíso",
	"uf": "SP"
}, {
	"Nome": "Paranapanema",
	"uf": "SP"
}, {
	"Nome": "Paranapuã",
	"uf": "SP"
}, {
	"Nome": "Parapuã",
	"uf": "SP"
}, {
	"Nome": "Pardinho",
	"uf": "SP"
}, {
	"Nome": "Pariquera-Açu",
	"uf": "SP"
}, {
	"Nome": "Parisi",
	"uf": "SP"
}, {
	"Nome": "Patrocínio Paulista",
	"uf": "SP"
}, {
	"Nome": "Paulicéia",
	"uf": "SP"
}, {
	"Nome": "Paulínia",
	"uf": "SP"
}, {
	"Nome": "Paulistânia",
	"uf": "SP"
}, {
	"Nome": "Paulo de Faria",
	"uf": "SP"
}, {
	"Nome": "Pederneiras",
	"uf": "SP"
}, {
	"Nome": "Pedra Bela",
	"uf": "SP"
}, {
	"Nome": "Pedranópolis",
	"uf": "SP"
}, {
	"Nome": "Pedregulho",
	"uf": "SP"
}, {
	"Nome": "Pedreira",
	"uf": "SP"
}, {
	"Nome": "Pedrinhas Paulista",
	"uf": "SP"
}, {
	"Nome": "Pedro de Toledo",
	"uf": "SP"
}, {
	"Nome": "Penápolis",
	"uf": "SP"
}, {
	"Nome": "Pereira Barreto",
	"uf": "SP"
}, {
	"Nome": "Pereiras",
	"uf": "SP"
}, {
	"Nome": "Peruíbe",
	"uf": "SP"
}, {
	"Nome": "Piacatu",
	"uf": "SP"
}, {
	"Nome": "Piedade",
	"uf": "SP"
}, {
	"Nome": "Pilar do Sul",
	"uf": "SP"
}, {
	"Nome": "Pindamonhangaba",
	"uf": "SP"
}, {
	"Nome": "Pindorama",
	"uf": "SP"
}, {
	"Nome": "Pinhalzinho",
	"uf": "SP"
}, {
	"Nome": "Piquerobi",
	"uf": "SP"
}, {
	"Nome": "Piquete",
	"uf": "SP"
}, {
	"Nome": "Piracaia",
	"uf": "SP"
}, {
	"Nome": "Piracicaba",
	"uf": "SP"
}, {
	"Nome": "Piraju",
	"uf": "SP"
}, {
	"Nome": "Pirajuí",
	"uf": "SP"
}, {
	"Nome": "Pirangi",
	"uf": "SP"
}, {
	"Nome": "Pirapora do Bom Jesus",
	"uf": "SP"
}, {
	"Nome": "Pirapozinho",
	"uf": "SP"
}, {
	"Nome": "Pirassununga",
	"uf": "SP"
}, {
	"Nome": "Piratininga",
	"uf": "SP"
}, {
	"Nome": "Pitangueiras",
	"uf": "SP"
}, {
	"Nome": "Planalto",
	"uf": "SP"
}, {
	"Nome": "Platina",
	"uf": "SP"
}, {
	"Nome": "Poá",
	"uf": "SP"
}, {
	"Nome": "Poloni",
	"uf": "SP"
}, {
	"Nome": "Pompéia",
	"uf": "SP"
}, {
	"Nome": "Pongaí",
	"uf": "SP"
}, {
	"Nome": "Pontal",
	"uf": "SP"
}, {
	"Nome": "Pontalinda",
	"uf": "SP"
}, {
	"Nome": "Pontes Gestal",
	"uf": "SP"
}, {
	"Nome": "Populina",
	"uf": "SP"
}, {
	"Nome": "Porangaba",
	"uf": "SP"
}, {
	"Nome": "Porto Feliz",
	"uf": "SP"
}, {
	"Nome": "Porto Ferreira",
	"uf": "SP"
}, {
	"Nome": "Potim",
	"uf": "SP"
}, {
	"Nome": "Potirendaba",
	"uf": "SP"
}, {
	"Nome": "Pracinha",
	"uf": "SP"
}, {
	"Nome": "Pradópolis",
	"uf": "SP"
}, {
	"Nome": "Praia Grande",
	"uf": "SP"
}, {
	"Nome": "Pratânia",
	"uf": "SP"
}, {
	"Nome": "Presidente Alves",
	"uf": "SP"
}, {
	"Nome": "Presidente Bernardes",
	"uf": "SP"
}, {
	"Nome": "Presidente Epitácio",
	"uf": "SP"
}, {
	"Nome": "Presidente Prudente",
	"uf": "SP"
}, {
	"Nome": "Presidente Venceslau",
	"uf": "SP"
}, {
	"Nome": "Promissão",
	"uf": "SP"
}, {
	"Nome": "Quadra",
	"uf": "SP"
}, {
	"Nome": "Quatá",
	"uf": "SP"
}, {
	"Nome": "Queiroz",
	"uf": "SP"
}, {
	"Nome": "Queluz",
	"uf": "SP"
}, {
	"Nome": "Quintana",
	"uf": "SP"
}, {
	"Nome": "Rafard",
	"uf": "SP"
}, {
	"Nome": "Rancharia",
	"uf": "SP"
}, {
	"Nome": "Redenção da Serra",
	"uf": "SP"
}, {
	"Nome": "Regente Feijó",
	"uf": "SP"
}, {
	"Nome": "Reginópolis",
	"uf": "SP"
}, {
	"Nome": "Registro",
	"uf": "SP"
}, {
	"Nome": "Restinga",
	"uf": "SP"
}, {
	"Nome": "Ribeira",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Bonito",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Branco",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Corrente",
	"uf": "SP"
}, {
	"Nome": "Ribeirão do Sul",
	"uf": "SP"
}, {
	"Nome": "Ribeirão dos Índios",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Grande",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Pires",
	"uf": "SP"
}, {
	"Nome": "Ribeirão Preto",
	"uf": "SP"
}, {
	"Nome": "Rifaina",
	"uf": "SP"
}, {
	"Nome": "Rincão",
	"uf": "SP"
}, {
	"Nome": "Rinópolis",
	"uf": "SP"
}, {
	"Nome": "Rio Claro",
	"uf": "SP"
}, {
	"Nome": "Rio das Pedras",
	"uf": "SP"
}, {
	"Nome": "Rio Grande da Serra",
	"uf": "SP"
}, {
	"Nome": "Riolândia",
	"uf": "SP"
}, {
	"Nome": "Riversul",
	"uf": "SP"
}, {
	"Nome": "Rosana",
	"uf": "SP"
}, {
	"Nome": "Roseira",
	"uf": "SP"
}, {
	"Nome": "Rubiácea",
	"uf": "SP"
}, {
	"Nome": "Rubinéia",
	"uf": "SP"
}, {
	"Nome": "Sabino",
	"uf": "SP"
}, {
	"Nome": "Sagres",
	"uf": "SP"
}, {
	"Nome": "Sales",
	"uf": "SP"
}, {
	"Nome": "Sales Oliveira",
	"uf": "SP"
}, {
	"Nome": "Salesópolis",
	"uf": "SP"
}, {
	"Nome": "Salmourão",
	"uf": "SP"
}, {
	"Nome": "Saltinho",
	"uf": "SP"
}, {
	"Nome": "Salto",
	"uf": "SP"
}, {
	"Nome": "Salto de Pirapora",
	"uf": "SP"
}, {
	"Nome": "Salto Grande",
	"uf": "SP"
}, {
	"Nome": "Sandovalina",
	"uf": "SP"
}, {
	"Nome": "Santa Adélia",
	"uf": "SP"
}, {
	"Nome": "Santa Albertina",
	"uf": "SP"
}, {
	"Nome": "Santa Bárbara d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Santa Branca",
	"uf": "SP"
}, {
	"Nome": "Santa Clara d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Santa Cruz da Conceição",
	"uf": "SP"
}, {
	"Nome": "Santa Cruz da Esperança",
	"uf": "SP"
}, {
	"Nome": "Santa Cruz das Palmeiras",
	"uf": "SP"
}, {
	"Nome": "Santa Cruz do Rio Pardo",
	"uf": "SP"
}, {
	"Nome": "Santa Ernestina",
	"uf": "SP"
}, {
	"Nome": "Santa Fé do Sul",
	"uf": "SP"
}, {
	"Nome": "Santa Gertrudes",
	"uf": "SP"
}, {
	"Nome": "Santa Isabel",
	"uf": "SP"
}, {
	"Nome": "Santa Lúcia",
	"uf": "SP"
}, {
	"Nome": "Santa Maria da Serra",
	"uf": "SP"
}, {
	"Nome": "Santa Mercedes",
	"uf": "SP"
}, {
	"Nome": "Santa Rita d`Oeste",
	"uf": "SP"
}, {
	"Nome": "Santa Rita do Passa Quatro",
	"uf": "SP"
}, {
	"Nome": "Santa Rosa de Viterbo",
	"uf": "SP"
}, {
	"Nome": "Santa Salete",
	"uf": "SP"
}, {
	"Nome": "Santana da Ponte Pensa",
	"uf": "SP"
}, {
	"Nome": "Santana de Parnaíba",
	"uf": "SP"
}, {
	"Nome": "Santo Anastácio",
	"uf": "SP"
}, {
	"Nome": "Santo André",
	"uf": "SP"
}, {
	"Nome": "Santo Antônio da Alegria",
	"uf": "SP"
}, {
	"Nome": "Santo Antônio de Posse",
	"uf": "SP"
}, {
	"Nome": "Santo Antônio do Aracanguá",
	"uf": "SP"
}, {
	"Nome": "Santo Antônio do Jardim",
	"uf": "SP"
}, {
	"Nome": "Santo Antônio do Pinhal",
	"uf": "SP"
}, {
	"Nome": "Santo Expedito",
	"uf": "SP"
}, {
	"Nome": "Santópolis do Aguapeí",
	"uf": "SP"
}, {
	"Nome": "Santos",
	"uf": "SP"
}, {
	"Nome": "São Bento do Sapucaí",
	"uf": "SP"
}, {
	"Nome": "São Bernardo do Campo",
	"uf": "SP"
}, {
	"Nome": "São Caetano do Sul",
	"uf": "SP"
}, {
	"Nome": "São Carlos",
	"uf": "SP"
}, {
	"Nome": "São Francisco",
	"uf": "SP"
}, {
	"Nome": "São João da Boa Vista",
	"uf": "SP"
}, {
	"Nome": "São João das Duas Pontes",
	"uf": "SP"
}, {
	"Nome": "São João de Iracema",
	"uf": "SP"
}, {
	"Nome": "São João do Pau d`Alho",
	"uf": "SP"
}, {
	"Nome": "São Joaquim da Barra",
	"uf": "SP"
}, {
	"Nome": "São José da Bela Vista",
	"uf": "SP"
}, {
	"Nome": "São José do Barreiro",
	"uf": "SP"
}, {
	"Nome": "São José do Rio Pardo",
	"uf": "SP"
}, {
	"Nome": "São José do Rio Preto",
	"uf": "SP"
}, {
	"Nome": "São José dos Campos",
	"uf": "SP"
}, {
	"Nome": "São Lourenço da Serra",
	"uf": "SP"
}, {
	"Nome": "São Luís do Paraitinga",
	"uf": "SP"
}, {
	"Nome": "São Manuel",
	"uf": "SP"
}, {
	"Nome": "São Miguel Arcanjo",
	"uf": "SP"
}, {
	"Nome": "São Paulo",
	"uf": "SP"
}, {
	"Nome": "São Pedro",
	"uf": "SP"
}, {
	"Nome": "São Pedro do Turvo",
	"uf": "SP"
}, {
	"Nome": "São Roque",
	"uf": "SP"
}, {
	"Nome": "São Sebastião",
	"uf": "SP"
}, {
	"Nome": "São Sebastião da Grama",
	"uf": "SP"
}, {
	"Nome": "São Simão",
	"uf": "SP"
}, {
	"Nome": "São Vicente",
	"uf": "SP"
}, {
	"Nome": "Sarapuí",
	"uf": "SP"
}, {
	"Nome": "Sarutaiá",
	"uf": "SP"
}, {
	"Nome": "Sebastianópolis do Sul",
	"uf": "SP"
}, {
	"Nome": "Serra Azul",
	"uf": "SP"
}, {
	"Nome": "Serra Negra",
	"uf": "SP"
}, {
	"Nome": "Serrana",
	"uf": "SP"
}, {
	"Nome": "Sertãozinho",
	"uf": "SP"
}, {
	"Nome": "Sete Barras",
	"uf": "SP"
}, {
	"Nome": "Severínia",
	"uf": "SP"
}, {
	"Nome": "Silveiras",
	"uf": "SP"
}, {
	"Nome": "Socorro",
	"uf": "SP"
}, {
	"Nome": "Sorocaba",
	"uf": "SP"
}, {
	"Nome": "Sud Mennucci",
	"uf": "SP"
}, {
	"Nome": "Sumaré",
	"uf": "SP"
}, {
	"Nome": "Suzanápolis",
	"uf": "SP"
}, {
	"Nome": "Suzano",
	"uf": "SP"
}, {
	"Nome": "Tabapuã",
	"uf": "SP"
}, {
	"Nome": "Tabatinga",
	"uf": "SP"
}, {
	"Nome": "Taboão da Serra",
	"uf": "SP"
}, {
	"Nome": "Taciba",
	"uf": "SP"
}, {
	"Nome": "Taguaí",
	"uf": "SP"
}, {
	"Nome": "Taiaçu",
	"uf": "SP"
}, {
	"Nome": "Taiúva",
	"uf": "SP"
}, {
	"Nome": "Tambaú",
	"uf": "SP"
}, {
	"Nome": "Tanabi",
	"uf": "SP"
}, {
	"Nome": "Tapiraí",
	"uf": "SP"
}, {
	"Nome": "Tapiratiba",
	"uf": "SP"
}, {
	"Nome": "Taquaral",
	"uf": "SP"
}, {
	"Nome": "Taquaritinga",
	"uf": "SP"
}, {
	"Nome": "Taquarituba",
	"uf": "SP"
}, {
	"Nome": "Taquarivaí",
	"uf": "SP"
}, {
	"Nome": "Tarabai",
	"uf": "SP"
}, {
	"Nome": "Tarumã",
	"uf": "SP"
}, {
	"Nome": "Tatuí",
	"uf": "SP"
}, {
	"Nome": "Taubaté",
	"uf": "SP"
}, {
	"Nome": "Tejupá",
	"uf": "SP"
}, {
	"Nome": "Teodoro Sampaio",
	"uf": "SP"
}, {
	"Nome": "Terra Roxa",
	"uf": "SP"
}, {
	"Nome": "Tietê",
	"uf": "SP"
}, {
	"Nome": "Timburi",
	"uf": "SP"
}, {
	"Nome": "Torre de Pedra",
	"uf": "SP"
}, {
	"Nome": "Torrinha",
	"uf": "SP"
}, {
	"Nome": "Trabiju",
	"uf": "SP"
}, {
	"Nome": "Tremembé",
	"uf": "SP"
}, {
	"Nome": "Três Fronteiras",
	"uf": "SP"
}, {
	"Nome": "Tuiuti",
	"uf": "SP"
}, {
	"Nome": "Tupã",
	"uf": "SP"
}, {
	"Nome": "Tupi Paulista",
	"uf": "SP"
}, {
	"Nome": "Turiúba",
	"uf": "SP"
}, {
	"Nome": "Turmalina",
	"uf": "SP"
}, {
	"Nome": "Ubarana",
	"uf": "SP"
}, {
	"Nome": "Ubatuba",
	"uf": "SP"
}, {
	"Nome": "Ubirajara",
	"uf": "SP"
}, {
	"Nome": "Uchoa",
	"uf": "SP"
}, {
	"Nome": "União Paulista",
	"uf": "SP"
}, {
	"Nome": "Urânia",
	"uf": "SP"
}, {
	"Nome": "Uru",
	"uf": "SP"
}, {
	"Nome": "Urupês",
	"uf": "SP"
}, {
	"Nome": "Valentim Gentil",
	"uf": "SP"
}, {
	"Nome": "Valinhos",
	"uf": "SP"
}, {
	"Nome": "Valparaíso",
	"uf": "SP"
}, {
	"Nome": "Vargem",
	"uf": "SP"
}, {
	"Nome": "Vargem Grande do Sul",
	"uf": "SP"
}, {
	"Nome": "Vargem Grande Paulista",
	"uf": "SP"
}, {
	"Nome": "Várzea Paulista",
	"uf": "SP"
}, {
	"Nome": "Vera Cruz",
	"uf": "SP"
}, {
	"Nome": "Vinhedo",
	"uf": "SP"
}, {
	"Nome": "Viradouro",
	"uf": "SP"
}, {
	"Nome": "Vista Alegre do Alto",
	"uf": "SP"
}, {
	"Nome": "Vitória Brasil",
	"uf": "SP"
}, {
	"Nome": "Votorantim",
	"uf": "SP"
}, {
	"Nome": "Votuporanga",
	"uf": "SP"
}, {
	"Nome": "Zacarias",
	"uf": "SP"
}, {
	"Nome": "Amparo de São Francisco",
	"uf": "SE"
}, {
	"Nome": "Aquidabã",
	"uf": "SE"
}, {
	"Nome": "Aracaju",
	"uf": "SE"
}, {
	"Nome": "Arauá",
	"uf": "SE"
}, {
	"Nome": "Areia Branca",
	"uf": "SE"
}, {
	"Nome": "Barra dos Coqueiros",
	"uf": "SE"
}, {
	"Nome": "Boquim",
	"uf": "SE"
}, {
	"Nome": "Brejo Grande",
	"uf": "SE"
}, {
	"Nome": "Campo do Brito",
	"uf": "SE"
}, {
	"Nome": "Canhoba",
	"uf": "SE"
}, {
	"Nome": "Canindé de São Francisco",
	"uf": "SE"
}, {
	"Nome": "Capela",
	"uf": "SE"
}, {
	"Nome": "Carira",
	"uf": "SE"
}, {
	"Nome": "Carmópolis",
	"uf": "SE"
}, {
	"Nome": "Cedro de São João",
	"uf": "SE"
}, {
	"Nome": "Cristinápolis",
	"uf": "SE"
}, {
	"Nome": "Cumbe",
	"uf": "SE"
}, {
	"Nome": "Divina Pastora",
	"uf": "SE"
}, {
	"Nome": "Estância",
	"uf": "SE"
}, {
	"Nome": "Feira Nova",
	"uf": "SE"
}, {
	"Nome": "Frei Paulo",
	"uf": "SE"
}, {
	"Nome": "Gararu",
	"uf": "SE"
}, {
	"Nome": "General Maynard",
	"uf": "SE"
}, {
	"Nome": "Gracho Cardoso",
	"uf": "SE"
}, {
	"Nome": "Ilha das Flores",
	"uf": "SE"
}, {
	"Nome": "Indiaroba",
	"uf": "SE"
}, {
	"Nome": "Itabaiana",
	"uf": "SE"
}, {
	"Nome": "Itabaianinha",
	"uf": "SE"
}, {
	"Nome": "Itabi",
	"uf": "SE"
}, {
	"Nome": "Itaporanga d`Ajuda",
	"uf": "SE"
}, {
	"Nome": "Japaratuba",
	"uf": "SE"
}, {
	"Nome": "Japoatã",
	"uf": "SE"
}, {
	"Nome": "Lagarto",
	"uf": "SE"
}, {
	"Nome": "Laranjeiras",
	"uf": "SE"
}, {
	"Nome": "Macambira",
	"uf": "SE"
}, {
	"Nome": "Malhada dos Bois",
	"uf": "SE"
}, {
	"Nome": "Malhador",
	"uf": "SE"
}, {
	"Nome": "Maruim",
	"uf": "SE"
}, {
	"Nome": "Moita Bonita",
	"uf": "SE"
}, {
	"Nome": "Monte Alegre de Sergipe",
	"uf": "SE"
}, {
	"Nome": "Muribeca",
	"uf": "SE"
}, {
	"Nome": "Neópolis",
	"uf": "SE"
}, {
	"Nome": "Nossa Senhora Aparecida",
	"uf": "SE"
}, {
	"Nome": "Nossa Senhora da Glória",
	"uf": "SE"
}, {
	"Nome": "Nossa Senhora das Dores",
	"uf": "SE"
}, {
	"Nome": "Nossa Senhora de Lourdes",
	"uf": "SE"
}, {
	"Nome": "Nossa Senhora do Socorro",
	"uf": "SE"
}, {
	"Nome": "Pacatuba",
	"uf": "SE"
}, {
	"Nome": "Pedra Mole",
	"uf": "SE"
}, {
	"Nome": "Pedrinhas",
	"uf": "SE"
}, {
	"Nome": "Pinhão",
	"uf": "SE"
}, {
	"Nome": "Pirambu",
	"uf": "SE"
}, {
	"Nome": "Poço Redondo",
	"uf": "SE"
}, {
	"Nome": "Poço Verde",
	"uf": "SE"
}, {
	"Nome": "Porto da Folha",
	"uf": "SE"
}, {
	"Nome": "Propriá",
	"uf": "SE"
}, {
	"Nome": "Riachão do Dantas",
	"uf": "SE"
}, {
	"Nome": "Riachuelo",
	"uf": "SE"
}, {
	"Nome": "Ribeirópolis",
	"uf": "SE"
}, {
	"Nome": "Rosário do Catete",
	"uf": "SE"
}, {
	"Nome": "Salgado",
	"uf": "SE"
}, {
	"Nome": "Santa Luzia do Itanhy",
	"uf": "SE"
}, {
	"Nome": "Santa Rosa de Lima",
	"uf": "SE"
}, {
	"Nome": "Santana do São Francisco",
	"uf": "SE"
}, {
	"Nome": "Santo Amaro das Brotas",
	"uf": "SE"
}, {
	"Nome": "São Cristóvão",
	"uf": "SE"
}, {
	"Nome": "São Domingos",
	"uf": "SE"
}, {
	"Nome": "São Francisco",
	"uf": "SE"
}, {
	"Nome": "São Miguel do Aleixo",
	"uf": "SE"
}, {
	"Nome": "Simão Dias",
	"uf": "SE"
}, {
	"Nome": "Siriri",
	"uf": "SE"
}, {
	"Nome": "Telha",
	"uf": "SE"
}, {
	"Nome": "Tobias Barreto",
	"uf": "SE"
}, {
	"Nome": "Tomar do Geru",
	"uf": "SE"
}, {
	"Nome": "Umbaúba",
	"uf": "SE"
}, {
	"Nome": "Abreulândia",
	"uf": "TO"
}, {
	"Nome": "Aguiarnópolis",
	"uf": "TO"
}, {
	"Nome": "Aliança do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Almas",
	"uf": "TO"
}, {
	"Nome": "Alvorada",
	"uf": "TO"
}, {
	"Nome": "Ananás",
	"uf": "TO"
}, {
	"Nome": "Angico",
	"uf": "TO"
}, {
	"Nome": "Aparecida do Rio Negro",
	"uf": "TO"
}, {
	"Nome": "Aragominas",
	"uf": "TO"
}, {
	"Nome": "Araguacema",
	"uf": "TO"
}, {
	"Nome": "Araguaçu",
	"uf": "TO"
}, {
	"Nome": "Araguaína",
	"uf": "TO"
}, {
	"Nome": "Araguanã",
	"uf": "TO"
}, {
	"Nome": "Araguatins",
	"uf": "TO"
}, {
	"Nome": "Arapoema",
	"uf": "TO"
}, {
	"Nome": "Arraias",
	"uf": "TO"
}, {
	"Nome": "Augustinópolis",
	"uf": "TO"
}, {
	"Nome": "Aurora do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Axixá do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Babaçulândia",
	"uf": "TO"
}, {
	"Nome": "Bandeirantes do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Barra do Ouro",
	"uf": "TO"
}, {
	"Nome": "Barrolândia",
	"uf": "TO"
}, {
	"Nome": "Bernardo Sayão",
	"uf": "TO"
}, {
	"Nome": "Bom Jesus do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Brasilândia do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Brejinho de Nazaré",
	"uf": "TO"
}, {
	"Nome": "Buriti do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Cachoeirinha",
	"uf": "TO"
}, {
	"Nome": "Campos Lindos",
	"uf": "TO"
}, {
	"Nome": "Cariri do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Carmolândia",
	"uf": "TO"
}, {
	"Nome": "Carrasco Bonito",
	"uf": "TO"
}, {
	"Nome": "Caseara",
	"uf": "TO"
}, {
	"Nome": "Centenário",
	"uf": "TO"
}, {
	"Nome": "Chapada da Natividade",
	"uf": "TO"
}, {
	"Nome": "Chapada de Areia",
	"uf": "TO"
}, {
	"Nome": "Colinas do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Colméia",
	"uf": "TO"
}, {
	"Nome": "Combinado",
	"uf": "TO"
}, {
	"Nome": "Conceição do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Couto de Magalhães",
	"uf": "TO"
}, {
	"Nome": "Cristalândia",
	"uf": "TO"
}, {
	"Nome": "Crixás do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Darcinópolis",
	"uf": "TO"
}, {
	"Nome": "Dianópolis",
	"uf": "TO"
}, {
	"Nome": "Divinópolis do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Dois Irmãos do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Dueré",
	"uf": "TO"
}, {
	"Nome": "Esperantina",
	"uf": "TO"
}, {
	"Nome": "Fátima",
	"uf": "TO"
}, {
	"Nome": "Figueirópolis",
	"uf": "TO"
}, {
	"Nome": "Filadélfia",
	"uf": "TO"
}, {
	"Nome": "Formoso do Araguaia",
	"uf": "TO"
}, {
	"Nome": "Fortaleza do Tabocão",
	"uf": "TO"
}, {
	"Nome": "Goianorte",
	"uf": "TO"
}, {
	"Nome": "Goiatins",
	"uf": "TO"
}, {
	"Nome": "Guaraí",
	"uf": "TO"
}, {
	"Nome": "Gurupi",
	"uf": "TO"
}, {
	"Nome": "Ipueiras",
	"uf": "TO"
}, {
	"Nome": "Itacajá",
	"uf": "TO"
}, {
	"Nome": "Itaguatins",
	"uf": "TO"
}, {
	"Nome": "Itapiratins",
	"uf": "TO"
}, {
	"Nome": "Itaporã do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Jaú do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Juarina",
	"uf": "TO"
}, {
	"Nome": "Lagoa da Confusão",
	"uf": "TO"
}, {
	"Nome": "Lagoa do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Lajeado",
	"uf": "TO"
}, {
	"Nome": "Lavandeira",
	"uf": "TO"
}, {
	"Nome": "Lizarda",
	"uf": "TO"
}, {
	"Nome": "Luzinópolis",
	"uf": "TO"
}, {
	"Nome": "Marianópolis do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Mateiros",
	"uf": "TO"
}, {
	"Nome": "Maurilândia do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Miracema do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Miranorte",
	"uf": "TO"
}, {
	"Nome": "Monte do Carmo",
	"uf": "TO"
}, {
	"Nome": "Monte Santo do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Muricilândia",
	"uf": "TO"
}, {
	"Nome": "Natividade",
	"uf": "TO"
}, {
	"Nome": "Nazaré",
	"uf": "TO"
}, {
	"Nome": "Nova Olinda",
	"uf": "TO"
}, {
	"Nome": "Nova Rosalândia",
	"uf": "TO"
}, {
	"Nome": "Novo Acordo",
	"uf": "TO"
}, {
	"Nome": "Novo Alegre",
	"uf": "TO"
}, {
	"Nome": "Novo Jardim",
	"uf": "TO"
}, {
	"Nome": "Oliveira de Fátima",
	"uf": "TO"
}, {
	"Nome": "Palmas",
	"uf": "TO"
}, {
	"Nome": "Palmeirante",
	"uf": "TO"
}, {
	"Nome": "Palmeiras do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Palmeirópolis",
	"uf": "TO"
}, {
	"Nome": "Paraíso do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Paranã",
	"uf": "TO"
}, {
	"Nome": "Pau d`Arco",
	"uf": "TO"
}, {
	"Nome": "Pedro Afonso",
	"uf": "TO"
}, {
	"Nome": "Peixe",
	"uf": "TO"
}, {
	"Nome": "Pequizeiro",
	"uf": "TO"
}, {
	"Nome": "Pindorama do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Piraquê",
	"uf": "TO"
}, {
	"Nome": "Pium",
	"uf": "TO"
}, {
	"Nome": "Ponte Alta do Bom Jesus",
	"uf": "TO"
}, {
	"Nome": "Ponte Alta do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Porto Alegre do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Porto Nacional",
	"uf": "TO"
}, {
	"Nome": "Praia Norte",
	"uf": "TO"
}, {
	"Nome": "Presidente Kennedy",
	"uf": "TO"
}, {
	"Nome": "Pugmil",
	"uf": "TO"
}, {
	"Nome": "Recursolândia",
	"uf": "TO"
}, {
	"Nome": "Riachinho",
	"uf": "TO"
}, {
	"Nome": "Rio da Conceição",
	"uf": "TO"
}, {
	"Nome": "Rio dos Bois",
	"uf": "TO"
}, {
	"Nome": "Rio Sono",
	"uf": "TO"
}, {
	"Nome": "Sampaio",
	"uf": "TO"
}, {
	"Nome": "Sandolândia",
	"uf": "TO"
}, {
	"Nome": "Santa Fé do Araguaia",
	"uf": "TO"
}, {
	"Nome": "Santa Maria do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Santa Rita do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Santa Rosa do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Santa Tereza do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Santa Terezinha do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Bento do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Félix do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Miguel do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Salvador do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Sebastião do Tocantins",
	"uf": "TO"
}, {
	"Nome": "São Valério da Natividade",
	"uf": "TO"
}, {
	"Nome": "Silvanópolis",
	"uf": "TO"
}, {
	"Nome": "Sítio Novo do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Sucupira",
	"uf": "TO"
}, {
	"Nome": "Taguatinga",
	"uf": "TO"
}, {
	"Nome": "Taipas do Tocantins",
	"uf": "TO"
}, {
	"Nome": "Talismã",
	"uf": "TO"
}, {
	"Nome": "Tocantínia",
	"uf": "TO"
}, {
	"Nome": "Tocantinópolis",
	"uf": "TO"
}, {
	"Nome": "Tupirama",
	"uf": "TO"
}, {
	"Nome": "Tupiratins",
	"uf": "TO"
}, {
	"Nome": "Wanderlândia",
	"uf": "TO"
}, {
	"Nome": "Xambioá",
	"uf": "TO"
}];

export default objCidades;